(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification-popup"]) return;
  try {
    
  const button = document.getElementById('age-validator-fail');
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const errorContainer = document.getElementById('age-error-container');
    errorContainer.classList.remove('hidden');
  });
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalComponentAgePopup extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const initPopupBehavior = () => {
        const storageKey = self.dataset.storageKey;
        const storageValue = self.dataset.storageValue || null;
        if (storageKey && localStorage.getItem(storageKey) === storageValue) {
          self.remove();
          return;
        }
        if (!window.location.href.includes('challenge') || !self.classList.contains('modal--active')) {
          if (self.dataset.trigger === 'self') {
            self.open();
            return;
          }
          self.onScroll = showOnScroll.bind(self);
          self.delay = parseInt(self.dataset.delay || '0', 10);
          window.addEventListener('scroll', self.onScroll);
        }
      };
      const showOnScroll = () => {
        if (window.scrollY > self.delay) {
          window.removeEventListener('scroll', self.onScroll);
          self.open();
        }
      };
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
      initPopupBehavior();
    }
  }
  if (!customElements.get('modal-age-component-popup'))
    customElements.define('modal-age-component-popup', ModalComponentAgePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // <scroll-component> (the marquee custom element) is defined once, globally,
  // in assets/scroll-component.js — see that file for the implementation.

  /* ── Announcement-bar section entrance ───────────────────────────────
     Matches logo-list.liquid's section entrance fade — the marquee track
     itself previously had no reveal at all, appearing instantly while every
     other section on the page fades/reveals in. Fades the <scroll-component>
     wrapper rather than the inner .scroll-component track so this never
     fights the track's own CSS marquee animation (which lives on that inner
     element via --marquee-animation-name). */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playAnnouncementBarReveal(section) {
      var _M = window.themeMotion || {};
      var track = section.querySelector('scroll-component');
      if (!track) return;

      gsap.set(track, { opacity: 0, y: 28 });
      gsap.to(track, {
        opacity: 1, y: 0,
        duration: (_M.dur && _M.dur.slow) || 1.0,
        ease: (_M.ease && _M.ease.enter) || 'power4.out',
        overwrite: 'auto'
      });
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initAnnouncementBarReveal(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'announcement-bar-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it, so it could refresh and lock in a stale start/end before
        // that sibling pinned section finishes resolving its own pin-spacer
        // height on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playAnnouncementBarReveal(section); },
        onEnterBack: function () { playAnnouncementBarReveal(section); }
      });
    }

    document.querySelectorAll('.announcement-bar').forEach(initAnnouncementBarReveal);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('announcement-bar') ? root : root.querySelector('.announcement-bar'));
      if (s) { initAnnouncementBarReveal(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class BannerCarousel extends HTMLElement {
    connectedCallback() {
      const section = this;
      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      if (slides.length === 0) return;

      const viewport = section.querySelector('[data-viewport]');
      const prevBtns = Array.from(section.querySelectorAll('[data-prev-button]'));
      const nextBtns = Array.from(section.querySelectorAll('[data-next-button]'));
      const headerHeading = section.querySelector('[data-header-heading]');
      const headerLink = section.querySelector('[data-header-link]');
      const headerLinkText = section.querySelector('[data-header-link-text]');

      let currentIndex = 0;
      let isAnimating = false;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let autoplayTimer = null;
      let activeVideoListeners = [];

      const clearAutoplayTimer = () => {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
        activeVideoListeners.forEach(({ video, listener }) => {
          video.removeEventListener('ended', listener);
        });
        activeVideoListeners = [];
      };

      const pauseAllVideos = () => {
        slides.forEach((slide) => {
          const videos = slide.querySelectorAll('video');
          videos.forEach((v) => {
            v.pause();
            try {
              v.currentTime = 0;
            } catch (e) {}
          });
        });
      };

      const updateHeader = (targetSlide, targetIndex) => {
        if (!targetSlide) return;
        const headingText = targetSlide.dataset.heading || '';
        const btnLabel = targetSlide.dataset.buttonLabel || '';
        const btnUrl = targetSlide.dataset.buttonUrl || '#';
        const btnTarget = targetSlide.dataset.buttonTarget === 'true';
        const colorScheme = targetSlide.dataset.colorScheme;

        if (headerHeading) {
          headerHeading.textContent = headingText;
        }
        if (headerLinkText) {
          headerLinkText.textContent = btnLabel;
        }
        if (headerLink) {
          headerLink.setAttribute('href', btnUrl);
          if (btnTarget) {
            headerLink.setAttribute('target', '_blank');
          } else {
            headerLink.removeAttribute('target');
          }
        }

        const middleControls = section.querySelector('[data-middle-controls]');
        if (middleControls && colorScheme) {
          Array.from(middleControls.classList).forEach((cls) => {
            if (cls.startsWith('scheme--')) {
              middleControls.classList.remove(cls);
            }
          });
          middleControls.classList.add(`scheme--${colorScheme}`);
        }

        const nextArrowTitles = section.querySelectorAll('[data-next-arrow-title]');
        if (nextArrowTitles.length > 0 && slides.length > 0) {
          const idx = targetIndex !== undefined ? targetIndex : currentIndex;
          if (slides[idx]) {
            const taglineText = slides[idx].dataset.arrowTagline || '';
            nextArrowTitles.forEach((el) => {
              el.textContent = taglineText;
            });
          }
        }
      };

      const prepareSlideContent = (slide) => {
        const animItems = Array.from(slide.querySelectorAll('[data-animate-item]'));
        const propHand   = slide.querySelector('[data-prop="hand"]');
        const propTowel  = slide.querySelector('[data-prop="towel"]');
        const propBottle = slide.querySelector('[data-prop="bottle"]');
        const propFoam   = slide.querySelector('[data-prop="foam"]');
        const backdropText = slide.querySelector('.slide-card_backdrop-text');
        if (window.gsap) {
          if (animItems.length > 0) window.gsap.set(animItems, { autoAlpha: 0, y: 20 });
          if (backdropText) {
            const isMob = window.innerWidth < 768;
            const yPct = isMob ? 0 : -50;
            window.gsap.set(backdropText, { scale: 1.55, opacity: 0, xPercent: -50, yPercent: yPct });
          }
          if (propHand) window.gsap.set(propHand, { x: -600, opacity: 0 });
          if (propTowel) {
            window.gsap.killTweensOf(propTowel);
            window.gsap.set(propTowel, { yPercent: -50, y: -110, opacity: 0 });
          }
          if (propBottle) window.gsap.set(propBottle, { y: 180, opacity: 0 });
          if (propFoam) window.gsap.set(propFoam, { y: 180, opacity: 0 });
        }
      };

      const animateSlideContent = (slide, show) => {
        const animItems = Array.from(slide.querySelectorAll('[data-animate-item]'));
        const propHand   = slide.querySelector('[data-prop="hand"]');
        const propTowel  = slide.querySelector('[data-prop="towel"]');
        const propBottle = slide.querySelector('[data-prop="bottle"]');
        const propFoam   = slide.querySelector('[data-prop="foam"]');
        const backdropText = slide.querySelector('.slide-card_backdrop-text');
        const hasProps = propHand || propTowel || propBottle || propFoam || backdropText;
        if (animItems.length === 0 && !hasProps) return;

        if (window.gsap) {
          if (show) {
            if (animItems.length > 0) {
              window.gsap.fromTo(
                animItems,
                { autoAlpha: 0, y: 20 },
                { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out', stagger: 0.06, delay: 0.1, overwrite: 'auto' }
              );
            }
            if (backdropText) {
              const isMob = window.innerWidth < 768;
              const yPct = isMob ? 0 : -50;
              window.gsap.fromTo(backdropText,
                { scale: 1.55, opacity: 0, xPercent: -50, yPercent: yPct },
                { scale: 1, opacity: 1, xPercent: -50, yPercent: yPct, duration: 1.4, ease: 'expo.out', overwrite: 'auto' }
              );
            }
            if (propHand) {
              window.gsap.fromTo(propHand,
                { x: -600, opacity: 0 },
                { x: 0, opacity: 1, duration: 2.0, ease: 'circ.out', overwrite: 'auto' }
              );
            }
            if (propTowel) {
              window.gsap.killTweensOf(propTowel);
              window.gsap.fromTo(propTowel,
                { yPercent: -50, y: -110, opacity: 0 },
                {
                  yPercent: -50,
                  y: 0,
                  opacity: 1,
                  duration: 0.9,
                  ease: 'power3.out',
                  overwrite: 'auto',
                  onComplete: () => {
                    window.gsap.to(propTowel, { yPercent: -50, y: -16, duration: 2.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
                  }
                }
              );
            }
            if (propBottle) {
              window.gsap.fromTo(propBottle,
                { y: 180, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.1, overwrite: 'auto' }
              );
            }
            if (propFoam) {
              window.gsap.fromTo(propFoam,
                { y: 180, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.22, overwrite: 'auto' }
              );
            }
          } else {
            if (animItems.length > 0) {
              window.gsap.to(animItems, { autoAlpha: 0, y: -10, duration: 0.2, ease: 'power2.in', overwrite: 'auto' });
            }
            if (propTowel) window.gsap.killTweensOf(propTowel);
            [propHand, propTowel, propBottle, propFoam, backdropText].filter(Boolean).forEach((el) => {
              window.gsap.to(el, { opacity: 0, duration: 0.2, overwrite: 'auto' });
            });
          }
        }
      };

      const syncVideosAndAutoplay = (targetSlide) => {
        clearAutoplayTimer();

        const isAutoplay = section.dataset.autoplay === 'true';
        const interval = parseInt(section.dataset.interval, 10) || 5000;

        slides.forEach((slide) => {
          if (slide !== targetSlide) {
            const videos = slide.querySelectorAll('video');
            videos.forEach((v) => {
              v.pause();
              try {
                v.currentTime = 0;
              } catch (e) {}
            });
          }
        });

        const activeVideos = Array.from(targetSlide.querySelectorAll('video'));

        if (activeVideos.length > 0) {
          let videoEndedTriggered = false;
          activeVideos.forEach((video) => {
            if (slides.length > 1 && isAutoplay) {
              video.loop = false;
              video.removeAttribute('loop');

              const onEnded = () => {
                if (!videoEndedTriggered) {
                  videoEndedTriggered = true;
                  handleNext();
                }
              };
              video.addEventListener('ended', onEnded, { once: true });
              activeVideoListeners.push({ video, listener: onEnded });
            }

            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                if (isAutoplay && slides.length > 1 && !videoEndedTriggered) {
                  autoplayTimer = setTimeout(() => {
                    if (!videoEndedTriggered) {
                      videoEndedTriggered = true;
                      handleNext();
                    }
                  }, interval);
                }
              });
            }
          });
        } else if (isAutoplay && slides.length > 1) {
          autoplayTimer = setTimeout(() => {
            handleNext();
          }, interval);
        }
      };

      const goToSlide = (targetIndex) => {
        if (targetIndex === currentIndex || isAnimating) return;
        if (targetIndex < 0) targetIndex = slides.length - 1;
        if (targetIndex >= slides.length) targetIndex = 0;

        const currentSlide = slides[currentIndex];
        const targetSlide = slides[targetIndex];
        if (!targetSlide) return;

        isAnimating = true;
        syncVideosAndAutoplay(targetSlide);

        if (window.gsap) {
          const numStrips = 8;

          const getVisibleBg = (slide) => {
            const isDesktop = window.innerWidth >= 768;
            let bg = isDesktop
              ? slide.querySelector('[data-bg="desktop"]')
              : slide.querySelector('[data-bg="mobile"]');
            if (!bg) bg = slide.querySelector('[data-bg]');
            return bg;
          };

          const targetBg = getVisibleBg(targetSlide);

          const buildSlices = (bgWrapper) => {
            if (!bgWrapper || !viewport) return null;
            const overlay = document.createElement('div');
            overlay.className = 'banner-carousel_slice-overlay';
            const strips = [];
            const stripPercent = 100 / numStrips;
            for (let i = 0; i < numStrips; i++) {
              const strip = document.createElement('div');
              strip.className = 'banner-carousel_slice-strip';
              strip.style.top = `${i * stripPercent}%`;
              strip.style.height = `calc(${stripPercent}% + 1.5px)`;

              const inner = bgWrapper.cloneNode(true);
              inner.classList.add('banner-carousel_slice-inner');
              inner.style.top = `-${i * 100}%`;
              inner.style.height = `${numStrips * 100}%`;
              inner.style.position = 'absolute';
              inner.style.left = '0';
              inner.style.width = '100%';

              const origVideos = bgWrapper.querySelectorAll('video');
              const cloneVideos = inner.querySelectorAll('video');
              origVideos.forEach((v, idx) => {
                if (cloneVideos[idx]) {
                  try {
                    cloneVideos[idx].currentTime = v.currentTime;
                    cloneVideos[idx].play().catch(() => {});
                  } catch (e) {}
                }
              });

              strip.appendChild(inner);
              overlay.appendChild(strip);
              strips.push(strip);
            }
            viewport.appendChild(overlay);
            return { overlay, strips };
          };

          const incomingSlices = buildSlices(targetBg);

          if (targetBg) targetBg.style.opacity = '0';
          prepareSlideContent(targetSlide);
          targetSlide.classList.add('is-active');

          animateSlideContent(currentSlide, false);

          const tl = window.gsap.timeline({
            onComplete: () => {
              currentSlide.classList.remove('is-active');
              if (targetBg) targetBg.style.opacity = '';
              if (incomingSlices) incomingSlices.overlay.remove();
              currentIndex = targetIndex;
              isAnimating = false;
            }
          });

          if (incomingSlices) {
            incomingSlices.strips.forEach((strip, i) => {
              const direction = i % 2 === 0 ? -1 : 1;
              const xOffset = direction * 100;
              window.gsap.set(strip, {
                xPercent: xOffset,
                opacity: 0
              });
              tl.to(
                strip,
                {
                  xPercent: 0,
                  opacity: 1,
                  duration: 0.55,
                  ease: 'power3.out'
                },
                i * 0.035
              );
            });
          }

          animateSlideContent(targetSlide, true);
        } else {
          slides.forEach((s) => s.classList.remove('is-active'));
          targetSlide.classList.add('is-active');
          currentIndex = targetIndex;
          isAnimating = false;
        }

        updateHeader(targetSlide, targetIndex);
      };

      const handlePrev = () => goToSlide(currentIndex - 1);
      const handleNext = () => goToSlide(currentIndex + 1);

      prevBtns.forEach((btn) => btn.addEventListener('click', handlePrev));
      nextBtns.forEach((btn) => btn.addEventListener('click', handleNext));

      const handleDragStart = (e) => {
        if (slides.length <= 1) return;
        isDragging = true;
        startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        currentX = startX;
      };

      const handleDragMove = (e) => {
        if (!isDragging || slides.length <= 1) return;
        currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      };

      const handleDragEnd = () => {
        if (!isDragging || slides.length <= 1) return;
        isDragging = false;
        const diffX = currentX - startX;
        const threshold = 40;
        if (diffX < -threshold) {
          handleNext();
        } else if (diffX > threshold) {
          handlePrev();
        }
      };

      if (viewport && slides.length > 1) {
        viewport.addEventListener('mousedown', handleDragStart);
        viewport.addEventListener('mousemove', handleDragMove);
        window.addEventListener('mouseup', handleDragEnd);

        viewport.addEventListener('touchstart', handleDragStart, { passive: true });
        viewport.addEventListener('touchmove', handleDragMove, { passive: true });
        viewport.addEventListener('touchend', handleDragEnd);
      }

      if (window.Shopify && window.Shopify.designMode) {
        const handleShopifySelect = (event) => {
          const targetBlockIndex = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (targetBlockIndex !== -1) {
            goToSlide(targetBlockIndex);
          }
        };
        section.addEventListener('shopify:block:select', handleShopifySelect);
        const shopifyCleanup = () => section.removeEventListener('shopify:block:select', handleShopifySelect);
        this.shopifyCleanup = shopifyCleanup;
      }

      updateHeader(slides[currentIndex], currentIndex);
      syncVideosAndAutoplay(slides[currentIndex]);

      const cleanup = () => {
        clearAutoplayTimer();
        pauseAllVideos();
        prevBtns.forEach((btn) => btn.removeEventListener('click', handlePrev));
        nextBtns.forEach((btn) => btn.removeEventListener('click', handleNext));
        if (viewport) {
          viewport.removeEventListener('mousedown', handleDragStart);
          viewport.removeEventListener('mousemove', handleDragMove);
          window.removeEventListener('mouseup', handleDragEnd);
          viewport.removeEventListener('touchstart', handleDragStart);
          viewport.removeEventListener('touchmove', handleDragMove);
          viewport.removeEventListener('touchend', handleDragEnd);
        }
        if (this.shopifyCleanup) this.shopifyCleanup();
      };

      this.cleanup = cleanup;
    }

    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
    }
  }

  if (!customElements.get('banner-carousel')) {
    customElements.define('banner-carousel', BannerCarousel);
  }

  /* ── Banner carousel entrance reveal (scroll-triggered, replays on every re-entry) ─── */
  window.onThemeGsapReady(function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playBannerCarouselReveal(section) {
      var _M = window.themeMotion || {};
      var flags = _M.flags || {};
      var viewport = section.querySelector('.banner-carousel_viewport');
      var activeSlide = section.querySelector('.js-slide.is-active') || section.querySelector('.js-slide');
      var topBarLogo = section.querySelector('.banner-carousel_top-bar-logo');
      var topBarText = section.querySelector('.banner-carousel_top-bar-text');
      var logo = activeSlide && activeSlide.querySelector('.slide-card_logo-wrapper');
      var tagline = activeSlide && activeSlide.querySelector('.slide-card_tagline-wrapper');
      var heading = activeSlide && activeSlide.querySelector('.slide-card_heading');
      var desc = activeSlide && activeSlide.querySelector('.slide-card_description');
      var ctaWrap = activeSlide && activeSlide.querySelector('.slide-card_button-wrapper');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      if (topBarLogo) {
        gsap.set(topBarLogo, { opacity: 0, y: -16 });
        tl.to(topBarLogo, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.1);
      }
      if (topBarText) {
        gsap.set(topBarText, { opacity: 0, y: -16 });
        tl.to(topBarText, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.1);
      }

      if (logo) {
        gsap.set(logo, { opacity: 0, y: 24 });
        tl.to(logo, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.3);
      }

      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 22 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.38);
      }

      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, { duration: split.duration, ease: split.ease, stagger: split.stagger }), 0.5);
        } else {
          gsap.set(heading, { opacity: 0, y: 30 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.5);
        }
      }

      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, { duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger }), 0.65);
        } else {
          gsap.set(desc, { opacity: 0, y: 24 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.65);
        }
      }

      if (ctaWrap) {
        gsap.set(ctaWrap, { opacity: 0, scale: 0.88 });
        tl.to(ctaWrap, {
          opacity: 1, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.spring) || 'elastic.out(1,0.5)',
          clearProps: 'scale'
        }, 0.8);
      }

      var backdropText = activeSlide && activeSlide.querySelector('.slide-card_backdrop-text');
      var propHand   = activeSlide && activeSlide.querySelector('[data-prop="hand"]');
      var propTowel  = activeSlide && activeSlide.querySelector('[data-prop="towel"]');
      var propBottle = activeSlide && activeSlide.querySelector('[data-prop="bottle"]');
      var propFoam   = activeSlide && activeSlide.querySelector('[data-prop="foam"]');

      if (backdropText) {
        var isMob = window.innerWidth < 768;
        var yPct = isMob ? 0 : -50;
        gsap.set(backdropText, { scale: 1.55, opacity: 0, xPercent: -50, yPercent: yPct });
        tl.to(backdropText, { scale: 1, opacity: 1, xPercent: -50, yPercent: yPct, duration: 1.5, ease: 'expo.out', overwrite: 'auto' }, 0);
      }
      if (propHand) {
        gsap.set(propHand, { x: -600, opacity: 0 });
        tl.to(propHand, { x: 0, opacity: 1, duration: 2.0, ease: 'circ.out', overwrite: 'auto' }, 0.15);
      }
      if (propTowel) {
        gsap.killTweensOf(propTowel);
        gsap.set(propTowel, { yPercent: -50, y: -110, opacity: 0 });
        tl.to(propTowel, {
          yPercent: -50,
          y: 0, opacity: 1, duration: 1.0, ease: 'power3.out', overwrite: 'auto',
          onComplete: function () {
            gsap.to(propTowel, { yPercent: -50, y: -16, duration: 2.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
          }
        }, 0.3);
      }
      if (propBottle) {
        gsap.set(propBottle, { y: 200, opacity: 0 });
        tl.to(propBottle, { y: 0, opacity: 1, duration: 1.0, ease: 'power3.out', overwrite: 'auto' }, 0.45);
      }
      if (propFoam) {
        gsap.set(propFoam, { y: 200, opacity: 0 });
        tl.to(propFoam, { y: 0, opacity: 1, duration: 1.0, ease: 'power3.out', overwrite: 'auto' }, 0.58);
      }
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initBannerCarouselReveal(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'banner-carousel-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative priority above it, so it
        // could refresh and lock in a stale start/end before that sibling
        // pinned section finishes resolving its own pin-spacer height on
        // the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playBannerCarouselReveal(section); },
        onEnterBack: function () { playBannerCarouselReveal(section); }
      });
    }

    document.querySelectorAll('.banner-carousel').forEach(initBannerCarouselReveal);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('banner-carousel') ? root : root.querySelector('.banner-carousel'));
      if (s) { initBannerCarouselReveal(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-content"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this._cleanupTimer) {
        clearTimeout(this._cleanupTimer);
        this._cleanupTimer = null;
      }
      // GSAP's pin wraps this element in a .pin-spacer, which reparents it and
      // re-fires connectedCallback synchronously (before this.st is assigned
      // below), so guard with a flag set before the pin can ever be created.
      if (this._initialized) return;
      const init = () => {
        if (this._initialized) return;
        this._initialized = true;
        window.gsap.registerPlugin(window.ScrollTrigger);
        /* Exposed so shopify:section:reorder (below) can force a real re-init —
           dragging sections in the customizer moves this element's DOM node
           without ever calling disconnectedCallback/connectedCallback, so
           nothing else would pick up its new position. */
        this._init = init;
        // Always sweep the full comparison range — fully "before" at rest,
        // fully "after" once the pin's scroll distance is exhausted —
        // regardless of any static/no-JS placement rendered by Liquid.
        const FULL_SWEEP = 100;

        // ── Main divider spring ───────────────────────────────────────────
        // --after-placement goes 100 → 0 as scroll progresses, sweeping the
        // vertical before/after boundary all the way from right to left.
        let springTarget   = FULL_SWEEP;
        let springCurrent  = FULL_SWEEP;
        let springVelocity = 0;
        const STIFFNESS = 0.13;  // how fast it chases the target
        const DAMPING   = 0.72;  // < 1 = underdamped = bouncy

        // ── Bow spring (clip-path jelly deformation) ──────────────────────
        // Drives the quadratic bezier control point of the SVG <clipPath>.
        // Bow is expressed as % of element width (matches springCurrent scale).
        // Positive bow = control point right of the endpoints = boundary bulges
        // right (line lags behind at the middle when sweeping right, and vice versa).
        let bowCurrent  = 0;
        let bowVelocity = 0;
        const BOW_STIFFNESS = 0.14;  // faster reaction → hits peak while velocity is still high
        const BOW_DAMPING   = 0.52;  // heavily underdamped → visible oscillation
        // Skipped entirely below 768px (see this._lightMode, set by the
        // matchMedia block below) — phones are the most power/thermal-
        // constrained context for a per-frame two-integration spring plus
        // two bezier-string setAttribute() calls every tick.
        this._lightMode = false;

        // Cache both path elements (queried once, updated every frame)
        this._clipPath = this.querySelector('.bf-clip_path');
        this._archPath = this.querySelector('.bf-arch_path');

        // ── Real drag support (Awwwards roadmap Phase 3 signature scene) ──
        // The handle used to be `pointer-events: none` — a grab affordance
        // that did nothing when touched. This wires an actual drag that
        // feeds the SAME springTarget the scroll-scrub drives below, so
        // dragging inherits the exact spring/bow physics for free instead of
        // running a second, competing motion system. Dragging just overrides
        // springTarget; the next scroll onUpdate hands control back to
        // scroll position — the position otherwise stays where it's dropped,
        // matching how a standard before/after slider handle is expected to
        // behave.
        let dragEnabled = true;
        let isDragging = false;
        const pointerIcon = this.querySelector('.bf-wrapper_point-icn');
        const pointerHandle = this.querySelector('.bf-wrapper_point');
        const setTargetFromClientX = (clientX) => {
          const rect = this.getBoundingClientRect();
          if (!rect.width) return;
          const pct = ((clientX - rect.left) / rect.width) * 100;
          springTarget = Math.max(0, Math.min(FULL_SWEEP, pct));
          if (pointerHandle) pointerHandle.setAttribute('aria-valuenow', Math.round(springTarget));
        };

        // Keyboard equivalent of the pointer drag above (WCAG 2.1.1) — the
        // handle is a role="slider" with tabindex="0" (see snippets/before-after.liquid),
        // so Left/Right (and Home/End) move the comparison boundary the same
        // way dragging does, and aria-valuenow is kept in sync for screen readers.
        if (pointerHandle && !pointerHandle.dataset.keyboardBound) {
          pointerHandle.dataset.keyboardBound = 'true';
          pointerHandle.addEventListener('keydown', (e) => {
            if (!dragEnabled) return;
            let next = null;
            if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
              next = Math.max(0, springTarget - 5);
            } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
              next = Math.min(FULL_SWEEP, springTarget + 5);
            } else if (e.key === 'Home') {
              next = 0;
            } else if (e.key === 'End') {
              next = FULL_SWEEP;
            } else {
              return;
            }
            e.preventDefault();
            springTarget = next;
            pointerHandle.setAttribute('aria-valuenow', Math.round(next));
          });
        }
        if (pointerIcon && !pointerIcon.dataset.pointerBound) {
          pointerIcon.dataset.pointerBound = 'true';
          pointerIcon.addEventListener('pointerdown', (e) => {
            if (!dragEnabled) return;
            isDragging = true;
            pointerIcon.classList.add('is-dragging');
            pointerIcon.setPointerCapture(e.pointerId);
            setTargetFromClientX(e.clientX);
            e.preventDefault();
          });
          pointerIcon.addEventListener('pointermove', (e) => {
            if (!isDragging) return;
            setTargetFromClientX(e.clientX);
          });
          const endDrag = (e) => {
            if (!isDragging) return;
            isDragging = false;
            pointerIcon.classList.remove('is-dragging');
            if (pointerIcon.hasPointerCapture && pointerIcon.hasPointerCapture(e.pointerId)) {
              pointerIcon.releasePointerCapture(e.pointerId);
            }
          };
          pointerIcon.addEventListener('pointerup', endDrag);
          pointerIcon.addEventListener('pointercancel', endDrag);
        }

        // ScrollTrigger owns the pin and drives springTarget via onUpdate
        // Defer pin creation by one microtask so that any pinned sections
        // above this one (e.g. showcase-hotspot, collection-list) have already
        // injected their pin-spacers into the DOM before we measure this
        // element's document position for refreshPriority. Without this delay,
        // getBoundingClientRect().top is measured against a layout that hasn't
        // yet accounted for those spacers, so the priority is computed too low
        // and this section's ScrollTrigger refreshes before the ones above it
        // settle — causing the pin to start/end at the wrong scroll position.
        window.gsap.delayedCall(0, () => {
        this.st = window.ScrollTrigger.create({
          trigger: this,
          // Exclude the sticky header's height so its fixed overlay doesn't
          // cover the top of this section once pinned.
          start: () => `top top+=${window.getStickyHeaderOffset ? window.getStickyHeaderOffset() : 0}`,
          end: '+=100%',
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          /* Priority for ScrollTrigger.refresh() ordering among pinned sections,
             derived from this element's live document position instead of a fixed
             number — merchants can reorder sections in the customizer, so a
             hardcoded priority goes stale the moment the order changes. Higher-up
             elements get a higher (less negative) priority so their pin-spacers
             resolve first, matching whatever order is currently on the page. */
          refreshPriority: window.themeScrollPriority ? window.themeScrollPriority(this) : -(this.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0)),
          onUpdate: (self) => {
            // While a drag is in progress, scroll hands control to the drag
            // instead of overwriting springTarget out from under the user's
            // pointer (this fires from the pin's own internal scroll too).
            if (isDragging) return;
            // progress 0 → placement 100 (fully before), progress 1 → placement 0 (fully after)
            springTarget = FULL_SWEEP - self.progress * FULL_SWEEP;
          },
        });
        // The matchMedia callback above fires synchronously before this
        // delayedCall resolves, so this.st was still undefined when it ran.
        // Re-apply the current mobile/reduced-motion state now that this.st exists.
        if (this._lightMode || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
          this.st.disable();
        }
        }); // end gsap.delayedCall — ensures pin-spacers from sections above
            // are already in the DOM when refreshPriority is measured.

        // Spring ticker — runs every frame
        this._ticker = () => {
          // ── Position spring ──
          const force = (springTarget - springCurrent) * STIFFNESS;
          springVelocity = (springVelocity + force) * DAMPING;
          springCurrent += springVelocity;
          const clamped = Math.max(-1.5, Math.min(101.5, springCurrent));
          this.style.setProperty('--after-placement', clamped + '%');

          if (this._lightMode) {
            // Simplified mobile path: skip the bow spring's two-integration
            // math and the curved bezier entirely — straight vertical
            // boundary only.
            const pFlat = clamped / 100;
            if (this._clipPath) {
              this._clipPath.setAttribute('d', `M 1,0 L ${pFlat.toFixed(4)},0 L ${pFlat.toFixed(4)},1 L 1,1 Z`);
            }
            if (this._archPath) {
              this._archPath.setAttribute('d', `M ${clamped.toFixed(3)},0 L ${clamped.toFixed(3)},100`);
            }
            this.style.setProperty('--arch-peak', clamped.toFixed(3) + '%');
            this.style.setProperty('--arch-tilt', '0deg');
            return;
          }

          // ── Bow spring → clip-path jelly bulge ──
          // Sweeping RIGHT (springVelocity > 0): bowTarget < 0 → control point left
          //   → top/bottom reveal first, middle lags → bulge trails to the left
          // Sweeping LEFT  (springVelocity < 0): bowTarget > 0 → inverted bulge
          // Scale 20: velocity ~2 → bowTarget 40% → spring peaks ~20% → visible bulge ~10% of width
          const bowTarget = -springVelocity * 20;
          const bowForce  = (bowTarget - bowCurrent) * BOW_STIFFNESS;
          bowVelocity = (bowVelocity + bowForce) * BOW_DAMPING;
          bowCurrent += bowVelocity;

          // p and b shared by both the clip-path and the visible arch line
          const p = clamped / 100;       // objectBoundingBox (0-1)
          const b = bowCurrent / 100;    // bow as fraction of element width

          if (this._clipPath) {
            // Clip region = everything to the right of the curved boundary
            this._clipPath.setAttribute(
              'd',
              `M 1,0 L ${p.toFixed(4)},0 Q ${(p + b).toFixed(4)},0.5 ${p.toFixed(4)},1 L 1,1 Z`
            );
          }

          if (this._archPath) {
            // Same bezier in 0-100 viewBox coords — traces the exact clip boundary
            // clamped = p*100, bowCurrent = b*100
            this._archPath.setAttribute(
              'd',
              `M ${clamped.toFixed(3)},0 Q ${(clamped + bowCurrent).toFixed(3)},50 ${clamped.toFixed(3)},100`
            );
          }

          // Position handle at bulge peak (midpoint of bezier = p + 0.5*b)
          this.style.setProperty('--arch-peak', (clamped + bowCurrent * 0.5).toFixed(3) + '%');

          // Signature moment (Awwwards roadmap 4.4): tilt the handle with the
          // bulge instead of letting it stay upright while the line bends
          // underneath it — reads as riding the wave rather than sliding
          // along a track. bowCurrent already IS "how bowed the curve
          // currently is", so this rides the exact same physics the line
          // itself uses, no extra curve math. The 0.9 multiplier and sign are
          // a tuned aesthetic choice, not a strict tangent-angle derivation
          // (the real tangent at this curve's exact midpoint is degenerate —
          // always vertical, since the bezier's endpoints share an x — so an
          // analytically "correct" angle would show no tilt at all here).
          this.style.setProperty('--arch-tilt', (bowCurrent * 0.9).toFixed(2) + 'deg');
        };
        window.gsap.ticker.add(this._ticker);

        // Reduced-motion (kill springs, snap immediately) and the mobile-
        // lightweight variant, combined into one reactive matchMedia so both
        // respond live to viewport/OS-setting changes instead of only ever
        // being checked once at init.
        const initialPos = parseFloat(this.dataset.initialPosition || '50');
        this.mm = window.gsap.matchMedia();
        this.mm.add({
          reduceMotion: '(prefers-reduced-motion: reduce)',
          isMobile: '(max-width: 767px)'
        }, (context) => {
          const { reduceMotion, isMobile } = context.conditions;
          this._lightMode = isMobile;
          dragEnabled = !reduceMotion;

          // The scroll-scrubbed pin only earns its keep once there's real
          // viewport height to spend on it. On mobile, `end: '+=100%'` still
          // reserves a pin-spacer as tall as the section itself, which reads
          // as a dead scroll gap before/after the section with nothing
          // visibly changing. Disable the pin below the desktop breakpoint —
          // the same disable()/enable() pair already used for reduced-motion
          // below — and let the drag handle keep working as the mobile way
          // to compare, same as reduced-motion.
          if (isMobile) {
            if (this.st) this.st.disable();
            springTarget = initialPos;
            springCurrent = initialPos;
            const pFlat = initialPos / 100;
            this.style.setProperty('--after-placement', initialPos + '%');
            if (this._clipPath) {
              this._clipPath.setAttribute('d', `M 1,0 L ${pFlat.toFixed(4)},0 L ${pFlat.toFixed(4)},1 L 1,1 Z`);
            }
            if (this._archPath) {
              this._archPath.setAttribute('d', `M ${initialPos.toFixed(3)},0 L ${initialPos.toFixed(3)},100`);
            }
            this.style.setProperty('--arch-peak', initialPos.toFixed(3) + '%');
            this.style.setProperty('--arch-tilt', '0deg');
          } else if (!reduceMotion) {
            if (this.st) this.st.enable();
          }

          if (!reduceMotion) return;

          window.gsap.ticker.remove(this._ticker);
          if (this.st) this.st.disable();
          const pFlat = initialPos / 100;
          this.style.setProperty('--after-placement', initialPos + '%');
          if (this._clipPath) this._clipPath.setAttribute('d', `M 1,0 L ${pFlat.toFixed(4)},0 L ${pFlat.toFixed(4)},1 L 1,1 Z`);
          if (this._archPath) this._archPath.setAttribute('d', `M ${initialPos.toFixed(3)},0 L ${initialPos.toFixed(3)},100`);
          this.style.setProperty('--arch-peak', initialPos.toFixed(3) + '%');
          this.style.setProperty('--arch-tilt', '0deg');
          return () => {
            if (!isMobile && this.st) this.st.enable();
            window.gsap.ticker.add(this._ticker);
          };
        });
      };
      window.onThemeGsapReady(init);
    }
    disconnectedCallback() {
      // Defer teardown: if this disconnect is just GSAP's pin-spacer reparenting,
      // the element will already be reconnected by the time this timeout fires.
      this._cleanupTimer = setTimeout(() => {
        if (this.isConnected) return;
        this._initialized = false;
        if (this._ticker) {
          window.gsap && window.gsap.ticker.remove(this._ticker);
          this._ticker = null;
        }
        this._clipPath = null;
        this._archPath = null;
        if (this.st) {
          this.st.kill();
          this.st = null;
        }
        if (this.mm) {
          this.mm.revert();
          this.mm = null;
        }
      }, 0);
    }
  }
  if (!customElements.get('before-after')) customElements.define('before-after', BeforeAfter);

  /* Dragging sections in the customizer moves this element's DOM node without
     firing connectedCallback/disconnectedCallback, so the pin's refreshPriority
     (computed from document position at init time) would go stale. Tear down
     and force a real re-init so it's recomputed against the new order. */
  document.addEventListener('shopify:section:reorder', function() {
    document.querySelectorAll('before-after').forEach(function(el) {
      if (!el._initialized) return;
      if (el._ticker) {
        window.gsap && window.gsap.ticker.remove(el._ticker);
        el._ticker = null;
      }
      if (el.mm) {
        el.mm.revert();
        el.mm = null;
      }
      if (el.st) {
        el.st.kill();
        el.st = null;
      }
      el._initialized = false;
      if (typeof el._init === 'function') el._init();
    });
  });

  /* ── Before/after content entrance reveal ─────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playBeforeAfterContentReveal(section) {
      var _M = window.themeMotion || {};
      var wrapper = section.querySelector('.before-after_wrapper');
      if (!wrapper) return;

      var captions = wrapper.querySelectorAll('.bf_description');
      var pointer = wrapper.querySelector('.bf-wrapper_pointer');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      /* wrapper wipe reveal (images + pointer) */
      if (_M.flags ? _M.flags.clipReveals !== false : true) {
        gsap.set(wrapper, { clipPath: 'inset(0 0 100% 0)' });
        tl.to(wrapper, {
          clipPath: 'inset(0 0 0% 0)',
          duration: (_M.dur && _M.dur.xslow) || 1.4,
          ease: (_M.ease && _M.ease.reveal) || 'expo.out',
          clearProps: 'clipPath'
        }, 0);
      } else {
        gsap.set(wrapper, { opacity: 0, y: 40 });
        tl.to(wrapper, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out'
        }, 0);
      }

      /* before/after caption labels */
      if (captions.length) {
        var staggerEnabled = _M.flags ? _M.flags.staggerCards !== false : true;
        var captionTargets = [];
        var splitPreset = null;
        Array.prototype.forEach.call(captions, function (caption) {
          var split = window.themeSplitHeading && window.themeSplitHeading(caption);
          if (split && split.targets !== caption) {
            if (!splitPreset) splitPreset = split;
            captionTargets = captionTargets.concat(split.targets);
          } else {
            captionTargets.push(caption);
          }
        });
        if (splitPreset) {
          gsap.set(captionTargets, splitPreset.fromVars);
          tl.to(captionTargets, Object.assign({}, splitPreset.toVars, {
            duration: splitPreset.duration,
            ease: splitPreset.ease,
            stagger: staggerEnabled ? splitPreset.stagger : 0
          }), 0.45);
        } else {
          gsap.set(captionTargets, { opacity: 0, y: 16 });
          tl.to(captionTargets, {
            opacity: 1, y: 0,
            duration: (_M.dur && _M.dur.base) || 0.65,
            ease: (_M.ease && _M.ease.enter) || 'power3.out',
            stagger: staggerEnabled ? ((_M.stagger && _M.stagger.tight) || 0.08) : 0
          }, 0.45);
        }
      }

      /* drag handle pop-in */
      if (pointer) {
        gsap.set(pointer, { opacity: 0, scale: 0.85 });
        tl.to(pointer, {
          opacity: 1, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.spring) || 'elastic.out(1,0.5)',
          clearProps: 'scale'
        }, 0.65);
      }
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initBeforeAfterContentSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'before-after-content-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 75%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks every pinned section's negative priority above it (see
        // the pin's own refreshPriority below, and collection-list.liquid's
        // same pattern) — so it would refresh, and lock in its start/end,
        // before sections above it (e.g. showcase-hotspot's pin) finish
        // settling into their final height. onEnter/onEnterBack then never
        // fire if that stale range ends up behind the current scroll
        // position once the layout above corrects itself.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playBeforeAfterContentReveal(section); },
        onEnterBack: function () { playBeforeAfterContentReveal(section); }
      });
    }

    document.querySelectorAll('.before-after').forEach(initBeforeAfterContentSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('before-after') ? root : root.querySelector('.before-after'));
      if (s) { initBeforeAfterContentSection(s); }
    });

    /* Outright section removal: kill this instance's own reveal ScrollTrigger
       by id rather than relying only on ScrollTrigger's own detached-element
       cleanup on next refresh. Matches sections/showcase-hotspot.liquid's
       pattern. The pin/drag ScrollTrigger is a different case — it's owned
       and killed directly by the <before-after> custom element's own
       disconnectedCallback, which already fires on removal. */
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('before-after') ? root : root.querySelector('.before-after'));
      if (!s || !s.id || !ST) return;
      var triggerId = 'before-after-content-reveal-' + s.id;
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-products"] && !Shopify.designMode) return;
  try {
    
  /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
     from each trigger's live document position instead of a fixed number —
     merchants can reorder sections in the theme customizer, so a hardcoded
     priority goes stale the moment the order changes. Higher-up elements get a
     higher (less negative) priority so their pin-spacers resolve first, matching
     whatever order is currently on the page. See hero-banner/collection-list
     for the same pattern. */
  function bundleProductsScrollPriority(el) {
    return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
  }

  function initBundleProductsHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.bundle-product_heading-head');
    if (!headingHead) return;

    var idPrefix = 'bp-head-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.bundle-product_tagline-text');
    var heading = headingHead.querySelector('.bundle-product_heading');
    var description = headingHead.querySelector('.bundle-product_description');
    var ctaButton = headingHead.querySelector('.button');

    /* The split is left in place rather than reverted on complete since it
       needs to remain animatable for repeat entries — see the toggleActions
       note below. */
    var headingSplit = window.themeSplitHeading(heading);
    var descriptionSplit = window.themeSplitHeading(description);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descriptionSplit.targets || [],
      ctaButton || []
    );
    if (!headEls.length) return;

    /* Split pieces (words/chars) can vastly outnumber the plain 4-element
       group (tagline, heading, description, cta), so the stagger falls back
       to the split preset's tighter spacing once a split is actually active.
       toggleActions (rather than once:true) replays this reveal every time
       the heading scrolls back into view — initBundleProductsRows below
       uses the same toggleActions treatment so both stay in sync instead of
       drifting apart on scroll-back. */
    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.65),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix,
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: bundleProductsScrollPriority(headingHead)
      }
    }));
  }

  function initBundleProductsRows(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || reduceMotion || isMobile) return;
    if (ST) gsap.registerPlugin(ST);

    var rows = Array.prototype.slice.call(section.querySelectorAll('.product-bundle-row, [data-bundle-row]'));
    if (!rows.length) return;

    var footer = section.querySelector('.bundle-component_footer');
    var allTargets = footer ? rows.concat([footer]) : rows;

    var idPrefix = 'bp-rows-' + section.id;
    if (ST) {
      ST.getAll().forEach(function (t) {
        var id = t.vars && t.vars.id;
        if (id && id.indexOf(idPrefix) === 0) t.kill();
      });
    }

    var _M = window.themeMotion || {};
    var _useClip = (_M.flags ? _M.flags.clipReveals !== false : true);
    var _staggerStep = (_M.stagger && _M.stagger.loose) || 0.16;
    var _batchStart = (_M.trigger && _M.trigger.start) || 'top 82%';

    function hideRow(el) {
      if (el === footer) {
        gsap.set(el, { opacity: 0, y: 30 });
        return;
      }
      var img = el.querySelector('img, [class*="product-bundle-row_image"], svg');
      if (_useClip) {
        gsap.set(el, { clipPath: 'inset(0 100% 0 0)' });
        if (img) gsap.set(img, { scale: 1.1, transformOrigin: 'center center' });
      } else {
        gsap.set(el, { opacity: 0, y: 60 });
      }
    }

    allTargets.forEach(hideRow);

    if (ST) {
      var entranceBatch = ST.batch(allTargets, {
        interval: 0.1,
        start: _batchStart,
        refreshPriority: window.themeScrollPriority ? window.themeScrollPriority(section) : bundleProductsScrollPriority(section),
        onEnter: function (batch) {
          batch.forEach(function (el, bi) {
            var delay = bi * _staggerStep;
            if (el === footer) {
              gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: (_M.dur && _M.dur.base) || 0.65,
                ease: (_M.ease && _M.ease.enter) || 'power4.out',
                delay: delay,
                clearProps: 'opacity,transform',
                overwrite: 'auto'
              });
              return;
            }
            var img = el.querySelector('img, [class*="product-bundle-row_image"], svg');
            if (_useClip) {
              gsap.to(el, {
                clipPath: 'inset(0 0% 0 0)',
                duration: (_M.dur && _M.dur.slow) || 1.0,
                ease: (_M.ease && _M.ease.reveal) || 'expo.out',
                delay: delay,
                clearProps: 'clipPath',
                overwrite: 'auto'
              });
              if (img) {
                gsap.to(img, {
                  scale: 1,
                  duration: (_M.dur && _M.dur.xslow) || 1.4,
                  ease: 'power2.out',
                  delay: delay,
                  clearProps: 'scale,transform',
                  overwrite: 'auto'
                });
              }
            } else {
              gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: (_M.dur && _M.dur.slow) || 1.0,
                ease: (_M.ease && _M.ease.enter) || 'power4.out',
                delay: delay,
                clearProps: 'opacity,transform',
                overwrite: 'auto'
              });
            }
          });
        },
        onLeaveBack: function (batch) {
          batch.forEach(function (el) {
            hideRow(el);
          });
        }
      });

      entranceBatch.forEach(function (t, i) { t.vars.id = idPrefix + '-' + i; });

      if (document.fonts) {
        document.fonts.ready.then(function () {
          if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        });
      }
    } else {
      gsap.set(rows, { opacity: 0, y: 60 });
      gsap.to(rows, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', stagger: 0.12, clearProps: 'opacity,transform' });
      if (footer) {
        gsap.set(footer, { opacity: 0, y: 30 });
        gsap.to(footer, { opacity: 1, y: 0, duration: 0.65, ease: 'power2.out', delay: rows.length * 0.08, clearProps: 'opacity,transform' });
      }
    }
  }

  function initBundleProducts(section) {
    initBundleProductsHeading(section);
    initBundleProductsRows(section);
  }

  function initAllBundleProducts() {
    document.querySelectorAll('.bundle-product').forEach(initBundleProducts);
  }

  window.onThemeGsapReady(initAllBundleProducts);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('bundle-product')
      ? root
      : (root && root.querySelector ? root.querySelector('.bundle-product') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initBundleProducts(section); });
  });

  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem ? parentElem.querySelectorAll('[data-update-link]') : null;
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement) {
      const checkbox = parentElement.querySelector('[data-bundle-checkbox]');
      const isAvailable = currentVariant && currentVariant.available;
      if (!isAvailable) {
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = true;
          checkbox.setAttribute('disabled', 'disabled');
          checkbox.setAttribute('aria-disabled', 'true');
        }
        parentElement.classList.add('is-unchecked', 'is-soldout');
      } else {
        if (checkbox) {
          checkbox.disabled = false;
          checkbox.removeAttribute('disabled');
          checkbox.removeAttribute('aria-disabled');
          checkbox.checked = true;
        }
        parentElement.classList.remove('is-unchecked', 'is-soldout');
      }
      if (currentVariant) {
        parentElement.dataset.variantId = currentVariant.id;
        parentElement.dataset.variantPrice = currentVariant.price;
        if (currentVariant.requires_selling_plan !== undefined) {
          parentElement.dataset.requiresSellingPlan = currentVariant.requires_selling_plan ? 'true' : 'false';
        } else if (data.requires_selling_plan !== undefined) {
          parentElement.dataset.requiresSellingPlan = data.requires_selling_plan ? 'true' : 'false';
        }
        const rowErrElem = parentElement.querySelector('[data-product-bundle-error], .product-bundle-row_error');
        if (rowErrElem && parentElement.dataset.requiresSellingPlan !== 'true') {
          rowErrElem.classList.add('hidden');
          const errSpan = rowErrElem.querySelector('[data-error]');
          if (errSpan) errSpan.innerText = '';
        }
        const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
        if (selectedVariantLabel) {
          const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
          if (variantName) selectedVariantLabel.textContent = variantName;
        }
        const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
        if (customQtyInput) {
          if (currentVariant.price !== undefined) {
            customQtyInput.dataset.variantPrice = currentVariant.price;
          }
          if (typeof customQtyInput.resetQuantity === 'function') {
            customQtyInput.resetQuantity();
          } else {
            const inputField = customQtyInput.querySelector('input[type="number"]');
            if (inputField) {
              const minVal = inputField.min || 1;
              inputField.value = minVal;
              inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      }
      const bundleComponent = parentElement.closest('bundle-component');
      if (bundleComponent && typeof bundleComponent.updateTotals === 'function') {
        bundleComponent.updateTotals();
      }
    }
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    if (!forms) return;
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      if (input) input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-bundle-row, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    let parentElement = document.querySelector(parent);
    if (!parentElement && parent) {
      const idClean = parent.startsWith('#') ? parent.slice(1) : parent;
      parentElement = document.getElementById(idClean);
    }
    const card = parentElement ? (parentElement.closest('.product-bundle-row, .product-complementary-row, article') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
          const qtyInput = parentElement.querySelector('quantity-input, quantity-input-custom');
          if (qtyInput) {
            const sourceQtyInput = html.querySelector('quantity-input, quantity-input-custom');
            if (sourceQtyInput && sourceQtyInput.dataset.variantPrice) {
              qtyInput.dataset.variantPrice = sourceQtyInput.dataset.variantPrice;
            }
            const inputField = qtyInput.querySelector('input[type="number"]');
            if (inputField) {
              inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    let parentElem = document.querySelector(parent);
    if (!parentElem && parent) {
      const idClean = parent.startsWith('#') ? parent.slice(1) : parent;
      parentElem = document.getElementById(idClean);
    }
    if (!parentElem) return;
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };

  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const button = event.target.closest('button');
        if (!button) return;
        const previousValue = this.input.value;
        button.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const minVal = parseInt(this.input.min);
        const maxVal = parseInt(this.input.max);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        if (!btn) return;
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= minVal);
            btn.toggleAttribute('disabled', value <= minVal);
            break;
          case 'max':
            if (!isNaN(maxVal)) {
              btn.classList.toggle('disabled', value >= maxVal);
              btn.toggleAttribute('disabled', value >= maxVal);
            }
            break;
          default:
            break;
        }
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
      };

      const onBlur = () => {
        let value = parseInt(this.input.value);
        const minVal = parseInt(this.input.min) || 1;
        const maxVal = parseInt(this.input.max);
        if (isNaN(value) || value < minVal) {
          this.input.value = minVal;
          this.input.dispatchEvent(this.changeEvent);
        } else if (!isNaN(maxVal) && value > maxVal) {
          this.input.value = maxVal;
          this.input.dispatchEvent(this.changeEvent);
        }
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.blurChange = onBlur.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.input.addEventListener('change', this.inputChange);
        this.input.addEventListener('blur', this.blurChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  class QuantityInputCustom extends QuantityInput {
    constructor() {
      super();
    }

    resetQuantity() {
      if (!this.input) return;
      const minVal = parseInt(this.input.min) || 1;
      this.input.value = minVal;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input-custom')) {
    customElements.define('quantity-input-custom', QuantityInputCustom);
  }
  if (!customElements.get('variant-pill')) {
    class VariantPill extends HTMLElement {
      constructor() {
        super();
        this.variantChange = this.onInputChange.bind(this);
        this.addEventListener('change', this.variantChange);
        this.addEventListener('click', this.onClick.bind(this));
      }
      connectedCallback() {
        const parent = document.querySelector(this.dataset.parent);
        if (parent) {
          const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
          if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
        }
      }
      onClick(event) {
        const label = event.target.closest('label');
        if (label && label.htmlFor) {
          const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
          if (input) {
            if (!input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = input.value;
              }
              this.setVariantOptions(input.value);
            }
            return;
          }
        }
        const radio = event.target.closest('input[type="radio"]');
        if (radio) {
          const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = radio.value;
          }
          this.setVariantOptions(radio.value);
          return;
        }
        const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
        if (btn && btn.dataset.value) {
          const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = btn.dataset.value;
          }
          this.setVariantOptions(btn.dataset.value);
        }
      }
      onInputChange(event) {
        const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
          ? event.target
          : this.querySelector('input[type="radio"]:checked');
        if (!input) return;
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = input.value;
        }
        this.setVariantOptions(input.value);
      }
      setVariantOptions(value) {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        if (!parent) return;
        if (errElem) errElem.classList.add('hidden');

        const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
        const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
        if (selectedVariantLabel && value) {
          selectedVariantLabel.textContent = value;
        }
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;

        this.updateOptionsAvailability(parent, currentSet);

        let availableSet = null;
        if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find((set) => set.includes(val));
          };
          availableSet = checkSet(value);
        }

        onVariantChange(
          this.dataset.jsonSelector,
          availableSet ? availableSet : currentSet,
          this.dataset.forms,
          this.dataset.renders,
          this.dataset.mainParent,
          this.dataset.galleries,
          this.dataset.sectionId,
          this.dataset.productUrl,
          this.dataset.updateUrl,
          null,
          this.dataset.mediaTemplate === 'true',
          this.dataset.template
        );
      }

      updateOptionsAvailability(parentOrElems, set) {
        if (typeof VariantDropdown !== 'undefined' && VariantDropdown.prototype.updateOptionsAvailability) {
          VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
          return;
        }
        const json = document.querySelector(this.dataset.jsonSelector);
        if (!json) return;
        let data;
        try {
          data = JSON.parse(json.textContent);
        } catch (e) {
          return;
        }
        const variants = data && data.variants;
        if (!variants || !Array.isArray(variants)) return;

        const elems = parentOrElems instanceof HTMLElement
          ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
          : parentOrElems;

        elems.forEach((select) => {
          select.setAttribute('data-current-set', JSON.stringify(set));
          const optionIndex = parseInt(select.dataset.optionIndex);
          if (isNaN(optionIndex)) return;

          const isCheckSets = select.dataset.checkSets === 'true';
          const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
          if (dropdownItems.length > 0) {
            dropdownItems.forEach((item) => {
              const val = item.dataset.value;
              if (val === undefined) return;

              const isAvailable = variants.some((v) => {
                if (!v.available) return false;
                const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
                if (vVal !== val) return false;
                if (isCheckSets) return true;
                for (let k = 0; k < optionIndex; k++) {
                  const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                  if (prevVal !== set[k]) return false;
                }
                return true;
              });

              const statusText = item.querySelector('[data-variant-status-text]');
              if (isAvailable) {
                item.style.opacity = '1';
                item.classList.remove('disabled');
                if (statusText) statusText.classList.add('hidden');
              } else {
                item.style.opacity = '0.5';
                item.classList.add('disabled');
                if (statusText) statusText.classList.remove('hidden');
              }

              const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
              if (isActive) {
                const displayElem = select.querySelector('[data-current-value]');
                if (displayElem) {
                  if (!isAvailable && statusText) {
                    displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                  } else {
                    displayElem.textContent = item.dataset.text || val;
                  }
                }
                const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
                if (selectedValueSpan) {
                  if (!isAvailable && statusText) {
                    selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                  } else {
                    selectedValueSpan.textContent = item.dataset.text || val;
                  }
                }
              }
            });
          }

          const radioInputs = select.querySelectorAll('input[type="radio"]');
          if (radioInputs.length > 0) {
            radioInputs.forEach((input) => {
              const val = input.value || input.getAttribute('value');
              if (val === undefined) return;

              const isAvailable = variants.some((v) => {
                if (!v.available) return false;
                const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
                if (vVal !== val) return false;
                if (isCheckSets) return true;
                for (let k = 0; k < optionIndex; k++) {
                  const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                  if (prevVal !== set[k]) return false;
                }
                return true;
              });

              const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
              const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

              if (isAvailable) {
                input.classList.remove('disabled');
                if (labelText) {
                  labelText.classList.add('hidden');
                  labelText.classList.remove('visually-hidden');
                }
              } else {
                input.classList.add('disabled');
                if (labelText) {
                  labelText.classList.remove('hidden');
                  labelText.classList.add('visually-hidden');
                }
              }

              if (input.checked || val === set[optionIndex]) {
                const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
                if (selectedValueSpan) {
                  selectedValueSpan.textContent = val;
                }
              }
            });
          }
        });
      }
    }
    customElements.define('variant-pill', VariantPill);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-with-content"] && !Shopify.designMode) return;
  try {
    
  class TabsetComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tablistNode = this;
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
      const animationFrames = (() => {
        try { return JSON.parse(this.dataset.frames); } catch (e) { return null; }
      })();
      const timing = (() => {
        try { return JSON.parse(this.dataset.options); } catch (e) { return null; }
      })();
      const doAnimate = (node) => {
        if (!animationFrames || !timing || !node) return;
        return node.animate(animationFrames, timing);
      };
      const setSelectedTab = (currentTab, setFocus = true) => {
        this.tabs.forEach((tab, index) => {
          const panel = this.tabpanels[index];
          if (!panel) return;
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
          panel.classList.toggle('hidden', !isSelected);
          if (isSelected) {
            if (setFocus) tab.focus();
            doAnimate(panel);
          }
        });
        window.dispatchEvent(new Event('resize'));
      }
      const setSelectedToPreviousTab = (currentTab) => {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      }
      const setSelectedToNextTab = (currentTab) => {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
      }
      const onKeydown = (event) => {
        const tgt = event.currentTarget;
        let flag = false;
        switch (event.key) {
          case 'ArrowLeft':
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;
          case 'ArrowRight':
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;
          case 'Home':
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;
          case 'End':
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;
          default:
            break;
        }
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
      const onClick = (event) => {
        this.setSelectedTab(event.currentTarget);
      }
      const initialize = () => {
        this.tabpanels = this.tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach(tab => {
          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          tab.addEventListener('keydown', onKeydown);
          tab.addEventListener('click', onClick);
        });
        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        this.setSelectedTab(this.firstTab, false);
      }
      this.setSelectedTab = setSelectedTab;
      this.setSelectedToPreviousTab = setSelectedToPreviousTab;
      this.setSelectedToNextTab = setSelectedToNextTab;
      this.onKeydown = onKeydown;
      this.onClick = onClick;
      this.initialize = initialize;
      if (this.dataset.editorMode === 'true') {
        document.addEventListener('shopify:block:select', (event) => {
          const target = event.target;
          const parent = target.parentElement;
          if (parent.nodeName !== 'TABSET-COMPONENT') return;
          parent.initialize();
          parent.setSelectedTab(target);
        });
      }
      initialize();
    }
  }
  if (!customElements.get('tabset-component')) customElements.define('tabset-component', TabsetComponent);

  /* ── Collapsible with content — entrance reveal (GSAP) ───────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playCollapsibleWithContentReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('.collapsible-with-content_heading-head');
      var mediaWrap = section.querySelector('.collapsible-group_img-wrapper');
      var items = section.querySelectorAll('.collapsible-with-content_row-wrap, .collapsible-group');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      if (mediaWrap && (_M.flags ? _M.flags.clipReveals !== false : true)) {
        gsap.set(mediaWrap, { clipPath: 'inset(0 0 100% 0)', scale: 1.04 });
        tl.to(mediaWrap, {
          clipPath: 'inset(0 0 0% 0)', scale: 1,
          duration: (_M.dur && _M.dur.xslow) || 1.4, ease: (_M.ease && _M.ease.reveal) || 'expo.out',
          clearProps: 'clipPath,scale'
        }, 0);
      }

      if (headWrap) {
        var heading = headWrap.querySelector('h1, h2, h3, h4, h5, h6, [class*="_heading"]');
        if (heading) {
          var split = window.themeSplitHeading && window.themeSplitHeading(heading);
          if (split && split.targets !== heading) {
            gsap.set(split.targets, split.fromVars);
            tl.to(split.targets, Object.assign({}, split.toVars, { duration: split.duration, ease: split.ease, stagger: split.stagger }), 0.2);
          } else {
            gsap.set(heading, { opacity: 0, y: 24 });
            tl.to(heading, {
              opacity: 1, y: 0,
              duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out'
            }, 0.2);
          }
        }

        var tagline = headWrap.querySelector('.collapsible-with-content_tagline');
        if (tagline) {
          gsap.set(tagline, { opacity: 0, y: 16 });
          tl.to(tagline, {
            opacity: 1, y: 0,
            duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out'
          }, 0.1);
        }

        var description = headWrap.querySelector('.collapsible-with-content_description');
        if (description) {
          var descSplit = window.themeSplitHeading && window.themeSplitHeading(description);
          if (descSplit && descSplit.targets !== description) {
            gsap.set(descSplit.targets, descSplit.fromVars);
            tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, { duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger }), 0.3);
          } else {
            gsap.set(description, { opacity: 0, y: 16 });
            tl.to(description, {
              opacity: 1, y: 0,
              duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out'
            }, 0.3);
          }
        }
      }

      if (items.length) {
        gsap.set(items, { opacity: 0, y: 32 });
        tl.to(items, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1
        }, mediaWrap || headWrap ? 0.3 : 0);
      }
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initCollapsibleWithContentReveal(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'collapsible-with-content-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative priority above it, so it
        // could refresh and lock in a stale start/end before sibling pinned
        // sections finish resolving their own pin-spacer heights on the
        // same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playCollapsibleWithContentReveal(section); },
        onEnterBack: function () { playCollapsibleWithContentReveal(section); }
      });
    }

    document.querySelectorAll('.collapsible-with-content').forEach(initCollapsibleWithContentReveal);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('collapsible-with-content') ? root : root.querySelector('.collapsible-with-content'));
      if (s) { initCollapsibleWithContentReveal(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  /* ── Motion Design System: heading, card entrance, stack-pin and hover ─────
     Ported from the reference theme's collection-list implementation and
     rebuilt on the theme's shared window.onThemeGsapReady queue (instead of
     DOMContentLoaded) so it works whether GSAP loads before or after this
     section's markup, reading timing/easing from window.themeMotion instead
     of hardcoding it for the heading/no-stack-card reveal. */
  /* Both delegate to layout/theme.liquid's window.themeSplitWords/
     window.themeScrollPriority — shared with sections/main-collections.liquid,
     which had byte-identical copies of this logic under an 'mc' prefix. The
     'cl' prefix here keeps this section's own class names/dataset flag
     (.cl-word-wrap/.cl-word-inner, data-cl-split) exactly as they were;
     only the duplicated logic moved, not this section's markup contract. */
  function collectionListSplitWords(el) {
    return window.themeSplitWords(el, 'cl');
  }

  function collectionListScrollPriority(el) {
    return window.themeScrollPriority(el);
  }

  function initCollectionListHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.collection-list_heading-head');
    if (!headingHead) return;

    var idPrefix = 'cl-head-' + section.id;
    var oldHeadTrigger = ST.getById(idPrefix);
    if (oldHeadTrigger) oldHeadTrigger.kill();

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.collection-list_tagline-text');
    var heading = headingHead.querySelector('.collection-list_heading');
    var desc = headingHead.querySelector('.collection-list_description');

    if (heading) {
      heading.style.visibility = '';
      if (heading.dataset.clSplit || heading.querySelector('.cl-word-wrap')) {
        heading.textContent = heading.textContent;
        delete heading.dataset.clSplit;
      }
    }

    var headingSplit = window.themeSplitHeading(heading);
    var descSplit = window.themeSplitHeading(desc);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descSplit.targets || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix,
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 75%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: collectionListScrollPriority(headingHead)
      }
    }));
  }

  /* Per-card entrance reveal for non-stack instances. Always clears its own
     inline styles on the card's sub-elements first — covers the stack /
     no-stack mode switch on resize, where the pin-stack timeline above owns
     these cards instead and this must get completely out of its way. */
  function initCollectionListCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    var idPrefix = 'cl-card-' + section.id + '-';
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });
    if (window.innerWidth < 768) return;

    var cards = section.querySelectorAll('.collection-list-card');

    cards.forEach(function (card) {
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      var textCol = card.querySelector('.collection-list-card_content-col--one');
      [topBar, imgWrap, img, textCol].filter(Boolean).forEach(function (el) { gsap.set(el, { clearProps: 'all' }); });
    });

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var _M = window.themeMotion || {};
    if (reduceMotion) return;
    /* If stack-pin mode or collapsible mode is active on this device, skip entrance batch */
    var isDesktop = window.innerWidth >= 768;
    var currentAnim = isDesktop
      ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
      : (section.dataset.animationMobile || 'none');
    if (currentAnim === 'stacked' || currentAnim === 'collapsible') return;

    /* Resets a card's animated sub-elements to their pre-reveal hidden
       state — used both for the initial setup below and by onLeaveBack to
       re-hide a card once it scrolls back out, so scrolling forward into it
       again replays the same entrance. Every card goes through this (not
       just ones below the fold): a card already in view when its
       ScrollTrigger is created just has onEnter fire immediately, which
       matches how every other entrance reveal in this theme treats
       above-the-fold content. */
    function hideCard(card) {
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      var textCol = card.querySelector('.collection-list-card_content-col--one');

      if (topBar) gsap.set(topBar, { opacity: 0, y: -10 });
      if (imgWrap) gsap.set(imgWrap, { clipPath: 'inset(0 0 100% 0)' });
      if (img) gsap.set(img, { scale: 1.14, transformOrigin: 'center center' });
      if (textCol) gsap.set(textCol, { opacity: 0, x: -24 });
    }

    cards.forEach(function (card) { hideCard(card); });

    /* ScrollTrigger.batch() instead of one ST.create() per card — same
       technique image-gallery.liquid already established for this codebase.
       Cards that enter the viewport within the same short window animate
       together via a single grouped callback instead of each card firing
       its own independent onEnter, which matters on a collection page with
       20+ cards in the grid. */
    var _staggerStep = (_M.stagger && _M.stagger.tight) || 0.08;
    var cardBatch = ST.batch(Array.prototype.slice.call(cards), {
      interval: 0.1,
      start: (_M.trigger && _M.trigger.start) || 'top 75%',
      end: 'bottom top',
      /* initCollectionListHeading (above) and the pin-stack trigger below
         already set this on their own triggers; this batch never did, so
         its start positions could get computed before/after sibling pinned
         sections (hero-banner, main-collections, etc. — see
         window.themeScrollPriority in theme.liquid) finish resolving their
         own pin-spacer heights on the same refresh pass, landing a few
         pixels off in either direction depending on refresh order. For
         cards sitting right at the 'top 75%' threshold, that's the
         difference between entering on this refresh or the next — exactly
         the "reveals on card 1 sometimes, 2 or 3 other times" inconsistency
         between loads. */
      refreshPriority: collectionListScrollPriority(section),
      onEnter: function (batch) {
        batch.forEach(function (card, i) {
          var topBar = card.querySelector('.collection-list-card_top-bar');
          var imgWrap = card.querySelector('.collection-list-card_content-image');
          var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
          var textCol = card.querySelector('.collection-list-card_content-col--one');

          var tl = gsap.timeline({ defaults: { overwrite: 'auto' }, delay: i * _staggerStep });
          if (topBar) tl.to(topBar, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.fast) || 0.55, ease: (_M.ease && _M.ease.enter) || 'power3.out' }, 0);
          if (imgWrap) tl.to(imgWrap, { clipPath: 'inset(0 0 0% 0)', duration: (_M.dur && _M.dur.slow) || 1.1, ease: 'expo.out' }, 0.06);
          if (img) tl.to(img, { scale: 1, duration: (_M.dur && _M.dur.xslow) || 1.7, ease: 'power2.out' }, 0.06);
          if (textCol) tl.to(textCol, { opacity: 1, x: 0, duration: (_M.dur && _M.dur.base) || 0.85, ease: (_M.ease && _M.ease.enter) || 'power3.out' }, 0.3);
        });
      },
      onLeaveBack: function (batch) {
        batch.forEach(hideCard);
      }
    });
    /* Tag the batch's own triggers with idPrefix so the kill-before-rebuild
       pass above still finds and clears them on the next theme-editor reload. */
    cardBatch.forEach(function (t, i) { t.vars.id = idPrefix + 'batch-' + i; });
  }

  /* Stack animation: pins the cards-wrap only (never the heading/description
     above it, which stays in normal scroll flow) and scrubs each card up over
     the one before it, dimming/parallaxing the outgoing card's content and
     backdrop text as the next card arrives.
     headH is measured from the wrapper's top to the first card's natural top
     using getBoundingClientRect() — normally ~0 since the wrapper now starts
     right at the first card, but kept to absorb any padding/margin so there's
     no card-jump on pin. */
  function initCollectionListStack(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    var cards = section.querySelectorAll('.collection-list-card');
    var wrapper = section.querySelector('.collection-list_cards-wrap');
    if (!cards.length || !wrapper) return;

    var idPrefix = 'cl-stack-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id === idPrefix) t.kill();
    });

    /* Measure geometry BEFORE any DOM changes so layout is still natural.
       getBoundingClientRect includes margins/padding — offsetHeight does not. */
    var wrapperRect = wrapper.getBoundingClientRect();
    var firstCardRect = cards[0].getBoundingClientRect();

    var headH = Math.round(firstCardRect.top - wrapperRect.top);
    if (headH < 0) headH = 0;

    /* Read every top-bar height first, in its own pass, before any style is
       written. Interleaving reads (offsetHeight) with writes (setProperty) in
       a single loop forces a synchronous layout recalc on every iteration;
       batching reads-then-writes collapses that to at most one reflow. */
    var topBarHeights = [];
    cards.forEach(function (card) {
      var tb = card.querySelector('.collection-list-card_top-bar');
      topBarHeights.push(tb ? tb.offsetHeight : 0);
    });

    /* Also read background color here, before layout-affecting writes below —
       getComputedStyle would otherwise force the browser to flush those
       pending style changes first. */
    var schemeBg = getComputedStyle(cards[0]).backgroundColor;

    var accumH = headH;
    var positions = [];

    cards.forEach(function (card, i) {
      positions.push(accumH);
      card.style.setProperty('--card-height', 'calc(100vh - ' + (accumH + topBarHeights[i]) + 'px)');
      accumH += topBarHeights[i];
    });

    wrapper.style.position = 'relative';
    wrapper.style.height = window.innerHeight + 'px';

    /* This section's pin can immediately follow another pinned section (e.g.
       hero-banner) further up the page, so the combined forced scroll before
       real content is reached adds up fast. 0.5 keeps the stacking effect
       clearly visible while limiting how much extra scroll it demands. */
    var scrollDist = (cards.length - 1) * window.innerHeight * 1.0;

    cards.forEach(function (card, i) {
      card.style.position = 'absolute';
      card.style.left = '0';
      card.style.width = '100%';
      card.style.top = '0';
      card.style.zIndex = i + 1;
      card.style.pointerEvents = i === 0 ? 'auto' : 'none';
      gsap.set(card, { y: i === 0 ? headH : window.innerHeight });
    });

    /* Keep wrapper opaque so nothing behind (e.g. hero with GSAP transform offset,
       or the heading above it once it has scrolled past) bleeds through any gap
       above the first card. */
    wrapper.style.backgroundColor = (schemeBg && schemeBg !== 'rgba(0, 0, 0, 0)' && schemeBg !== 'transparent')
      ? schemeBg
      : (getComputedStyle(document.body).backgroundColor || '#fff');

    var tl = gsap.timeline({
      scrollTrigger: {
        id: idPrefix,
        trigger: wrapper,
        pin: true,
        /* Exclude the sticky header's height so its fixed overlay doesn't
           cover the top of this section once pinned. */
        start: function () { return 'top top+=' + (window.getStickyHeaderOffset ? window.getStickyHeaderOffset() : 0); },
        end: function () { return '+=' + scrollDist; },
        scrub: 0.4,
        refreshPriority: collectionListScrollPriority(wrapper),
        invalidateOnRefresh: true
      }
    });

    cards.forEach(function (card, i) {
      if (i === 0) return;

      tl.to(card, {
        y: positions[i],
        ease: 'none',
        onStart: function () { card.style.pointerEvents = 'auto'; },
        onReverseComplete: function () { card.style.pointerEvents = 'none'; }
      }, '>');

      var img = card.querySelector('.collection-list-card_content-image img') ||
        card.querySelector('.collection-list-card_content-image svg');
      if (img) {
        tl.fromTo(img, { yPercent: 10 }, { yPercent: 0, ease: 'none' }, '<');
      }

      var prevContent = cards[i - 1].querySelector('.collection-list-card_content');
      var prevBackdrop = cards[i - 1].querySelector('.collection-list-card_backdrop-text');
      if (prevContent) tl.to(prevContent, { scale: 0.94, opacity: 0.22, ease: 'none' }, '<');
      if (prevBackdrop) tl.to(prevBackdrop, { yPercent: -40, opacity: 0, ease: 'none' }, '<');
    });

    var totalCards = cards.length;
    cards.forEach(function (card, i) {
      var focusableElements = card.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach(function (el) {
        if (el.dataset.clFocusBound) return;
        el.dataset.clFocusBound = '1';
        var isPointer = false;
        var setPointerFlag = function () {
          isPointer = true;
          setTimeout(function () { isPointer = false; }, 500);
        };
        el.addEventListener('pointerdown', setPointerFlag);
        el.addEventListener('mousedown', setPointerFlag);
        el.addEventListener('focus', function () {
          if (isPointer) return;
          try {
            if (!el.matches(':focus-visible')) return;
          } catch (err) {}
          var st = tl.scrollTrigger;
          var targetProgress = totalCards > 1 ? i / (totalCards - 1) : 0;
          gsap.to(tl, {
            progress: targetProgress,
            duration: 0.4,
            ease: 'power2.out',
            onUpdate: function () {
              if (st) window.scrollTo(0, st.start + (st.end - st.start) * tl.progress());
            }
          });
        });
      });
    });
  }

  /* Hover: image scale. Guarded by a dataset flag so repeated init passes
     (resize, unrelated theme-editor reloads) don't stack duplicate listeners
     on cards that are already bound. */
  function initCollectionListHover(section) {
    var gsap = window.gsap;
    if (!gsap) return;
    section.querySelectorAll('.collection-list-card').forEach(function (card) {
      if (card.dataset.clHoverBound) return;
      card.dataset.clHoverBound = '1';
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      if (!img) return;
      card.addEventListener('mouseenter', function () {
        gsap.to(img, { scale: 1.07, duration: 0.65, ease: 'power2.out', overwrite: 'auto' });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(img, { scale: 1, duration: 0.9, ease: 'power2.inOut', overwrite: 'auto' });
      });
    });
  }

  /* Full reset before every (re)init pass: clears both GSAP-managed props and
     directly-set inline styles left by the stack/collapsible layout — covers a resize
     that flips a section between modes, or the theme editor reloading a section mid-scroll. */
  function resetCollectionListSection(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var wrapper = section.querySelector('.collection-list_cards-wrap');
    if (wrapper) { wrapper.style.position = ''; wrapper.style.height = ''; wrapper.style.backgroundColor = ''; }

    if (ST) {
      var stackId = 'cl-stack-' + section.id;
      ST.getAll().forEach(function (t) {
        var id = t.vars && t.vars.id;
        if (id === stackId) t.kill();
      });
    }

    section.querySelectorAll('.collection-list-card').forEach(function (card) {
      card.style.removeProperty('--card-height');
      card.style.removeProperty('position');
      card.style.removeProperty('left');
      card.style.removeProperty('width');
      card.style.removeProperty('top');
      card.style.removeProperty('z-index');
      var content = card.querySelector('.collection-list-card_content');
      if (content) {
        content.style.removeProperty('height');
        content.style.removeProperty('opacity');
        content.style.removeProperty('display');
        content.style.removeProperty('overflow');
      }
      if (!gsap) return;
      [
        card,
        content,
        card.querySelector('.collection-list-card_content-image'),
        card.querySelector('.collection-list-card_content-image img') ||
          card.querySelector('.collection-list-card_content-image svg'),
        card.querySelector('.collection-list-card_top-bar'),
        card.querySelector('.collection-list-card_content-col--one'),
        card.querySelector('.collection-list-card_content-link'),
        card.querySelector('.collection-list-card_backdrop-text')
      ].filter(Boolean).forEach(function (el) { gsap.set(el, { clearProps: 'all' }); });
    });
  }

  /* Collapsible / Accordion mode with GSAP: allows cards to expand and collapse smoothly */
  function initCollectionListCollapsible(section) {
    var gsap = window.gsap;
    if (!gsap) return;

    var cards = section.querySelectorAll('.collection-list-card');
    cards.forEach(function (card) {
      var content = card.querySelector('.collection-list-card_content');
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var toggler = card.querySelector('.collection-list-card_toggler');
      if (!content || !topBar) return;

      var shouldBeOpen = card.dataset.openByDefault === 'true' || card.classList.contains('is-open');
      if (shouldBeOpen) {
        card.classList.add('is-open');
        gsap.set(content, { height: 'auto', opacity: 1, display: 'flex', clearProps: 'transform' });
        if (toggler) toggler.setAttribute('aria-expanded', 'true');
      } else {
        card.classList.remove('is-open');
        gsap.set(content, { height: 0, opacity: 0, display: 'none' });
        if (toggler) toggler.setAttribute('aria-expanded', 'false');
      }

      if (!card.dataset.clCollapsibleBound) {
        card.dataset.clCollapsibleBound = '1';
        topBar.addEventListener('click', function (e) {
          var isDesk = window.innerWidth >= 768;
          var curAnim = isDesk
            ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
            : (section.dataset.animationMobile || 'none');
          if (curAnim !== 'collapsible') return;
          var link = e.target.closest('a');
          if (link && !e.target.closest('.collection-list-card_toggler')) return;

          e.preventDefault();
          var isOpen = card.classList.contains('is-open');
          if (isOpen) {
            card.classList.remove('is-open');
            if (toggler) toggler.setAttribute('aria-expanded', 'false');
            gsap.to(content, {
              height: 0,
              opacity: 0,
              duration: 0.4,
              ease: 'power2.inOut',
              onComplete: function () {
                content.style.display = 'none';
              }
            });
          } else {
            cards.forEach(function (otherCard) {
              if (otherCard !== card && otherCard.classList.contains('is-open')) {
                otherCard.classList.remove('is-open');
                var otherToggler = otherCard.querySelector('.collection-list-card_toggler');
                var otherContent = otherCard.querySelector('.collection-list-card_content');
                if (otherToggler) otherToggler.setAttribute('aria-expanded', 'false');
                if (otherContent) {
                  gsap.to(otherContent, {
                    height: 0,
                    opacity: 0,
                    duration: 0.35,
                    ease: 'power2.inOut',
                    onComplete: function () {
                      otherContent.style.display = 'none';
                    }
                  });
                }
              }
            });

            card.classList.add('is-open');
            if (toggler) toggler.setAttribute('aria-expanded', 'true');
            content.style.display = 'flex';
            gsap.fromTo(content,
              { height: 0, opacity: 0 },
              { height: 'auto', opacity: 1, duration: 0.45, ease: 'power2.out' }
            );
          }
        });
      }
    });
  }

  /* Init a single section instance. isResize skips re-creating the heading
     reveal (already set up, and reduceMotion/dataset guards make it a no-op
     otherwise) — a resize only needs to re-decide animation modes and re-measure. */
  function initCollectionListReveal(section, isResize) {
    resetCollectionListSection(section);
    if (!isResize) initCollectionListHeading(section);

    var cards = section.querySelectorAll('.collection-list-card');
    if (!cards.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.innerWidth >= 768;
    var currentAnim = isDesktop
      ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
      : (section.dataset.animationMobile || 'none');

    if (reduceMotion) currentAnim = 'none';

    if (currentAnim === 'stacked') {
      section.classList.add('collection-list--stack-enabled');
      section.classList.remove('collection-list--collapsible-enabled');
      initCollectionListStack(section);
    } else if (currentAnim === 'collapsible') {
      section.classList.remove('collection-list--stack-enabled');
      section.classList.add('collection-list--collapsible-enabled');
      initCollectionListCollapsible(section);
    } else {
      section.classList.remove('collection-list--stack-enabled');
      section.classList.remove('collection-list--collapsible-enabled');
      initCollectionListCards(section);
    }
    initCollectionListHover(section);
  }

  /* Every collection-list section on the page. Only used for the initial
     load and for resize, where every instance genuinely needs re-measuring —
     never for a single unrelated section-editor reload. */
  function initAllCollectionListReveals(isResize) {
    document.querySelectorAll('.collection-list').forEach(function (section) {
      initCollectionListReveal(section, isResize);
    });
  }

  window.onThemeGsapReady(function () { initAllCollectionListReveals(false); });

  /* shopify:section:load fires for ANY section reloading in the theme editor,
     not just this one. Reinitializing every collection-list instance on the
     page in response to an unrelated section edit would kill and rebuild
     ScrollTriggers/pins that had nothing to do with the edit, fighting with
     whatever animation that other section owns. Scope the reinit to the
     section that actually reloaded. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('collection-list')
      ? root
      : (root && root.querySelector ? root.querySelector('.collection-list') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initCollectionListReveal(section, false); });
  });

  /* Dragging sections in the customizer moves DOM nodes without firing
     shopify:section:load, so pins created above would keep the refreshPriority
     computed from their old position. Reinitializing every instance kills
     each section's existing triggers by id before recreating them, so this
     picks up the current position/priority for every instance under the new
     order. */
  document.addEventListener('shopify:section:reorder', function () {
    window.onThemeGsapReady(function () { initAllCollectionListReveals(false); });
  });

  /* Outright section removal (as opposed to an edit, which fires
     shopify:section:load instead): kill this instance's own ScrollTriggers
     by id rather than relying only on ScrollTrigger's own detached-element
     cleanup on next refresh. Matches sections/showcase-hotspot.liquid's
     pattern. */
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('collection-list')
      ? root
      : (root && root.querySelector ? root.querySelector('.collection-list') : null);
    var ST = window.ScrollTrigger;
    if (!section || !section.id || !ST) return;
    var prefixes = ['cl-head-' + section.id, 'cl-card-' + section.id + '-', 'cl-stack-' + section.id];
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (!id) return;
      for (var i = 0; i < prefixes.length; i++) {
        if (id.indexOf(prefixes[i]) === 0) { t.kill(); break; }
      }
    });
  });

  (function () {
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        /* Mobile browsers fire resize when the address bar hides/shows on
           scroll — that only changes innerHeight, not innerWidth. Rebuilding
           every pinned stack ScrollTrigger mid-scroll for a non-resize caused
           visible jumps; only react to an actual width change. */
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        window.onThemeGsapReady(function () { initAllCollectionListReveals(true); });
      }, 220);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  /* ── Contact form entrance ──────────────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playContactFormReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('.contact-form_heading-head');
      var tagline  = headWrap && headWrap.querySelector('.contact-form_tagline');
      var heading  = headWrap && headWrap.querySelector('.contact-form_heading');
      var desc     = headWrap && headWrap.querySelector('.contact-form_description');
      var cards    = section.querySelectorAll('.contact-form_card-col');
      var fields   = section.querySelectorAll('.contact-form_field');
      var bottom   = section.querySelector('.contact-form_bottom-wrap');
      var media    = section.querySelector('.contact-form_col--media');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      var headOffset = 0;
      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 20 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        headOffset = 0.15;
      }
      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, {
            duration: split.duration, ease: split.ease, stagger: split.stagger
          }), headOffset);
        } else {
          gsap.set(heading, { opacity: 0, y: 28 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset);
        }
      }
      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
            duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
          }), headOffset + 0.2);
        } else {
          gsap.set(desc, { opacity: 0, y: 20 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset + 0.2);
        }
      }

      var contentOffset = headWrap ? 0.35 : 0;

      if (cards.length && (_M.flags ? _M.flags.staggerCards !== false : true)) {
        gsap.set(cards, { opacity: 0, y: 40 });
        tl.to(cards, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.base) || 0.65,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.tight) || 0.06
        }, contentOffset);
        contentOffset += 0.15;
      }

      if (fields.length) {
        gsap.set(fields, { opacity: 0, y: 24 });
        tl.to(fields, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.base) || 0.65,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.tight) || 0.06
        }, contentOffset);
      }

      if (bottom) {
        gsap.set(bottom, { opacity: 0, y: 20 });
        tl.to(bottom, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, contentOffset + 0.2);
      }

      if (media) {
        gsap.set(media, { opacity: 0, scale: 0.96 });
        tl.to(media, {
          opacity: 1, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          clearProps: 'scale'
        }, contentOffset);
      }
    }

    function initContactFormSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'contact-form-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it on the page — letting it refresh and lock in a stale
        // start/end before that sibling pinned section finishes resolving
        // its own pin-spacer height on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playContactFormReveal(section); },
        onEnterBack: function () { playContactFormReveal(section); }
      });
    }

    document.querySelectorAll('.contact-form').forEach(initContactFormSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('contact-form') ? root : root.querySelector('.contact-form'));
      if (s) { initContactFormSection(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  /* ── Featured blog entrance ─────────────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playFeaturedBlogReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('.featured-blog_heading-head');
      var tagline  = headWrap && headWrap.querySelector('.featured-blog_tagline');
      var heading  = headWrap && headWrap.querySelector('.featured-blog_heading');
      var desc     = headWrap && headWrap.querySelector('.featured-blog_description');
      var cards    = section.querySelectorAll('.featured-blog_grid-col');
      var btnWrap  = section.querySelector('.featured-blog_btn-wrap');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      var headOffset = 0;
      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 20 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        headOffset = 0.15;
      }
      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, {
            duration: split.duration, ease: split.ease, stagger: split.stagger
          }), headOffset);
        } else {
          gsap.set(heading, { opacity: 0, y: 28 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset);
        }
      }
      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
            duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
          }), headOffset + 0.2);
        } else {
          gsap.set(desc, { opacity: 0, y: 20 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset + 0.2);
        }
      }

      if (cards.length && (_M.flags ? _M.flags.staggerCards !== false : true)) {
        gsap.set(cards, { opacity: 0, y: 52, scale: 0.97 });
        tl.to(cards, {
          opacity: 1, y: 0, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1,
          clearProps: 'scale'
        }, headWrap ? 0.3 : 0);
      }

      if (btnWrap) {
        gsap.set(btnWrap, { opacity: 0, y: 20 });
        tl.to(btnWrap, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, '+=0.1');
      }
    }

    function initFeaturedBlogSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'featured-blog-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative priority above it, so it
        // could refresh and lock in a stale start/end before sibling pinned
        // sections finish resolving their own pin-spacer heights on the
        // same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playFeaturedBlogReveal(section); },
        onEnterBack: function () { playFeaturedBlogReveal(section); }
      });
    }

    document.querySelectorAll('.featured-blog').forEach(initFeaturedBlogSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('featured-blog') ? root : root.querySelector('.featured-blog'));
      if (s) { initFeaturedBlogSection(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class TabsetComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tablistNode = this;
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[data-tabset-content]'));
      const animationFrames = (() => {
        try {
          return JSON.parse(this.dataset.frames);
        } catch (e) {
          return null;
        }
      })();
      const timing = (() => {
        try {
          return JSON.parse(this.dataset.options);
        } catch (e) {
          return null;
        }
      })();
      const doAnimate = (node) => {
        if (!animationFrames || !timing || !node) return;
        return node.animate(animationFrames, timing);
      };
      const setSelectedTab = (currentTab, setFocus = true) => {
        this.tabs.forEach((tab, index) => {
          const panel = this.tabpanels[index];
          if (!panel) return;
          const isSelected = currentTab === tab;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
          panel.classList.toggle('hidden', !isSelected);
          if (isSelected) {
            if (setFocus) tab.focus();
            try {
              tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            } catch (e) {}
            doAnimate(panel);
          }
        });
        const collectionUrl = currentTab.dataset.collectionUrl;
        const hasMore = currentTab.dataset.hasMore;
        const sectionElem = this.closest('.featured-collection') || this.closest('section');
        if (sectionElem && collectionUrl) {
          const headerBtn = sectionElem.querySelector('.featured-collection_button--header');
          if (headerBtn) {
            headerBtn.setAttribute('href', collectionUrl);
            headerBtn.removeAttribute('aria-disabled');
            if (hasMore === 'false') {
              headerBtn.style.display = 'none';
            } else {
              headerBtn.style.display = '';
            }
          }
        }
        window.dispatchEvent(new Event('resize'));
        const parentSplideSlider = this.closest('splide-slider');
        if (parentSplideSlider && typeof parentSplideSlider.initializeActiveSlider === 'function') {
          parentSplideSlider.initializeActiveSlider();
        }
      };
      const setSelectedToPreviousTab = (currentTab) => {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === 0 ? this.lastTab : this.tabs[index - 1]);
      };
      const setSelectedToNextTab = (currentTab) => {
        const index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(index === this.tabs.length - 1 ? this.firstTab : this.tabs[index + 1]);
      };
      const onKeydown = (event) => {
        const tgt = event.currentTarget;
        let flag = false;
        switch (event.key) {
          case 'ArrowLeft':
            this.setSelectedToPreviousTab(tgt);
            flag = true;
            break;
          case 'ArrowRight':
            this.setSelectedToNextTab(tgt);
            flag = true;
            break;
          case 'Home':
            this.setSelectedTab(this.firstTab);
            flag = true;
            break;
          case 'End':
            this.setSelectedTab(this.lastTab);
            flag = true;
            break;
          default:
            break;
        }
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      };
      const onClick = (event) => {
        this.setSelectedTab(event.currentTarget);
      };
      const initialize = () => {
        this.tabpanels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
        this.tabs.forEach((tab) => {
          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          tab.addEventListener('keydown', onKeydown);
          tab.addEventListener('click', onClick);
        });
        this.firstTab = this.tabs[0];
        this.lastTab = this.tabs[this.tabs.length - 1];
        this.setSelectedTab(this.firstTab, false);
      };
      this.setSelectedTab = setSelectedTab;
      this.setSelectedToPreviousTab = setSelectedToPreviousTab;
      this.setSelectedToNextTab = setSelectedToNextTab;
      this.onKeydown = onKeydown;
      this.onClick = onClick;
      this.initialize = initialize;
      if (this.dataset.editorMode === 'true') {
        document.addEventListener('shopify:block:select', (event) => {
          const target = event.target;
          const parent = target.parentElement;
          if (parent.nodeName !== 'TABSET-COMPONENT') return;
          parent.initialize();
          parent.setSelectedTab(target);
        });
      }
      initialize();
    }
  }
  if (!customElements.get('tabset-component')) customElements.define('tabset-component', TabsetComponent);
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (
    jsonSelector,
    optSet,
    formsSelector,
    renders,
    parentSelector,
    gallerySelectors,
    sectionId,
    productUrl,
    updateUrl,
    focusSelector,
    renderMedia,
    templateSelector
  ) => {
    const json = document.querySelector(jsonSelector);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === optSet[index])
    );

    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }

    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if (!currentVariant) return;

    if (currentVariant.featured_image)
      setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach((form) => {
      if (!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if (!atcBtn) return;
      if (variant.available) {
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, article, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach((selector) => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach((element) => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
        if (focusSelector) {
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach((selector) => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach((element) => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if (!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      if (typeof VariantDropdown !== 'undefined' && VariantDropdown.prototype.updateOptionsAvailability) {
        VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
        return;
      }
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              item.classList.remove('disabled');
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              item.classList.add('disabled');
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = document.querySelector(this.dataset.form);
      if (!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append(
          'sections',
          secArr.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);

  /* ── Featured collection entrance ───────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playFeaturedCollectionReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('.featured-collection_heading-head');
      var tagline  = headWrap && headWrap.querySelector('.featured-collection_tagline');
      var heading  = headWrap && headWrap.querySelector('.featured-collection_heading');
      var desc     = headWrap && headWrap.querySelector('.featured-collection_description');
      var activePanel = section.querySelector('.featured-collection_tabset-panel:not(.hidden)') || section;
      var cards    = activePanel.querySelectorAll('.featured-collection_grid-col, .featured-collection_slide');
      var viewAll  = section.querySelector('.featured-collection_view-all');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      var headOffset = 0;
      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 20 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        headOffset = 0.15;
      }
      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, {
            duration: split.duration, ease: split.ease, stagger: split.stagger
          }), headOffset);
        } else {
          gsap.set(heading, { opacity: 0, y: 28 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset);
        }
      }
      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
            duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
          }), headOffset + 0.2);
        } else {
          gsap.set(desc, { opacity: 0, y: 20 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset + 0.2);
        }
      }

      if (cards.length && (_M.flags ? _M.flags.staggerCards !== false : true)) {
        gsap.set(cards, { opacity: 0, y: 52, scale: 0.97 });
        tl.to(cards, {
          opacity: 1, y: 0, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1,
          clearProps: 'scale'
        }, headWrap ? 0.3 : 0);
      }

      if (viewAll) {
        gsap.set(viewAll, { opacity: 0, y: 20 });
        tl.to(viewAll, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, '+=0.1');
      }
    }

    function initFeaturedCollectionSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'featured-collection-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it, so it can refresh and lock in a stale start/end before
        // that sibling pinned section finishes resolving its own pin-spacer
        // height on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playFeaturedCollectionReveal(section); },
        onEnterBack: function () { playFeaturedCollectionReveal(section); }
      });

      section.querySelectorAll('.splide__list').forEach(function (list) {
        var revealCloneCards = function () {
          Array.prototype.forEach.call(list.querySelectorAll('[data-slide-clone]'), function (card) {
            gsap.set(card, { opacity: 1, y: 0, scale: 1 });
          });
        };
        revealCloneCards();
        new MutationObserver(revealCloneCards).observe(list, { childList: true });
      });
    }

    document.querySelectorAll('.featured-collection').forEach(initFeaturedCollectionSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('featured-collection') ? root : root.querySelector('.featured-collection'));
      if (s) { initFeaturedCollectionSection(s); }
    });

    /* Tab switches (tabset-component) swap which panel is visible without a
       scroll event firing again, so the newly-shown panel's cards would stay
       at opacity:0 forever once the section's entrance already played. Replay
       just for that panel's cards on tab change. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tabset-content]');
      if (!btn) return;
      var section = btn.closest('.featured-collection');
      if (!section) return;
      requestAnimationFrame(function () {
        var panel = section.querySelector('.featured-collection_tabset-panel:not(.hidden)');
        if (!panel) return;
        var cards = panel.querySelectorAll('.featured-collection_grid-col, .featured-collection_slide');
        if (!cards.length) return;
        var alreadyRevealed = window.getComputedStyle(cards[0]).opacity !== '0';
        if (alreadyRevealed) return;
        var _M = window.themeMotion || {};
        gsap.set(cards, { opacity: 0, y: 52, scale: 0.97 });
        gsap.to(cards, {
          opacity: 1, y: 0, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1,
          clearProps: 'scale'
        });
      });
    });

    /* Image hover zoom — mirrors the image-gallery pattern: on pointer-fine
       devices, hovering a product card image gently scales the img to 1.07
       and back, driven by GSAP so it blends seamlessly with the entrance
       animation that also touches `scale`. */
    var _hoverM = window.themeMotion || {};
    if ((_hoverM.flags ? _hoverM.flags.imageHover !== false : true) && window.matchMedia('(pointer: fine)').matches) {
      document.querySelectorAll('.featured-collection').forEach(function (section) {
        section.querySelectorAll('.product-card-new_image-wrapper').forEach(function (wrapper) {
          var img = wrapper.querySelector('img');
          if (!img) return;
          wrapper.addEventListener('mouseenter', function () {
            gsap.to(img, { scale: 1.07, duration: (_hoverM.dur && _hoverM.dur.slow) || 1.0, ease: (_hoverM.ease && _hoverM.ease.ui) || 'power3.out', overwrite: 'auto' });
          });
          wrapper.addEventListener('mouseleave', function () {
            gsap.to(img, { scale: 1, duration: (_hoverM.dur && _hoverM.dur.slow) || 1.0, ease: (_hoverM.ease && _hoverM.ease.ui) || 'power3.out', overwrite: 'auto' });
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
    
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, article, .featured-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, article, .featured-product_wrapper, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
          // Dynamically update quantity-input variant price & subtotal
          const qtyInput = parentElement.querySelector('quantity-input');
          if (qtyInput) {
            const sourceQtyInput = html.querySelector('quantity-input');
            if (sourceQtyInput && sourceQtyInput.dataset.variantPrice) {
              qtyInput.dataset.variantPrice = sourceQtyInput.dataset.variantPrice;
            } else {
              // Local fallback for qty input variant price
              const jsonSelector = parentElement.querySelector('variant-pill')?.dataset.jsonSelector;
              const jsonElem = jsonSelector ? document.querySelector(jsonSelector) : null;
              if (jsonElem) {
                const data = JSON.parse(jsonElem.textContent);
                const variant = data.variants.find(v => v.id == id);
                if (variant) {
                  qtyInput.dataset.variantPrice = variant.price;
                }
              }
            }
            const inputField = qtyInput.querySelector('input[type="number"]');
            if (inputField) {
              inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content ? this.content.querySelectorAll('[data-btn-variant]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onVariantSelectBound = this.onVariantSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }

      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      this.doAnimate(this.content);
      this.content.focus();
      trapFocus(this.content);
      if (this.items) {
        this.items.forEach(item => {
          item.addEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.button, false);
      if (this.items) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }

    doAnimate(element) {
      try {
        const animationFrames = JSON.parse(this.content.dataset.frames);
        const timing = JSON.parse(this.content.dataset.options);
        if (animationFrames && timing) {
          element.animate(animationFrames, timing);
        }
      } catch (e) {
        console.warn("Animation failed", e);
      }
    }

    onVariantSelect(event) {
      const target = event.currentTarget;
      this.items.forEach(item => item.classList.remove('product-card_select-option--active'));
      target.classList.add('product-card_select-option--active');
      
      const displayElem = this.button.querySelector('[data-current-value]');
      if (displayElem) displayElem.textContent = target.dataset.text;

      const currentDot = this.button.querySelector('[data-current-dot]');
      if (currentDot) {
        const swatchValue = target.style.getPropertyValue('--variant-swatch');
        if (swatchValue) {
          currentDot.style.setProperty('--variant-swatch', swatchValue);
          const focalPoint = target.style.getPropertyValue('--swatch-focal-point');
          if (focalPoint) {
            currentDot.style.setProperty('--swatch-focal-point', focalPoint);
          } else {
            currentDot.style.removeProperty('--swatch-focal-point');
          }
          currentDot.classList.remove('hidden');
        } else {
          currentDot.classList.add('hidden');
        }
      }

      this.setVariantOptions(target.dataset.value);
      this.closeDropdown();
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      onVariantChange(
        this.dataset.jsonSelector,
        currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' || event.target.parentElement.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]') || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.playsInline = true;
            mediaElement.setAttribute('playsinline', '');
            mediaElement.setAttribute('webkit-playsinline', '');
            if (!mediaElement.getAttribute('src')) {
              const source = mediaElement.querySelector('source');
              if (source && (source.src || source.getAttribute('src'))) {
                mediaElement.src = source.src || source.getAttribute('src');
              }
            }
            mediaElement.load();
            const playPromise = mediaElement.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                mediaElement.muted = true;
                mediaElement.setAttribute('muted', '');
                mediaElement.play().catch(() => {});
              });
            }
          } else if (mediaElement.tagName === 'IFRAME') {
            const src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              mediaElement.setAttribute('src', src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`);
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.button) this.button.addEventListener('click', this.loadMediaHandler);
    }
    disconnectedCallback() {
      if (this.button && this.loadMediaHandler) this.button.removeEventListener('click', this.loadMediaHandler);
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  class ProductModel extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      if (this.button) this.button.addEventListener('click', this.loadModel.bind(this));
    }
    loadModel() {
      if (this.getAttribute('loaded') === 'true') return;
      this.setAttribute('loaded', 'true');
      const content = this.template.content.cloneNode(true);
      this.appendChild(content);
      if (typeof window.Shopify !== 'undefined' && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }
      if (window.ProductModel?.loadShopifyXR) {
        window.ProductModel.loadShopifyXR();
      }
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  }
  if (!customElements.get('product-model')) customElements.define('product-model', ProductModel);
  class RecipientForm extends HTMLElement {
    connectedCallback() {
      this.checkboxInput = this.querySelector(`[id*="Recipient-Checkbox"]`);
      this.checkboxInput.disabled = false;
      this.hiddenControlField = this.querySelector(`[id*="Recipient-Control"]`);
      this.hiddenControlField.disabled = true;
      this.emailInput = this.querySelector(`[id*="Recipient-email"]`);
      this.nameInput = this.querySelector(`[id*="Recipient-name"]`);
      this.messageInput = this.querySelector(`[id*="Recipient-message"]`);
      this.sendonInput = this.querySelector(`[id*="Recipient-send-on"]`);
      this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
      this.errorMessageList = this.errorMessageWrapper.querySelector('ul');
      this.errorMessage = this.errorMessageWrapper.querySelector('.error-message');
      this.defaultErrorHeader = this.errorMessage?.innerText;
      this.currentProductVariantId = this.dataset.productVariantId;
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields(flag = false) {
      if (this.emailInput) this.emailInput.value = '';
      if (this.nameInput) this.nameInput.value = '';
      if (this.messageInput) this.messageInput.value = '';
      if (this.sendonInput) this.sendonInput.value = '';
      if (flag) this.checkboxInput.checked = false;
    }

    displayErrorMessage(title, body) {
      this.clearErrorMessage();
      this.errorMessageWrapper.hidden = false;
      if (typeof body === 'object') {
        this.errorMessage.innerText = this.defaultErrorHeader;
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}-${this.dataset.productId}`;
          const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}-${this.dataset.productId}`;
          const label = key.includes('send_on') ? '' : key;
          const message = `${label} ${value}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message');
          if (!errorTextElement) return;
          if (this.errorMessageList)
            this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove('hidden');
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
          inputElement.setAttribute('aria-invalid', true);
          inputElement.setAttribute('aria-describedby', errorMessageId);
        });
      }
      this.errorMessage.innerText = body;
    }

    createErrorListItem(target, message) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.setAttribute('href', target);
      a.innerText = message;
      a.classList.add('errors-list_link');
      li.appendChild(a);
      li.className = 'error-message errors-list_item';
      return li;
    }

    clearErrorMessage() {
      this.errorMessageWrapper.hidden = true;
      if (this.errorMessageList) this.errorMessageList.innerHTML = '';
      this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
        field.classList.add('hidden');
        const textField = field.querySelector('.error-message');
        if (textField) textField.innerText = '';
      });
      [this.emailInput, this.messageInput, this.nameInput].forEach((inputElement) => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
      });
    }

    resetRecipientForm() {
      if (this.checkboxInput.checked) {
        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  if (!customElements.get('recipient-form')) customElements.define('recipient-form', RecipientForm);
  window.Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  class ModalSizeToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = this.closest('modal-size-component') || document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (!modal) return;
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-size-toggler')) customElements.define('modal-size-toggler', ModalSizeToggler);
  class ModalSizeComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-size-component')) customElements.define('modal-size-component', ModalSizeComponent);
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) return this.hideTimer();
      const els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const last = { days: null, hours: null, minutes: null, seconds: null };
      const frames = this.dataset.frames ? JSON.parse(this.dataset.frames) : null;
      const options = this.dataset.options ? JSON.parse(this.dataset.options) : null;
      const doAnimate = (el) => {
        if (!el || !frames || !options) return;
        el.animate(frames, options);
      };
      const hideTimer = () => {
        this.classList.add('hidden');
        if (this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
        const message = this.nextElementSibling;
        if (message?.hasAttribute('data-message')) message.classList.remove('hidden');
      };
      const update = () => {
        const remaining = endDate.getTime() - Date.now();
        if (remaining <= 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          Object.values(els).forEach(el => el && (el.textContent = '0'));
          hideTimer();
          this.dispatchEvent(new Event('timeup'));
          return;
        }
        const current = {
          days: Math.floor(remaining / 864e5),
          hours: Math.floor((remaining % 864e5) / 36e5),
          minutes: Math.floor((remaining % 36e5) / 6e4),
          seconds: Math.floor((remaining % 6e4) / 1e3)
        };
        for (const unit in current) {
          if (els[unit] && last[unit] !== current[unit]) {
            els[unit].textContent = current[unit];
            if (last[unit] !== null) doAnimate(els[unit]);
            last[unit] = current[unit];
          }
        }
      };
      update();
      this.intervalId = setInterval(update, 1000);
    }
    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-stories"] && !Shopify.designMode) return;
  try {
    
  class FeaturedStoriesSlider extends HTMLElement {
    connectedCallback() {
      /* The fade/index/rewind state machine now lives in the nested
         <carousel-slider> (assets/gsap-slider.js) — wait for its Slider
         instance to exist before wiring up the story-specific presentation
         glue (progress bars, Ken-Burns zoom, thumb drag-scroll) on top of it. */
      const waitForSlider = () => {
        const carousel = this.querySelector('carousel-slider');
        if (!carousel || !carousel.slider) {
          requestAnimationFrame(waitForSlider);
          return;
        }
        this.initSlider(carousel.slider);
      };
      waitForSlider();
    }
    initSlider(slider) {
      if (!window.gsap || this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      /* Continuous, self-perpetuating motion (the autoplay timer, the
         Ken-Burns zoom on each advance) is exactly what prefers-reduced-motion
         asks us to drop — matching the rule already followed in
         featured-video.liquid. Manual slide navigation (input-tied, one-shot)
         stays (the crossfade itself is now the shared engine's fade-type
         transition). Reactive via gsap.matchMedia (mirroring
         before-after-content.liquid) rather than a one-shot .matches check,
         so a mid-session OS preference change actually starts/stops the
         autoplay instead of only taking effect after a reload. */
      const autoplayEnabled = this.dataset.autoplay === 'true';
      let reduceMotion = false;
      const interval = parseInt(this.dataset.interval) || 5000;
      const slides = Array.from(this.querySelectorAll('[data-story-slide]'));
      if (slides.length === 0) return;
      this.autoplayTween = null;
      const scrollThumbIntoView = (thumb) => {
        if (!thumb) return;
        const container = thumb.closest('[data-thumbs-container]');
        if (!container) return;
        const thumbLeft = thumb.offsetLeft;
        const thumbWidth = thumb.offsetWidth;
        const containerWidth = container.offsetWidth;
        const targetScrollLeft = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
        container.scrollTo({
          left: Math.max(0, targetScrollLeft),
          behavior: 'smooth'
        });
      };
      const updateAllThumbnails = (activeIdx) => {
        const allThumbs = Array.from(this.querySelectorAll('[data-thumb-slide]'));
        allThumbs.forEach(thumb => {
          const index = parseInt(thumb.dataset.index);
          if (index === activeIdx) {
            thumb.classList.add('is-active');
          } else {
            thumb.classList.remove('is-active');
          }
        });
        const activeSlide = slides[activeIdx];
        if (activeSlide) {
          const activeThumb = activeSlide.querySelector(`[data-thumb-slide][data-index="${activeIdx}"]`);
          if (activeThumb) {
            scrollThumbIntoView(activeThumb);
          }
        }
      };
      const stopAutoplay = () => {
        if (this.autoplayTween) {
          this.autoplayTween.kill();
          this.autoplayTween = null;
        }
        const allBars = Array.from(this.querySelectorAll('[data-thumb-progress-bar]'));
        allBars.forEach(bar => gsap.set(bar, { scaleX: 0 }));
      };
      const playAutoplay = () => {
        if (!autoplayEnabled || reduceMotion) return;
        stopAutoplay();
        const activeSlide = slides[slider.index];
        if (!activeSlide) return;
        const activeThumb = activeSlide.querySelector(`[data-thumb-slide][data-index="${slider.index}"]`);
        if (!activeThumb) return;
        const progressBar = activeThumb.querySelector('[data-thumb-progress-bar]');
        if (!progressBar) return;
        // scaleX instead of width: GPU-composited, no per-frame reflow for
        // the whole autoplay interval.
        gsap.set(progressBar, { scaleX: 0 });
        this.autoplayTween = gsap.to(progressBar, {
          scaleX: 1,
          duration: interval / 1000,
          ease: 'none',
          onComplete: () => {
            goToSlide((slider.index + 1) % slides.length);
          }
        });
      };
      const resetAllThumbs = () => {
        const allThumbs = Array.from(this.querySelectorAll('[data-thumb-slide]'));
        allThumbs.forEach(thumb => {
          gsap.to(thumb, { x: 0, y: 0, duration: 0.35, ease: 'power2.out', overwrite: 'auto' });
        });
      };
      // Runs on every move regardless of trigger (thumb click, autoplay
      // completion, or the engine's own goTo) so thumb highlighting and the
      // next autoplay cycle always stay in sync with the real active slide.
      slider.on('moved', () => {
        resetAllThumbs();
        updateAllThumbnails(slider.index);
        playAutoplay();
      });
      updateAllThumbnails(slider.index);
      const goToSlide = (nextIndex, opts) => {
        /* Previously also bailed on `!slider.state.isIdle`, which blocked any
           click made during the ~0.5s crossfade — since the engine's fade
           tweens already run with overwrite: 'auto' (see gsap-slider.js
           setFadeState/animateToDomIndex), a new target can safely interrupt
           an in-flight one, so gating on the current index is enough. */
        if (nextIndex === slider.index) return;
        stopAutoplay();
        resetAllThumbs();
        if (!reduceMotion) {
          const nextImages = slides[nextIndex].querySelectorAll('[data-story-image]');
          if (nextImages.length > 0) {
            gsap.fromTo(nextImages, { scale: 1.08 }, { scale: 1, duration: 1.2, ease: 'power2.out' });
          }
        }
        slider.go(nextIndex, opts);
      };
      let isDraggingThumb = false;
        let dragStartX = 0;
        // container.setPointerCapture() below (needed so the drag multiplier
        // keeps tracking the pointer once it leaves the container's bounds)
        // has a Chrome quirk: once a pointer is captured, the *click* event's
        // target gets retargeted to the capturing element too, not just the
        // pointer events. That breaks `e.target.closest('[data-thumb-slide]')`
        // in the click handler below, because `.closest()` only walks UP from
        // the target, and the retargeted target (the container) sits ABOVE
        // the button, not inside it — so a plain, no-movement click on a
        // thumbnail silently resolved to nothing. Recording the real target
        // at pointerdown time, before capture is set, sidesteps it.
        let pointerDownThumb = null;
        const containers = this.querySelectorAll('[data-thumbs-container]');
        containers.forEach(container => {
          let isDown = false;
          let startX = 0;
          let scrollLeftPos = 0;
          let activePointerId = null;
          const endDrag = () => {
            if (!isDown) return;
            isDown = false;
            if (activePointerId !== null && container.hasPointerCapture(activePointerId)) {
              container.releasePointerCapture(activePointerId);
            }
            activePointerId = null;
            container.classList.remove('is-dragging');
            resetAllThumbs();
          };
          container.addEventListener('pointerdown', (e) => {
            // Touch already drag-scrolls natively via overflow-x + -webkit-overflow-scrolling;
            // only mouse/pen get the custom drag multiplier below.
            if (e.pointerType === 'touch') return;
            isDown = true;
            isDraggingThumb = false;
            pointerDownThumb = e.target.closest('[data-thumb-slide]');
            activePointerId = e.pointerId;
            dragStartX = e.pageX;
            startX = e.pageX - container.offsetLeft;
            scrollLeftPos = container.scrollLeft;
            container.setPointerCapture(activePointerId);
            container.classList.add('is-dragging');
          });
          container.addEventListener('pointermove', (e) => {
            if (!isDown || e.pointerId !== activePointerId) return;
            if (Math.abs(e.pageX - dragStartX) > 5) {
              isDraggingThumb = true;
            }
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 1.5;
            container.scrollLeft = scrollLeftPos - walk;
          });
          container.addEventListener('pointerup', endDrag);
          container.addEventListener('pointercancel', endDrag);
          container.addEventListener('lostpointercapture', endDrag);
          container.addEventListener('wheel', (e) => {
            if (e.deltaY !== 0) {
              container.scrollLeft += e.deltaY;
            }
          }, { passive: true });
        });
        this.addEventListener('pointermove', (e) => {
          if (reduceMotion || isDraggingThumb || e.pointerType !== 'mouse') return;
          const thumbBtn = e.target.closest('[data-thumb-slide]');
          if (!thumbBtn || !this.contains(thumbBtn)) return;
          const rect = thumbBtn.getBoundingClientRect();
          const maxPull = 10;
          const strength = 0.3;
          const x = Math.max(-maxPull, Math.min(maxPull, (e.clientX - rect.left - rect.width / 2) * strength));
          const y = Math.max(-maxPull, Math.min(maxPull, (e.clientY - rect.top - rect.height / 2) * strength));
          gsap.to(thumbBtn, { x: x, y: y, duration: 0.3, ease: 'power2.out', overwrite: 'auto' });
        });
        this.addEventListener('pointerout', (e) => {
          if (e.pointerType !== 'mouse') return;
          const thumbBtn = e.target.closest('[data-thumb-slide]');
          if (!thumbBtn || (e.relatedTarget && thumbBtn.contains(e.relatedTarget))) return;
          gsap.to(thumbBtn, { x: 0, y: 0, duration: 0.4, ease: 'power3.out', overwrite: 'auto' });
        });
        this.addEventListener('click', (e) => {
          if (isDraggingThumb) {
            isDraggingThumb = false;
            pointerDownThumb = null;
            return;
          }
          const thumbBtn = pointerDownThumb || e.target.closest('[data-thumb-slide]');
          pointerDownThumb = null;
          if (thumbBtn) {
            const targetIndex = parseInt(thumbBtn.dataset.index);
            if (!isNaN(targetIndex)) {
              goToSlide(targetIndex, { userInitiated: true });
            }
          }
        });
      this.mm = gsap.matchMedia();
      this.mm.add('(prefers-reduced-motion: reduce)', () => {
        reduceMotion = true;
        stopAutoplay();
        return () => {
          reduceMotion = false;
          playAutoplay();
        };
      });
      playAutoplay();
      // Stored on the instance (rather than only closed over) so the
      // module-level shopify:block:select listener below can reach this
      // slider's own goToSlide without needing its own per-instance listener.
      this._goToSlide = goToSlide;
    }
    disconnectedCallback() {
      /* Mirrors <before-after>'s disconnectedCallback: kill the in-flight
         autoplay tween and revert the matchMedia instance connectedCallback/
         initSlider created above, so removing/replacing this element (e.g. a
         theme-editor section reload) doesn't leak either. */
      if (this.autoplayTween) {
        this.autoplayTween.kill();
        this.autoplayTween = null;
      }
      if (this.mm) {
        this.mm.revert();
        this.mm = null;
      }
    }
  }
  if (!customElements.get('featured-stories-slider')) {
    customElements.define('featured-stories-slider', FeaturedStoriesSlider);
  }
  /* Single delegated listener instead of one per <featured-stories-slider>
     instance — the theme editor recreates this custom element (and its
     initSlider closure) on every shopify:section:load, and a listener added
     per-instance with no matching removal would keep piling up on document,
     each one holding a reference to an old, now-detached slider. Bind once
     at module scope and, on every fire, look up whichever currently-
     connected instances opted into go-to (data-go-to="true"). */
  if (!document.__fsBlockSelectBound) {
    document.__fsBlockSelectBound = true;
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail?.blockId || event.target?.dataset?.blockId;
      if (!blockId) return;
      document.querySelectorAll('featured-stories-slider[data-go-to="true"]').forEach((el) => {
        if (typeof el._goToSlide !== 'function') return;
        const targetSlide = el.querySelector(`[id$="${blockId}"]`);
        if (!targetSlide) return;
        const slides = Array.from(el.querySelectorAll('[data-story-slide]'));
        const index = slides.indexOf(targetSlide);
        if (index !== -1) el._goToSlide(index, { userInitiated: true });
      });
    });
  }
  /* ── Section entrance reveal ──────────────────────────────────────── */
  function playFeaturedStoriesReveal(section) {
    var _M = window.themeMotion || {};
    var areaWrap  = section.querySelector('.featured-stories_area-wrap');
    var headCol   = section.querySelector('.featured-stories_heading-col');
    var heading   = headCol && headCol.querySelector('.featured-stories_heading');
    var desc      = section.querySelector('.featured-stories_description');
    var thumbWrap = section.querySelector('.featured-stories_thumbs-container, [class*="_thumbs-container"]');

    var tl = window.gsap.timeline({ defaults: { overwrite: 'auto' } });

    /* headCol only carries the positional slide now — the heading's own
       opacity/reveal is delegated entirely to its themeSplitHeading split
       below, same separation of concerns as the clip-wrap + split combo
       used in featured-video/promotional-hero-banner. */
    if (headCol) {
      window.gsap.set(headCol, { x: -48 });
      tl.to(headCol, {
        x: 0,
        duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out'
      }, 0.25);
    }
    if (heading) {
      var headingSplit = window.themeSplitHeading && window.themeSplitHeading(heading);
      if (headingSplit && headingSplit.targets !== heading) {
        window.gsap.set(headingSplit.targets, headingSplit.fromVars);
        tl.to(headingSplit.targets, Object.assign({}, headingSplit.toVars, {
          duration: headingSplit.duration, ease: headingSplit.ease, stagger: headingSplit.stagger
        }), 0.4);
      } else {
        window.gsap.set(heading, { opacity: 0, y: 20 });
        tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.4);
      }
    }
    if (desc) {
      var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
      if (descSplit && descSplit.targets !== desc) {
        window.gsap.set(descSplit.targets, descSplit.fromVars);
        tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
          duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
        }), 0.55);
      } else {
        window.gsap.set(desc, { opacity: 0, y: 20 });
        tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.55);
      }
    }
    if (thumbWrap) {
      var thumbs = thumbWrap.querySelectorAll('[data-thumb-slide]');
      if (thumbs.length) {
        window.gsap.set(thumbs, { opacity: 0, y: 36 });
        tl.to(thumbs, {
          opacity: 1, y: 0,
          duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.tight) || 0.06
        }, 0.7);
      }
    }
  }

  /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
     replays every time the section scrolls back into view, instead of
     firing once and staying done forever. onEnter also covers the section
     already being in view when the trigger is created. Falls back to
     playing immediately if ScrollTrigger never loads, matching the
     previous behavior when window.ScrollTrigger was unavailable. Extracted
     into its own named function (rather than inline in a forEach) so a
     single section can be killed-and-rebuilt on shopify:section:load
     without touching any other .featured-stories instance on the page. */
  function initFeaturedStoriesSection(section) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    if (!window.gsap) return;
    var _M = window.themeMotion || {};
    if (!window.ScrollTrigger) { playFeaturedStoriesReveal(section); return; }
    window.gsap.registerPlugin(window.ScrollTrigger);
    var triggerId = 'featured-stories-reveal-' + (section.id || 'static');
    window.ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars && t.vars.id === triggerId) t.kill();
    });
    window.ScrollTrigger.create({
      id: triggerId,
      trigger: section,
      start: (_M.trigger && _M.trigger.start) || 'top 82%',
      end: 'bottom top',
      // Without this, this trigger defaults to refreshPriority 0, which
      // outranks any pinned section's negative priority above it, so it
      // could refresh — locking in a stale start/end — before sibling
      // pinned sections finish resolving their own pin-spacer heights on
      // the same refresh pass.
      refreshPriority: window.themeScrollPriority(section),
      onEnter: function () { playFeaturedStoriesReveal(section); },
      onEnterBack: function () { playFeaturedStoriesReveal(section); }
    });
  }

  window.onThemeGsapReady(function () {
    document.querySelectorAll('.featured-stories').forEach(initFeaturedStoriesSection);
  });

  /* shopify:section:load fires for ANY section reloading in the theme
     editor, not just this one. Reinitializing every featured-stories
     instance on the page in response to an unrelated section edit would
     kill and rebuild ScrollTriggers that had nothing to do with the edit.
     Scope the reinit to the section that actually reloaded, and re-guard
     with onThemeGsapReady since this listener lives outside the initial
     ready callback above and GSAP may not have finished loading yet. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('featured-stories')
      ? root
      : (root && root.querySelector ? root.querySelector('.featured-stories') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initFeaturedStoriesSection(section); });
  });

  /* Outright section removal (as opposed to an edit, which fires
     shopify:section:load instead): kill this instance's own reveal
     ScrollTrigger by id rather than relying only on ScrollTrigger's own
     detached-element cleanup on next refresh. Matches
     sections/before-after-content.liquid's pattern. */
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('featured-stories')
      ? root
      : (root && root.querySelector ? root.querySelector('.featured-stories') : null);
    if (!section || !section.id || !window.ScrollTrigger) return;
    var triggerId = 'featured-stories-reveal-' + section.id;
    window.ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars && t.vars.id === triggerId) t.kill();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playSectionVideo(section) {
      if (window.innerWidth < 768) return;
      var deferredMedia = section.querySelector('deferred-media');
      if (!deferredMedia) return;

      var triggerPlay = function () {
        var video = deferredMedia.querySelector('video');
        if (video) {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          if (video.paused) {
            video.play().catch(function () {});
          }
        }
        var youtube = deferredMedia.querySelector('.js-youtube');
        if (youtube && youtube.contentWindow) {
          youtube.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
          youtube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        var vimeo = deferredMedia.querySelector('.js-vimeo');
        if (vimeo && vimeo.contentWindow) {
          vimeo.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
          vimeo.contentWindow.postMessage('{"method":"play"}', '*');
        }
      };

      if (deferredMedia.getAttribute('loaded') !== 'true') {
        if (typeof deferredMedia.loadMediaHandler === 'function') {
          deferredMedia.loadMediaHandler();
        } else {
          var btn = deferredMedia.querySelector('[data-deferred-media-toggler]');
          if (btn) btn.click();
        }
        requestAnimationFrame(triggerPlay);
      } else {
        triggerPlay();
      }
    }

    function pauseSectionVideo(section) {
      if (typeof window.pauseElementBasedMedia === 'function') {
        window.pauseElementBasedMedia(section);
      } else {
        var video = section.querySelector('video');
        if (video) video.pause();
        var youtube = section.querySelector('.js-youtube');
        if (youtube && youtube.contentWindow) {
          youtube.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        var vimeo = section.querySelector('.js-vimeo');
        if (vimeo && vimeo.contentWindow) {
          vimeo.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }
    }

    function initFeaturedVideoSection() {
      var gsap = window.gsap;
      var ST = window.ScrollTrigger;
      if (!gsap || !ST) return;
      gsap.registerPlugin(ST);

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var pulses = new WeakMap();

    /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
       from each trigger's live document position — see hero-banner/collection-list
       for the same pattern. Without this these triggers default to priority 0,
       which refreshes before any pinned section above it accounts for its
       pin-spacer, so this section's cached trigger position can end up too high
       on the page and the reveal fires before the user actually scrolls to it. */
    function scrollPinPriority(el) {
      return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
    }

    /* Clears any GSAP-managed inline styles and kills this section's own
       parallax trigger/pulses before re-running init — needed so reopening
       the theme editor on this section, or scrolling back into it, doesn't
       stack a second reveal on top of the first or leak an infinite pulse
       tween. The entrance ScrollTrigger itself ('fv-entrance-' + id) lives
       outside initSection (see initFeaturedVideoEntrance below) and isn't
       killed here — killing it from inside the very callback it's
       currently dispatching would be unsafe. */
    function resetSection(section) {
      ST.getAll().forEach(function(t) {
        var id = t.vars && t.vars.id;
        if (id === 'fvparallax-' + section.id) t.kill();
      });

      [
        section.querySelector('.featured-video_wrapper'),
        section.querySelector('.deferred-media_btn-toggler .object-fit'),
        section.querySelector('.video-card_heading'),
        section.querySelector('.video-card_description'),
        section.querySelector('.deferred-media_play-btn'),
        section.querySelector('.product-item')
      ].filter(Boolean).forEach(function(el) {
        var pulseTl = pulses.get(el);
        if (pulseTl) { pulseTl.kill(); pulses.delete(el); }
        gsap.set(el, { clearProps: 'opacity,transform,x,y,scale,rotate,yPercent,xPercent,skewX,filter' });
      });
    }

    /* Idle "breathing" loop on the play button once the entrance finishes, to
       keep drawing the eye toward it. Pauses on hover/focus so it doesn't
       fight the magnetic follow below, and stops for good once clicked.
       Interaction listeners are bound once (dataset-guarded) since toggler
       stays in the DOM across replays; the pulse timeline itself is
       recreated fresh on every call (resetSection kills the previous one
       first) and every listener looks it up fresh via pulses.get(playBtn)
       rather than closing over a specific instance, so they keep acting on
       whichever pulse is current instead of a stale, already-killed one
       from an earlier entrance. */
    function startPulse(toggler, playBtn, wrapper) {
      if (reduceMotion || pulses.has(playBtn)) return;

      var pulseTl = gsap.timeline({ repeat: -1, yoyo: true, defaults: { duration: 1.2, ease: 'sine.inOut' } });
      pulseTl.to(playBtn, { scale: 1.08 });
      pulses.set(playBtn, pulseTl);

      if (toggler.dataset.fvPulseBound) return;
      toggler.dataset.fvPulseBound = '1';

      /* Pause pulse on hover so it doesn't fight press/click tweens */
      if (pointerFine && wrapper) {
        wrapper.addEventListener('mouseenter', function () {
          var _pTl = pulses.get(playBtn);
          if (_pTl) _pTl.pause();
        });
        wrapper.addEventListener('mouseleave', function () {
          gsap.to(playBtn, { scale: 1, duration: 0.3, ease: 'power3.out', overwrite: 'auto',
            onComplete: function () {
              var _pTl = pulses.get(playBtn);
              if (_pTl) _pTl.resume();
            }
          });
        });
      }

      if (pointerFine) {
        toggler.addEventListener('mouseenter', function() {
          var _pTl = pulses.get(playBtn);
          if (_pTl) _pTl.pause();
          gsap.to(playBtn, { scale: 1, duration: 0.3, ease: 'power2.out' });
        });
        toggler.addEventListener('focus', function() {
          var _pTl = pulses.get(playBtn);
          if (_pTl) _pTl.pause();
        });
        toggler.addEventListener('mouseleave', function() {
          var _pTl = pulses.get(playBtn);
          if (_pTl) _pTl.resume();
        });
        toggler.addEventListener('blur', function() {
          var _pTl = pulses.get(playBtn);
          if (_pTl) _pTl.resume();
        });
      }
      toggler.addEventListener('click', function() {
        var _pTl = pulses.get(playBtn);
        if (_pTl) _pTl.kill();
        pulses.delete(playBtn);
      }, { once: true });
    }

    /* Play button chases the cursor across the full video section rather
       than sticking directly under it — a slow catch-up duration keeps it
       trailing a bit behind before it closes the gap, but the target offset
       always lands the button's own center exactly on the cursor (clamped
       near the toggler's edges) so once it catches up it's sitting right
       under the pointer and clickable there. It also leads slightly further
       in whichever direction the cursor is currently traveling, easing back
       to sitting exactly on the cursor once it holds still. Meanwhile the
       black triangle icon inside it rotates like a compass needle to keep
       aiming at the cursor. Both bounce back to their original position and
       angle the moment the cursor leaves. */
    function magneticButton(toggler, playBtn) {
      if (reduceMotion || toggler.dataset.fvMagnetic) return;
      toggler.dataset.fvMagnetic = '1';

      var EDGE_MARGIN_RATIO = 0.12;
      var LEAD_FACTOR = 3;
      var MAX_LEAD = 20;
      var STILL_DELAY = 120;
      var iconEl = playBtn.querySelector('svg');
      var xTo, yTo, rotateTo;
      var restOffsetX = 0, restOffsetY = 0, prevClientX = 0, prevClientY = 0, iconRotation = 0;
      var lastTargetX = 0, lastTargetY = 0, stillTimer = null, needsFreshSetters = false;

      /* quickTo reuses one persistent tween per setter; once the bounce-back
         tween below overwrites it, that persistent tween can't be trusted to
         keep animating on the next hover. Rebuilding every setter from
         scratch on every entry sidesteps that entirely, so the chase is
         guaranteed to work identically on the 1st, 2nd, and every later
         hover instead of only the first. */
      function createSetters() {
        xTo = gsap.quickTo(playBtn, 'x', { duration: 1.1, ease: 'power2.out' });
        yTo = gsap.quickTo(playBtn, 'y', { duration: 1.1, ease: 'power2.out' });
        if (iconEl) rotateTo = gsap.quickTo(iconEl, 'rotation', { duration: 0.35, ease: 'power2.out' });
      }
      createSetters();

      /* The chase itself stays on a plain, non-overshoot ease so the button
         visibly trails a step behind the cursor while it's moving — an
         elastic ease there front-loads almost all its travel instantly,
         which reads as the button being glued to the pointer instead of
         following it. The bounce is reserved for the moment the cursor
         actually stops: once no mousemove has landed for STILL_DELAY ms,
         this settles the button onto the last target with an overshoot so
         it reads as catching up and springing into place. It overwrites
         xTo/yTo's persistent tween, so the next mousemove has to rebuild
         them via createSetters() (see the comment above) rather than
         reusing the now-invalid ones. */
      function settleWithBounce() {
        gsap.killTweensOf(playBtn, 'x,y');
        gsap.to(playBtn, { x: lastTargetX, y: lastTargetY, duration: 0.6, ease: 'elastic.out(1, 0.35)' });
        needsFreshSetters = true;
      }

      toggler.addEventListener('mouseenter', function(e) {
        clearTimeout(stillTimer);
        needsFreshSetters = false;
        gsap.killTweensOf(playBtn, 'x,y');
        gsap.set(playBtn, { x: 0, y: 0 });
        if (iconEl) { gsap.killTweensOf(iconEl, 'rotation'); gsap.set(iconEl, { rotation: 0 }); }
        createSetters();
        prevClientX = e.clientX;
        prevClientY = e.clientY;
        lastTargetX = 0;
        lastTargetY = 0;
        iconRotation = 0;

        /* The button's own resting center rarely matches the toggler's
           geometric center — layout_style/content_alignment can park it
           anywhere in the card. Measuring it fresh (now that it's reset to
           0,0) is what lets the offset below land exactly on the cursor
           instead of carrying a baked-in mismatch toward wherever the
           button actually sits. Stored relative to the toggler's own rect
           (rather than as raw viewport coordinates) so it keeps tracking
           correctly if the page scrolls mid-hover instead of going stale. */
        var btnRect = playBtn.getBoundingClientRect();
        var togglerRect = toggler.getBoundingClientRect();
        restOffsetX = (btnRect.left + btnRect.width / 2) - togglerRect.left;
        restOffsetY = (btnRect.top + btnRect.height / 2) - togglerRect.top;
      });
      toggler.addEventListener('mousemove', function(e) {
        clearTimeout(stillTimer);
        if (needsFreshSetters) { createSetters(); needsFreshSetters = false; }

        var rect = toggler.getBoundingClientRect();
        var restX = rect.left + restOffsetX;
        var restY = rect.top + restOffsetY;
        var marginX = rect.width * EDGE_MARGIN_RATIO;
        var marginY = rect.height * EDGE_MARGIN_RATIO;
        var dx = e.clientX - restX;
        var dy = e.clientY - restY;

        /* The button's rest position is rarely the toggler's geometric
           center (see comment above), so the room to travel before hitting
           an edge differs on each side. Clamping symmetrically around 0
           would cut the chase short on the side with more room and let it
           overshoot the toggler on the side with less, so the bounds below
           are computed straight from the toggler's actual edges relative to
           restX/restY instead. */
        var minOffsetX = rect.left + marginX - restX;
        var maxOffsetX = rect.right - marginX - restX;
        var minOffsetY = rect.top + marginY - restY;
        var maxOffsetY = rect.bottom - marginY - restY;

        /* Extra push in whichever direction the cursor is travelling this
           frame, on top of the base cursor-locked offset. Since it's driven
           by the frame-to-frame delta it naturally shrinks to 0 as the
           cursor slows down, so the button still ends up landing exactly on
           the cursor once it stops rather than staying overshot. */
        var leadX = gsap.utils.clamp(-MAX_LEAD, MAX_LEAD, (e.clientX - prevClientX) * LEAD_FACTOR);
        var leadY = gsap.utils.clamp(-MAX_LEAD, MAX_LEAD, (e.clientY - prevClientY) * LEAD_FACTOR);
        prevClientX = e.clientX;
        prevClientY = e.clientY;

        lastTargetX = gsap.utils.clamp(minOffsetX, maxOffsetX, dx + leadX);
        lastTargetY = gsap.utils.clamp(minOffsetY, maxOffsetY, dy + leadY);
        xTo(lastTargetX);
        yTo(lastTargetY);
        stillTimer = setTimeout(settleWithBounce, STILL_DELAY);

        /* Aim the icon at the cursor using dx/dy straight from the button's
           resting center (not the lead-boosted offset above, which is about
           position overshoot and would just add jitter to the angle). The
           target angle is unwrapped against the last rotation so it always
           turns the short way instead of spinning the long way round every
           time it crosses the +/-180 boundary. */
        if (iconEl && (dx || dy)) {
          var targetAngle = Math.atan2(dy, dx) * (180 / Math.PI);
          iconRotation += ((targetAngle - iconRotation + 180) % 360 + 360) % 360 - 180;
          rotateTo(iconRotation);
        }
      });
      toggler.addEventListener('mouseleave', function() {
        clearTimeout(stillTimer);
        needsFreshSetters = false;
        gsap.killTweensOf(playBtn, 'x,y');
        gsap.to(playBtn, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1, 0.4)' });
        if (iconEl) {
          gsap.killTweensOf(iconEl, 'rotation');
          /* Settle on whichever multiple of 360 is nearest the current
             winding so it snaps back the short way, not the long way
             around, before the angle resets to 0 on the next entry. */
          var nearestZero = Math.round(iconRotation / 360) * 360;
          gsap.to(iconEl, { rotation: nearestZero, duration: 0.8, ease: 'elastic.out(1, 0.4)' });
        }
      });
    }

    /* Slow scrub parallax on the poster image as the video scrolls through
       the viewport. Reuses the data-motion-parallax intensity authored on
       .video-card. Returns the base scale it set, so a hover zoom can start
       from the same value instead of clobbering it. */
    function parallaxPoster(section) {
      var videoCard = section.querySelector('.video-card');
      var poster = section.querySelector('.deferred-media_btn-toggler .object-fit');
      if (!videoCard || !poster) return null;

      var intensity = parseFloat(videoCard.dataset.motionParallax) || 0.06;
      var baseScale = 1 + intensity * 2;
      gsap.set(poster, { scale: baseScale, transformOrigin: 'center center' });

      gsap.fromTo(poster,
        { yPercent: -intensity * 100 },
        {
          yPercent: intensity * 100,
          ease: 'none',
          scrollTrigger: {
            id: 'fvparallax-' + section.id,
            trigger: videoCard,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            refreshPriority: scrollPinPriority(videoCard)
          }
        }
      );
      return { poster: poster, baseScale: baseScale };
    }

    /* Small extra push-in on the poster while the poster is hovered, layered
       on top of the static parallax scale set above — a different tween
       target (scale vs. the parallax's yPercent) so the two never fight. */
    function hoverZoomPoster(toggler, poster, baseScale) {
      if (reduceMotion || toggler.dataset.fvHoverZoom) return;
      toggler.dataset.fvHoverZoom = '1';

      var zoomTo = gsap.quickTo(poster, 'scale', { duration: 0.6, ease: 'power2.out' });
      toggler.addEventListener('mouseenter', function() { zoomTo(baseScale * 1.045); });
      toggler.addEventListener('mouseleave', function() { zoomTo(baseScale); });
    }

    /* Tactile squeeze on the play button for the moment between press and
       release, so the click reads as a physical button rather than a flat
       hit target. mouseenter already pauses the idle pulse before this can
       fire, so there's no fight over the shared scale property. */
    function pressFeedback(toggler, playBtn) {
      if (reduceMotion || toggler.dataset.fvPress) return;
      toggler.dataset.fvPress = '1';

      toggler.addEventListener('mousedown', function() {
        var _pTl = pulses.get(playBtn);
        if (_pTl) _pTl.pause();
        gsap.to(playBtn, { scale: 0.88, duration: 0.18, ease: 'power2.out', overwrite: 'auto' });
      });
      toggler.addEventListener('mouseup', function() {
        gsap.to(playBtn, { scale: 1, duration: 0.35, ease: 'back.out(2)', overwrite: 'auto',
          onComplete: function () { var _pTl = pulses.get(playBtn); if (_pTl) _pTl.play(); }
        });
      });
    }

    function initSection(section) {
      resetSection(section);

      var wrapper = section.querySelector('.featured-video_wrapper');
      var heading = section.querySelector('.video-card_heading');
      var desc = section.querySelector('.video-card_description');
      var playBtn = section.querySelector('.deferred-media_play-btn');
      var toggler = section.querySelector('.deferred-media_btn-toggler');
      var card = section.querySelector('.product-item');
      if (!wrapper) return;

      /* Continuous / input-tied motion (cursor-follow, infinite pulse, scroll
         scrub) is exactly what prefers-reduced-motion asks us to drop, so it's
         skipped outright rather than toned down. */
      if (!reduceMotion) {
        /* magneticButton/pressFeedback/hoverZoomPoster are all mousemove-/
           mouseenter-driven — pointless listeners on touch devices, which
           rarely fire them, matching the pointer:fine gate already used for
           the same class of effect in multicolumn.liquid/image-gallery.liquid. */
        if (pointerFine && toggler && playBtn) {
          magneticButton(toggler, playBtn);
          pressFeedback(toggler, playBtn);
        }
        var parallax = parallaxPoster(section);
        if (pointerFine && toggler && parallax) hoverZoomPoster(toggler, parallax.poster, parallax.baseScale);
      }

      /* A simple one-time opacity fade is still widely considered acceptable
         under reduced motion, so the entrance keeps that much rather than
         disabling the section's reveal entirely — only the large transforms
         (clip-path wipe, off-screen slide, scale/rotate pop) are dropped. */
      if (reduceMotion) {
        gsap.set(wrapper, { opacity: 0 });
        if (heading) gsap.set(heading, { opacity: 0 });
        if (desc) gsap.set(desc, { opacity: 0 });
        if (playBtn) gsap.set(playBtn, { opacity: 0 });
        if (card) gsap.set(card, { opacity: 0 });

        var reducedTl = gsap.timeline({ defaults: { overwrite: 'auto' } });
        reducedTl.to(wrapper, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 0);
        if (heading) reducedTl.to(heading, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 0.1);
        if (desc) reducedTl.to(desc, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 0.15);
        if (playBtn) reducedTl.to(playBtn, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 0.2);
        if (card) reducedTl.to(card, { opacity: 1, duration: 0.6, ease: 'power1.out' }, 0.25);
        return;
      }

      gsap.set(wrapper, { opacity: 0 });
      var headingSplit = window.themeSplitHeading(heading);
      var descSplit = window.themeSplitHeading(desc);
      if (heading) gsap.set(headingSplit.targets, headingSplit.fromVars);
      if (desc) gsap.set(descSplit.targets, descSplit.fromVars);
      if (playBtn) gsap.set(playBtn, { scale: 0, rotate: -20, transformOrigin: 'center center' });

      var cardStartX = 0;
      if (card) {
        if (card.classList.contains('top-right') || card.classList.contains('bottom-right')) {
          cardStartX = window.innerWidth;
        } else if (card.classList.contains('top-left') || card.classList.contains('bottom-left')) {
          cardStartX = -window.innerWidth;
        }
        gsap.set(card, cardStartX !== 0 ? { x: cardStartX, opacity: 0 } : { opacity: 0 });
      }

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      /* Wired to the Motion Design System settings (window.themeMotion) like
         every other section's entrance timeline — this used to hardcode its
         own numbers regardless of the merchant's Base Animation Duration /
         Entrance Ease / Clip-path Reveal Ease settings. Fallback literals
         match the previous hardcoded defaults, so nothing changes visually
         until a merchant actually adjusts those settings. */
      var _M = window.themeMotion || {};
      tl.to(wrapper, { opacity: 1, duration: (_M.dur && _M.dur.xslow) || 1.2, ease: (_M.ease && _M.ease.reveal) || 'expo.out' }, 0);
      /* headingSplit/descSplit.cleanup (split.revert()) is deliberately never
         called here — the split spans need to stay in the DOM so this
         reveal has valid targets to animate on every replay. */
      if (heading) tl.to(headingSplit.targets, Object.assign({}, headingSplit.toVars, { duration: headingSplit.duration, stagger: headingSplit.stagger, ease: headingSplit.ease }), 0.3);
      if (desc) tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, { duration: descSplit.duration, stagger: descSplit.stagger, ease: descSplit.ease }), 0.42);
      if (playBtn) tl.to(playBtn, { scale: 1, rotate: 0, duration: (_M.dur && _M.dur.slow) || 1, ease: 'back.out(1.8)' }, 0.5);
      if (card) {
        tl.to(card, { x: 0, opacity: 1, duration: (_M.dur && _M.dur.slow) || 1, ease: (_M.ease && _M.ease.enter) || 'power3.out' }, 0.65);
      }
      if (playBtn && toggler) {
        tl.call(function() { startPulse(toggler, playBtn, wrapper); });
      }
    }

    /* Gates initSection() behind a ScrollTrigger with onEnter/onEnterBack so
       the entrance replays every time the section scrolls back into view,
       instead of firing once. onEnter also covers the section already
       being in view when the trigger is created. Uses its own id
       ('fv-entrance-' + id) separate from resetSection's kill-list, since
       resetSection runs from inside initSection — killing the trigger that's
       actively dispatching the callback running it would be unsafe. */
    function initFeaturedVideoEntrance(section) {
      var wrapper = section.querySelector('.featured-video_wrapper');
      if (!wrapper) return;
      var triggerId = 'fv-entrance-' + section.id;
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      var trigger = ST.create({
        id: triggerId,
        trigger: section,
        start: (window.themeMotion && window.themeMotion.trigger && window.themeMotion.trigger.start) || 'top 82%',
        end: 'bottom top',
        refreshPriority: scrollPinPriority(section),
        onEnter: function () {
          initSection(section);
          if (section.dataset.videoAutoplay === 'true') {
            playSectionVideo(section);
          }
        },
        onEnterBack: function () {
          initSection(section);
          if (section.dataset.videoAutoplay === 'true') {
            playSectionVideo(section);
          }
        },
        onLeave: function () {
          if (section.dataset.videoAutoplay === 'true') {
            pauseSectionVideo(section);
          }
        },
        onLeaveBack: function () {
          if (section.dataset.videoAutoplay === 'true') {
            pauseSectionVideo(section);
          }
        }
      });

      if (trigger.isActive && section.dataset.videoAutoplay === 'true') {
        playSectionVideo(section);
      }
    }

    function initAll() {
      document.querySelectorAll('.featured-video').forEach(initFeaturedVideoEntrance);
    }

    initAll();

    /* shopify:section:load fires for any section reloading in the editor,
       not just this one — scope the reinit to the section that actually
       reloaded so unrelated edits elsewhere don't restart this animation. */
    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target;
      var section = root && root.classList && root.classList.contains('featured-video')
        ? root
        : (root && root.querySelector ? root.querySelector('.featured-video') : null);
      if (!section) return;
      initFeaturedVideoEntrance(section);
    });

    document.addEventListener('shopify:section:reorder', function() {
      initAll();
    });
  }

  function initFeaturedVideoAutoplayFallback() {
    if (!window.IntersectionObserver) return;
    document.querySelectorAll('.featured-video[data-video-autoplay="true"]').forEach(function (section) {
      if (section._fvObserver) return;
      var deferredMedia = section.querySelector('deferred-media');
      if (!deferredMedia) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.innerWidth >= 768 && entry.isIntersecting) {
            playSectionVideo(section);
          } else {
            if (typeof window.pauseElementBasedMedia === 'function') {
              window.pauseElementBasedMedia(section);
            }
          }
        });
      }, { threshold: 0.1 });
      observer.observe(section);
      section._fvObserver = observer;
    });
  }

  if (window.onThemeGsapReady) {
    window.onThemeGsapReady(initFeaturedVideoSection);
  } else {
    document.addEventListener('DOMContentLoaded', initFeaturedVideoSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedVideoAutoplayFallback);
  } else {
    initFeaturedVideoAutoplayFallback();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 480,
        fill: 'forwards',
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 420,
      fill: 'forwards',
      easing: 'cubic-bezier(0.65, 0, 0.35, 1)',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class CartDrawerDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-drawer-dropdown')) {
    customElements.define('cart-drawer-dropdown', CartDrawerDropdown);
  }
  class CartWidgetDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeBtns = this.querySelectorAll('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
      if (this.closeBtns.length) {
        this.closeBtns.forEach((closeBtn) => {
          closeBtn.addEventListener('click', () => {
            this.closeDropdown();
          });
        });
      }
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const getCartModalBody = () => self.closest('.modal-component_body') || null;
      const showCartOverlay = () => {
        const cartBody = getCartModalBody();
        if (!cartBody) return;
        let overlay = cartBody.querySelector('.cart-widget-overlay');
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'cart-widget-overlay';
          overlay.setAttribute('aria-hidden', 'true');
          Object.assign(overlay.style, {
            position: 'absolute',
            inset: '0',
            background: 'rgba(0,0,0,0.70)',
            zIndex: '10',
            pointerEvents: 'all',
            cursor: 'default',
            opacity: '0',
            transition: 'opacity 0.25s ease',
          });
          cartBody.style.position = 'relative';
          cartBody.appendChild(overlay);
        }
        requestAnimationFrame(() => { overlay.style.opacity = '1'; });
        overlay.addEventListener('click', (e) => {
          e.stopPropagation();
          closeDropdown();
        }, { once: true });
      };
      const hideCartOverlay = () => {
        const cartBody = getCartModalBody();
        if (!cartBody) return;
        const overlay = cartBody.querySelector('.cart-widget-overlay');
        if (!overlay) return;
        overlay.style.opacity = '0';
        overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        showCartOverlay();
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        hideCartOverlay();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-widget-dropdown')) {
    customElements.define('cart-widget-dropdown', CartWidgetDropdown);
  }
  class ModalCartToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-cart-toggler'))
    customElements.define('modal-cart-toggler', ModalCartToggler);
  class ModalCartRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);

      this.applyColorScheme = (body) => {
        const { colorScheme } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      this.applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }

    open(toggler = null) {
      this.toggler = toggler;
      if (this.toggler) this.toggler.classList.add('btn-loading');
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }

    close() {
      if (this.toggler) this.toggler.classList.remove('btn-loading');
      const parent = this.querySelector(this.dataset.selector);
      if (parent) parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }

    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }

    renderModal() {
      if (this.toggler) this.toggler.classList.add('btn-loading');
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          if (parent && html) parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          if (this.toggler) this.toggler.classList.remove('btn-loading');
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
        });
    }

    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }

    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      if (flag) {
        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('click', this.onBodyClick);
      } else {
        this.removeEventListener('keyup', this.onKeyUp);
        this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (!boundings || boundings.contains(target) || target === boundings) return;
      this.close();
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-cart-render-component'))
    customElements.define('modal-cart-render-component', ModalCartRenderComponent);
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const button = event.target.closest('button');
        if (!button) return;
        const previousValue = this.input.value;
        button.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]') || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 300);
      this.inputUpdate.addEventListener('input', (event) => {
        const parentElement = document.querySelector(this.dataset.parentSelector);
        const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
        if (localLoader) localLoader.classList.remove('hidden');
        if (parentElement) parentElement.classList.add('is-loading');
        this.debouncedOnUpdate(event);
      });
    }

    onLineItemUpdate() {
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      const parentElement = document.querySelector(this.dataset.parentSelector);
      const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
      if (localLoader) localLoader.classList.remove('hidden');
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const handleLineError = (parent, response) => {
    const parentElement = typeof parent === 'string' ? document.querySelector(parent) : parent;
    const errorContainer = parentElement ? parentElement.querySelector('[data-render-error]') : null;
    if (errorContainer) {
      errorContainer.classList.remove('hidden');
      errorContainer.innerText = response.errors;
    }
    const qtyInput = parentElement ? parentElement.querySelector('input[name="updates[]"]') : null;
    if (qtyInput) qtyInput.value = parseFloat(parentElement.dataset.initQty);
    return (this.erorr = true);
  };
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  const lineItemUpdate = (line, quantity, sections, parent) => {
    const parentElement = typeof parent === 'string' ? document.querySelector(parent) : parent;
    const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
    if (localLoader) localLoader.classList.remove('hidden');
    if (parentElement) parentElement.classList.add('is-loading');
    const drawerContainer = document.querySelector('[data-line-items-drawer-container]') || document.querySelector('[data-line-items-container]');
    if (drawerContainer) drawerContainer.classList.add('cart-loading');
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map((section) => section.id),
      sections_url: window.location.pathname,
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if (response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (localLoader) localLoader.classList.add('hidden');
        if (parentElement) parentElement.classList.remove('is-loading');
        if (drawerContainer) drawerContainer.classList.remove('cart-loading');
        if (!this.erorr) {
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if (modal) {
            if (modal.classList.contains('modal--active')) {
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
      });
  };
  if (!customElements.get('line-item-remove')) {
    customElements.define(
      'line-item-remove',
      class LineItemRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const onRemoval = (event) => {
            event.preventDefault();
            this.button.classList.add('btn-loading');
            lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
          };
          this.removal = onRemoval.bind(this);
          this.button.addEventListener('click', this.removal);
        }
      }
    );
  }
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-cart-totals'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'data-cart-totals' && oldValue !== newValue) {
            this.update();
          }
        }

        connectedCallback() {
          // Disable transitions before first update so milestone points
          // jump instantly to their correct positions (no jerk on open)
          this.classList.add('no-transition');
          this.update();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.classList.remove('no-transition');
            });
          });
        }

        update() {
          const rateFactor = Shopify.currency.rate || 1;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
          const epsilon = 0.001;

          // Milestones configuration
          const milestones = [
            {
              id: 'shipping',
              threshold: parseFloat(this.dataset.amount) * rateFactor,
              successText: this.dataset.freeShippingUnlockedText || 'Free shipping unlocked!',
              label: this.dataset.freeShippingLabel || window.cartStrings.freeShipping
            }
          ];

          if (this.hasAttribute('data-discount-amount')) {
            milestones.push({
              id: 'discount',
              threshold: parseFloat(this.dataset.discountAmount) * rateFactor,
              successText: this.dataset.discountUnlockedText || 'Discount activated!',
              label: this.dataset.discountText || 'Discount'
            });
          }

          // Sort milestones by threshold to handle any user order
          milestones.sort((a, b) => a.threshold - b.threshold);

          const achieved = milestones.filter(m => cartTotals >= m.threshold - epsilon);
          const next = milestones.find(m => cartTotals < m.threshold - epsilon);

          const textContainer = this.querySelector('.shipping-bar_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }

            let message = '';
            if (achieved.length > 0) {
              message = achieved.map(m => m.successText).join(' & ');
            }

            if (next) {
              const remaining = next.threshold - cartTotals;
              const nextMessage = next.id === 'shipping' 
                ? this.baseTextTemplate.replace(/\|\|amount\|\|/g, `<span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span>`)
                : `Add <span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span> more for <span>${next.label}</span>`;
              
              message = message ? `${message} ${nextMessage}` : nextMessage;
            }

            textContainer.innerHTML = message || window.cartStrings.shippingAmount;
          }

          // Update Progress Bar Appearance
          const maxThreshold = milestones.length > 0 ? Math.max(...milestones.map(m => m.threshold)) : 100;
          const value = Math.min((cartTotals / maxThreshold) * 100, 100);
          
          const fill = this.querySelector('.milestone-fill');
          if (fill) {
            fill.style.width = value.toFixed(2) + '%';
            if (value >= 100 - epsilon) {
              fill.classList.add('is-full');
            } else {
              fill.classList.remove('is-full');
            }
          }

          milestones.forEach(m => {
            const milestoneEl = this.querySelector(`.milestone-point--${m.id}`);
            if (milestoneEl) {
              const percent = Math.min((m.threshold / maxThreshold) * 100, 100);
              milestoneEl.style.left = percent + '%';
              if (cartTotals >= m.threshold - epsilon) {
                milestoneEl.classList.add('is-active');
              } else {
                milestoneEl.classList.remove('is-active');
              }
            }
          });
        }
      }
    );
  }
  class cartDiscountCode extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const button = this.querySelector('button');
      const input = this.querySelector('input[name="discount_code"]');
      if (!button || !input) return;
      const onClick = (event) => {
        event.preventDefault();
        button.classList.add('btn-loading');
        const secArr = JSON.parse(this.dataset.sections);
        const discountCode = input.value.trim();
        var body = JSON.stringify({
          discount: discountCode,
          sections: secArr.map((section) => section.id),
          sections_url: window.location.pathname,
        });
        this.erorr = false;
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const response = JSON.parse(responseText);
            if (response.errors) return handleLineError(parent, response);
            sectionArrRender(secArr, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('btn-loading');
            if (!this.erorr) {
              const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
              if (modal) {
                if (modal.classList.contains('modal--active')) {
                  trapFocus(modal.content);
                  modal.setListeners(true);
                }
              }
            }
          });
      };
      this.onClick = onClick;
      button.addEventListener('click', onClick);
    }
  }
  if (!customElements.get('cart-discount-code')) customElements.define('cart-discount-code', cartDiscountCode);
  if (!customElements.get('cart-timer')) {
    customElements.define(
      'cart-timer',
      class CartTimer extends HTMLElement {
        constructor() {
          super();
          this.timerDuration = parseInt(this.dataset.duration) * 60; // in seconds
          this.storageKey = 'cart_timer_expiry';
          this.interval = null;
        }

        connectedCallback() {
          this.initTimer();
        }

        initTimer() {
          let expiry = sessionStorage.getItem(this.storageKey);
          if (!expiry) {
            expiry = Date.now() + this.timerDuration * 1000;
            sessionStorage.setItem(this.storageKey, expiry);
          }

          this.updateDisplay(expiry);
          this.interval = setInterval(() => {
            const remaining = this.updateDisplay(expiry);
            if (remaining <= 0) {
              clearInterval(this.interval);
              this.onExpire();
            }
          }, 1000);
        }

        updateDisplay(expiry) {
          const now = Date.now();
          const remaining = Math.max(0, Math.floor((expiry - now) / 1000));
          const minutes = Math.floor(remaining / 60);
          const seconds = remaining % 60;
          const timeString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

          const textContainer = this.querySelector('[data-timer-text]') || this.querySelector('.cart-timer_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }
            textContainer.innerHTML = this.baseTextTemplate.replace(/\|\|timer\|\|/g, `<span>${timeString}</span>`);
          }
          return remaining;
        }

        onExpire() {
          sessionStorage.removeItem(this.storageKey);
          const clearUrl = window.routes?.cart_clear_url || '/cart/clear';
          fetch(clearUrl, { method: 'POST' })
            .then(() => {
              location.reload();
            })
            .catch(() => {
              location.reload();
            });
        }

        disconnectedCallback() {
          if (this.interval) clearInterval(this.interval);
        }
      }
    );
  }
  if (!customElements.get('shipping-protection')) {
    customElements.define(
      'shipping-protection',
      class ShippingProtection extends HTMLElement {
        constructor() {
          super();
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.variantId = this.dataset.variantId;
          this.lineKey = this.dataset.lineKey;
          this.sections = JSON.parse(this.dataset.sections || '[]');
        }

        connectedCallback() {
          if (!this.checkbox) return;
          this.checkbox.addEventListener('change', this.onChange.bind(this));
        }

        onChange() {
          const isChecked = this.checkbox.checked;
          if (isChecked) {
            this.addProtection();
          } else {
            this.removeProtection();
          }
        }

        addProtection() {
          if (this.checkbox) this.checkbox.disabled = true;
          const body = JSON.stringify({
            id: this.variantId,
            quantity: 1,
            sections: this.sections.map((s) => s.id),
            sections_url: window.location.pathname
          });

          fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.sections) {
                sectionArrRender(this.sections, response);
              } else {
                location.reload();
              }
            })
            .catch((e) => {
              console.error(e);
              location.reload();
            })
            .finally(() => {
              if (this.checkbox) this.checkbox.disabled = false;
            });
        }

        removeProtection() {
          if (this.checkbox) this.checkbox.disabled = true;
          const body = JSON.stringify({
            id: this.lineKey || this.variantId,
            quantity: 0,
            sections: this.sections.map((s) => s.id),
            sections_url: window.location.pathname
          });

          fetch(`${window.routes.cart_change_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.sections) {
                sectionArrRender(this.sections, response);
              } else {
                location.reload();
              }
            })
            .catch((e) => {
              console.error(e);
              location.reload();
            })
            .finally(() => {
              if (this.checkbox) this.checkbox.disabled = false;
            });
        }
      }
    );
  }
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (
    jsonSelector,
    optSet,
    formsSelector,
    renders,
    parentSelector,
    gallerySelectors,
    sectionId,
    productUrl,
    updateUrl,
    focusSelector,
    renderMedia,
    templateSelector
  ) => {
    const json = document.querySelector(jsonSelector);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === optSet[index])
    );

    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }

    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if (!currentVariant) return;

    if (currentVariant.featured_image)
      setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach((form) => {
      if (!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if (!atcBtn) return;
      if (variant.available) {
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach((selector) => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach((element) => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
        if (focusSelector) {
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach((selector) => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach((element) => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if (!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      if (typeof VariantDropdown !== 'undefined' && VariantDropdown.prototype.updateOptionsAvailability) {
        VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
        return;
      }
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = document.querySelector(this.dataset.form);
      if (!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append(
          'sections',
          secArr.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class GSAPHeaderHandler {
    constructor() {
      /* Everything this class attaches (window listeners, ResizeObservers,
         a MediaQueryList listener) outlives the DOM node it was built
         around — swapping the header's markup back out from under it
         doesn't tear any of that down on its own. this._cleanups collects
         one teardown fn per thing attached, so destroy() below can undo
         exactly what init()/setupSticky() did, in the same run they did it. */
      this._cleanups = [];
      this.init();
    }

    updateHeaderHeight() {
      if (!this.headerArea) return;
      let height = 0;
      if (typeof window.getStickyHeaderOffset === 'function') {
        height = window.getStickyHeaderOffset();
      }
      if (!height) {
        height = Math.round(this.headerArea.getBoundingClientRect().height || 0);
      }
      if (height > 0) {
        document.body.style.setProperty('--header-height', `${height}px`);
      }
      const isOverlay = this.headerArea.classList.contains('is-header-overlay');
      if (isOverlay) {
        let annHeight = 0;
        let node = this.headerArea.parentElement ? this.headerArea.parentElement.previousElementSibling : null;
        while (node) {
          const targetEl = node.querySelector ? (node.querySelector('.section-wrapper_inner') || node.querySelector('.announcement-bar') || node) : node;
          const h = targetEl.clientHeight || Math.floor(targetEl.getBoundingClientRect().height || 0);
          annHeight += h > 0 ? h - 1 : 0;
          node = node.previousElementSibling;
        }
        document.body.style.setProperty('--announcement-bar-height', `${annHeight}px`);
      } else {
        document.body.style.removeProperty('--announcement-bar-height');
      }
    }

    init() {
      this.headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');

      if (!this.headerArea) return;

      this.spacerEl = document.querySelector('.page-header_sticky-spacer');

      const overlayEl = document.querySelector('[data-header-overlay="true"]');
      if (overlayEl) {
        this.headerArea.classList.add('is-header-overlay');
      }

      this.updateHeaderHeight();

      if (window.ResizeObserver) {
        const areaRO = new ResizeObserver(() => {
          this.updateHeaderHeight();
        });
        areaRO.observe(this.headerArea);
        this._cleanups.push(() => areaRO.disconnect());
        const annBar = document.querySelector('.announcement-bar');
        if (annBar) {
          const annRO = new ResizeObserver(() => {
            this.updateHeaderHeight();
            if (typeof window.syncSmoothWrapperTop === 'function') window.syncSmoothWrapperTop();
          });
          annRO.observe(annBar);
          this._cleanups.push(() => annRO.disconnect());
        }
      }
      const onWindowResize = () => this.updateHeaderHeight();
      window.addEventListener('resize', onWindowResize, { passive: true });
      this._cleanups.push(() => window.removeEventListener('resize', onWindowResize));

      const stickyBehavior = this.headerArea.dataset.stickyBehavior || 'none';
      if (stickyBehavior === 'none') {
        /* Sticky is off — the header stays in normal flow and never
           collapses, so the spacer must never reserve space either. */
        if (this.spacerEl) this.spacerEl.style.height = '0px';
        if (typeof window.syncSmoothWrapperTop === 'function') window.syncSmoothWrapperTop();
        return;
      }

      this.setupSticky(stickyBehavior);
    }

    /* Reverses everything init()/setupSticky() attached to window/document
       and to observers — called before a fresh GSAPHeaderHandler replaces
       this one (see initGSAPHeader below), so an editor reload of the
       header — or of any other section on the page — can never leave a
       second copy of these listeners racing the new instance's. */
    destroy() {
      this._cleanups.forEach((cleanup) => cleanup());
      this._cleanups = [];
    }

    setupSticky(behavior) {
      const headerEl = this.headerArea;
      const spacerEl = this.spacerEl;
      let lastScrollY = window.scrollY;
      let isSticky = false;

      /* Single source of truth for "how tall is the sticky header" — the
         same helper the GSAP-pinned sections (collection-list,
         main-collections, showcase-hotspot, before-after-content) use to
         offset their own ScrollTrigger `start`. Reusing it here guarantees
         the spacer and those pins can never disagree about the header's
         height. Falls back to measuring the header directly if the helper
         hasn't loaded yet (script order edge case), so the spacer still
         works even without it. */
      const measureHeaderHeight = () => {
        if (typeof window.getStickyHeaderOffset === 'function') {
          const offset = window.getStickyHeaderOffset();
          if (offset) return offset;
        }
        return Math.round(headerEl.getBoundingClientRect().height || 0);
      };

      const syncSpacer = () => {
        if (!spacerEl) return;
        /* Overlay headers (hero-banner / banner-carousel "enable header
           overlay") are designed to float over their trigger section with
           zero layout footprint at all times — transparent+absolute at
           rest, then solid+fixed once scrolled, but never reserving space
           either way. That's already jump-free without a spacer, so
           reserving height here would newly push that section down and
           open a gap under the header where none existed before. */
        const isOverlay = headerEl.classList.contains('is-header-overlay');
        spacerEl.style.height = (isSticky && !isOverlay) ? measureHeaderHeight() + 'px' : '0px';
        this.updateHeaderHeight();
        /* ScrollSmoother's #smooth-wrapper (layout/theme.liquid) reads this
           spacer's reserved height to decide how much of whatever preceded
           the header (e.g. a non-sticky announcement bar) should still
           count once it's scrolled out of view. Its own ResizeObserver
           won't fire here since this spacer keeps the page-wrapper's total
           height constant across the toggle — nudge it explicitly. */
        if (typeof window.syncSmoothWrapperTop === 'function') window.syncSmoothWrapperTop();
      };

      const setScrollHeaderHeight = () => {
        const currentHeight = measureHeaderHeight();
        document.body.style.setProperty('--page-header-height', `${currentHeight}px`);
      };

      const removeScrollHeaderHeight = () => {
        document.body.style.removeProperty('--page-header-height');
      };

      /* Keeps the reserved space correct even while already sticky — the
         header's own height can still change (announcement bar dismissed,
         viewport resize, mega menu breakpoint, font swap), and a scroll
         event isn't guaranteed to fire alongside any of those. */
      if (spacerEl && window.ResizeObserver) {
        const headerRO = new ResizeObserver(() => {
          if (isSticky) {
            syncSpacer();
            setScrollHeaderHeight();
          }
          this.updateHeaderHeight();
        });
        headerRO.observe(headerEl);
        this._cleanups.push(() => headerRO.disconnect());
      }
      /* Every sibling animated feature in this theme gates its scroll-tied
         motion behind prefers-reduced-motion; the sticky header's hide/reveal
         slide didn't. Under reduced motion, keep the is-sticky class toggle
         (a state change, not motion) but skip the yPercent slide itself.
         Reactive to the MediaQueryList's own "change" event — mirroring the
         gsap.matchMedia pattern used elsewhere in the theme — rather than a
         one-shot .matches read, so toggling the OS setting mid-session takes
         effect immediately instead of only after a reload. Uses the native
         MediaQueryList directly (not gsap.matchMedia) since this handler can
         run before GSAP has necessarily finished loading. */
      const reduceMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      let reduceMotion = reduceMotionQuery ? reduceMotionQuery.matches : false;
      if (reduceMotionQuery) {
        const onReduceMotionChange = (e) => { reduceMotion = e.matches; };
        reduceMotionQuery.addEventListener('change', onReduceMotionChange);
        this._cleanups.push(() => reduceMotionQuery.removeEventListener('change', onReduceMotionChange));
      }

      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const parentOffset = (headerEl.parentElement ? headerEl.parentElement.offsetTop : 0);
        const threshold = parentOffset;

        if (currentScrollY > threshold) {
          if (!isSticky) {
            isSticky = true;
            headerEl.classList.add('is-sticky');
            syncSpacer();
          }

          if (behavior === 'on_scroll_up') {
            if (currentScrollY > lastScrollY && currentScrollY > threshold + 80) {
              removeScrollHeaderHeight();
              headerEl.classList.add('is-header-hidden');
              if (typeof window.syncSmoothWrapperTop === 'function') window.syncSmoothWrapperTop();
              if (!reduceMotion) {
                if (window.gsap) {
                  window.gsap.to(headerEl, { yPercent: -100, duration: 0.3, ease: 'power2.out', overwrite: 'auto' });
                } else {
                  headerEl.style.transform = 'translateY(-100%)';
                }
              }
            } else if (currentScrollY < lastScrollY) {
              headerEl.classList.remove('is-header-hidden');
              this.updateHeaderHeight();
              setScrollHeaderHeight();
              if (typeof window.syncSmoothWrapperTop === 'function') window.syncSmoothWrapperTop();
              if (!reduceMotion) {
                if (window.gsap) {
                  window.gsap.to(headerEl, { yPercent: 0, duration: 0.3, ease: 'power2.out', overwrite: 'auto' });
                } else {
                  headerEl.style.transform = 'translateY(0%)';
                }
              }
            }
          } else if (behavior === 'on_scroll') {
            headerEl.classList.remove('is-header-hidden');
            this.updateHeaderHeight();
            setScrollHeaderHeight();
            if (!reduceMotion) {
              if (window.gsap) {
                window.gsap.to(headerEl, { yPercent: 0, duration: 0.2, ease: 'power2.out', overwrite: 'auto' });
              } else {
                headerEl.style.transform = 'translateY(0%)';
              }
            }
          }
        } else {
          headerEl.classList.remove('is-header-hidden');
          this.updateHeaderHeight();
          removeScrollHeaderHeight();
          if (isSticky) {
            isSticky = false;
            headerEl.classList.remove('is-sticky');
            syncSpacer();
            if (!reduceMotion) {
              if (window.gsap) {
                window.gsap.to(headerEl, { yPercent: 0, duration: 0.2, ease: 'power2.out', overwrite: 'auto' });
              } else {
                headerEl.style.transform = 'translateY(0%)';
              }
            }
          }
        }

        lastScrollY = currentScrollY;
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      this._cleanups.push(() => window.removeEventListener('scroll', handleScroll));
      handleScroll();
    }
  }

  /* Single live instance, not one-per-reload. shopify:section:load fires
     for EVERY section on the page, not just the header — re-running
     initGSAPHeader unfiltered on each one used to construct a brand-new
     GSAPHeaderHandler (with its own window resize/scroll listeners and
     ResizeObservers) every time a merchant edited any unrelated section,
     permanently stacking duplicates that then raced each other over
     is-sticky state and the header's own GSAP tweens. destroy() the
     previous instance before building a new one, and only rebuild at all
     when the reloaded section is actually the header. */
  let currentGSAPHeaderHandler = null;
  const initGSAPHeader = () => {
    if (currentGSAPHeaderHandler) currentGSAPHeaderHandler.destroy();
    currentGSAPHeaderHandler = new GSAPHeaderHandler();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGSAPHeader);
  } else {
    initGSAPHeader();
  }
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    const isHeaderSection = target && target.querySelector && target.querySelector('.page-header_fixed-area, .page-header');
    if (!isHeaderSection) return;
    initGSAPHeader();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    const isHeaderSection = target && target.querySelector && target.querySelector('.page-header_fixed-area, .page-header');
    if (!isHeaderSection || !currentGSAPHeaderHandler) return;
    currentGSAPHeaderHandler.destroy();
    currentGSAPHeaderHandler = null;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initTabs = (root) => {
      /* Scoped to the section that actually (re)loaded, matching
         sections/collection-list.liquid's pattern — otherwise every
         unrelated section edit in the theme editor re-runs this for every
         hero-banner on the page and stacks another keydown/click listener
         on top of the ones already bound. */
      const heroBanners = root ? [root] : document.querySelectorAll('.hero-banner');
      heroBanners.forEach(section => {
        const _M = window.themeMotion || {};
        const buttons = section.querySelectorAll('.js-tab-button');
        const panes = section.querySelectorAll('.hero-banner-content_tab-pane');
        if (!buttons.length || !panes.length) return;

        const closeTooltip = (tooltip) => {
          if (!tooltip || !tooltip.classList.contains('is-open')) return;
          const wrapper = tooltip.closest('.hero-tab_floating-tooltip-wrapper');
          const arrow = wrapper ? wrapper.querySelector('.hero-tab_tooltip-arrow') : null;
          const targets = arrow ? [tooltip, arrow] : tooltip;
          if (window.gsap) {
            window.gsap.to(targets, {
              opacity: 0,
              duration: (_M.dur && _M.dur.fast) || 0.2,
              ease: (_M.ease && _M.ease.exit) || "power2.in",
              onComplete: () => {
                tooltip.classList.remove('is-open');
              }
            });
          } else {
            tooltip.classList.remove('is-open');
          }
        };

        /* Entrance stagger for a tab pane's content, replayed on first load and
           after every tab switch so freshly-revealed content settles in rather
           than popping in instantly. Skipped under reduced motion. This is
           separate from initHeroEntrance() below (which layers a richer,
           token-driven clip-reveal/split-heading treatment on top of the
           active pane's media, tag, heading and CTA every time the section
           scrolls into view); this lighter fade covers the elements that
           treatment doesn't reach (badge image, description, product rider)
           and is what animates the pane on every subsequent tab switch. */
        const playEntrance = (pane, immediate = false) => {
          if (!pane) return;
          const els = [
            pane.querySelector('.hero-banner-content_badge-image-wrapper'),
            pane.querySelector('.hero-banner-content_season-tag'),
            pane.querySelector('.hero-banner-content_main-title'),
            pane.querySelector('.hero-banner-content_main-desc'),
            pane.querySelector('.hero-banner-content_buttons'),
            pane.querySelector('.hero-banner-content_rider-container')
          ].filter(Boolean);
          if (!els.length || !window.gsap) return;
          if (immediate || reduceMotion) {
            window.gsap.set(els, { clearProps: 'opacity,visibility,transform,autoAlpha,y,x,scale,clipPath' });
            return;
          }
          window.gsap.fromTo(els,
            { autoAlpha: 0, y: 24 },
            {
              autoAlpha: 1, y: 0,
              duration: (_M.dur && _M.dur.base) || 0.7,
              ease: (_M.ease && _M.ease.ui) || 'power3.out',
              stagger: (_M.stagger && _M.stagger.tight) || 0.08,
              overwrite: 'auto',
              onComplete: () => {
                window.gsap.set(els, { clearProps: 'opacity,visibility,transform,autoAlpha,y,x,scale,clipPath' });
              }
            }
          );
        };

        /* initTabs() re-runs for this section on every shopify:section:load
           (see bottom of file); without removing the previous handler first,
           each re-run stacks another document-level keydown listener on top
           of the ones already bound, every one of them closing over its own
           (increasingly stale) `section` reference. Store the handler on the
           section element so the next run — and the shopify:section:unload
           handler below — can remove exactly this section's listener. */
        if (section._heroTabsKeydownHandler) {
          document.removeEventListener('keydown', section._heroTabsKeydownHandler);
        }
        section._heroTabsKeydownHandler = (e) => {
          if (e.key === 'Escape' || e.key === 'Esc') {
            const activeTooltips = section.querySelectorAll('.hero-tab_tooltip.is-open');
            activeTooltips.forEach(tooltip => closeTooltip(tooltip));
          }
        };
        document.addEventListener('keydown', section._heroTabsKeydownHandler);

        let currentActiveBtn = null;
        let isFlipping = false;

        let scrollRaf = null;

        const syncTooltipPosition = () => {
          if (isFlipping || !currentActiveBtn) return;
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(() => {
            scrollRaf = null;
            if (isFlipping || !currentActiveBtn) return;
            const nav = currentActiveBtn.closest('.hero-navlist_tabs-nav');
            if (!nav) return;
            const navWrapper = nav.closest('.hero-banner_tabs-nav-wrapper') || nav.parentElement;
            if (!navWrapper) return;
            const wrapper = navWrapper.querySelector('.hero-tab_floating-tooltip-wrapper');
            if (!wrapper) return;
            const li = currentActiveBtn.closest('.hero-navlist_nav-item');
            if (!li) return;
            const navWrapperRect = navWrapper.getBoundingClientRect();
            const liRect = li.getBoundingClientRect();
            wrapper.style.left = `${liRect.left - navWrapperRect.left}px`;
            const isOutOfView = liRect.right < navWrapperRect.left || liRect.left > navWrapperRect.right;
            wrapper.style.visibility = isOutOfView ? 'hidden' : 'visible';
          });
        };

        const scrollTabIntoView = (btn) => {
          const nav = btn.closest('.hero-navlist_tabs-nav');
          const li = btn.closest('.hero-navlist_nav-item');
          if (!nav || !li) return;
          const navRect = nav.getBoundingClientRect();
          const liRect = li.getBoundingClientRect();
          if (liRect.left < navRect.left || liRect.right > navRect.right) {
            const targetScroll = li.offsetLeft - (nav.clientWidth / 2) + (li.offsetWidth / 2);
            if (window.gsap) {
              window.gsap.to(nav, {
                scrollLeft: targetScroll,
                duration: (_M.dur && _M.dur.base) || 0.5,
                ease: (_M.ease && _M.ease.ui) || "power2.out",
                overwrite: "auto"
              });
            } else {
              nav.scrollTo({ left: targetScroll, behavior: 'smooth' });
            }
          }
        };

        const updateFloatingTooltip = (btn, immediate = false) => {
          const nav = btn.closest('.hero-navlist_tabs-nav');
          if (!nav) return;
          const navWrapper = nav.closest('.hero-banner_tabs-nav-wrapper') || nav.parentElement;
          if (!navWrapper) return;
          const li = btn.closest('.hero-navlist_nav-item');
          if (!li) return;
          currentActiveBtn = btn;
          const template = li.querySelector('.hero-tab_tooltip');
          let wrapper = navWrapper.querySelector('.hero-tab_floating-tooltip-wrapper');
          if (!template) {
            if (wrapper) {
              wrapper.remove();
            }
            return;
          }
          if (!wrapper) {
            wrapper = document.createElement('div');
            navWrapper.appendChild(wrapper);
          }
          const templateScheme = (template.getAttribute('class') || '').split(' ').filter(c => c.startsWith('scheme')).join(' ');
          const isBottom = nav.classList.contains('hero-navlist_tabs-nav--bottom');
          wrapper.className = `hero-tab_floating-tooltip-wrapper ${templateScheme} ${isBottom ? 'is--bottom' : ''}`.trim();

          const useFlip = !immediate && window.gsap && window.Flip;
          const flipState = useFlip ? window.Flip.getState(wrapper) : null;

          wrapper.innerHTML = template.outerHTML;
          const activeTooltip = wrapper.querySelector('.hero-tab_tooltip');
          if (activeTooltip) {
            activeTooltip.classList.add('is-floating', 'is-open');
            const arrow = activeTooltip.querySelector('.hero-tab_tooltip-arrow');
            if (arrow) {
              wrapper.appendChild(arrow);
            }
            const animTargets = arrow ? [activeTooltip, arrow] : activeTooltip;
            if (window.gsap) {
              window.gsap.fromTo(animTargets, { opacity: 0 }, { opacity: 1, duration: (_M.dur && _M.dur.fast) || 0.3, ease: (_M.ease && _M.ease.ui) || "power2.out" });
            }

            const closeBtn = activeTooltip.querySelector('.js-tooltip-close');
            if (closeBtn) {
              closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                closeTooltip(activeTooltip);
              });
            }
          }

          const navWrapperRect = navWrapper.getBoundingClientRect();
          const liRect = li.getBoundingClientRect();
          wrapper.style.width = `${li.offsetWidth}px`;
          wrapper.style.left = `${liRect.left - navWrapperRect.left}px`;
          wrapper.style.visibility = 'visible';

          // FLIP: Invert & Play
          if (useFlip) {
            isFlipping = true;
            window.Flip.from(flipState, {
              duration: (_M.dur && _M.dur.base) || 0.5,
              ease: (_M.ease && _M.ease.ui) || 'power2.out',
              onComplete: () => {
                isFlipping = false;
                syncTooltipPosition();
              }
            });
          } else if (window.gsap) {
            window.gsap.set(wrapper, { x: 0, y: 0 });
          } else {
            wrapper.style.transform = 'none';
          }
        };

        const navLists = section.querySelectorAll('.hero-navlist_tabs-nav');

        if (section._heroTabsResizeHandler) {
          window.removeEventListener('resize', section._heroTabsResizeHandler);
        }
        section._heroTabsResizeHandler = syncTooltipPosition;
        window.addEventListener('resize', section._heroTabsResizeHandler, { passive: true });

        navLists.forEach(nav => {
          nav.addEventListener('scroll', syncTooltipPosition, { passive: true });

          nav.addEventListener('wheel', (e) => {
            if (e.deltaY !== 0 && nav.scrollWidth > nav.clientWidth && !e.shiftKey) {
              e.preventDefault();
              nav.scrollLeft += e.deltaY;
            }
          }, { passive: false });

          let isDown = false;
          let startX = 0;
          let scrollLeftPos = 0;
          let hasMoved = false;

          nav.addEventListener('mousedown', (e) => {
            isDown = true;
            hasMoved = false;
            startX = e.pageX - nav.offsetLeft;
            scrollLeftPos = nav.scrollLeft;
            nav.style.cursor = 'grabbing';
            nav.style.userSelect = 'none';
          });

          window.addEventListener('mouseup', () => {
            if (isDown) {
              isDown = false;
              nav.style.cursor = '';
              nav.style.userSelect = '';
            }
          });

          nav.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            const x = e.pageX - nav.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 4) {
              hasMoved = true;
            }
            nav.scrollLeft = scrollLeftPos - walk;
          });

          nav.addEventListener('click', (e) => {
            if (hasMoved) {
              e.preventDefault();
              e.stopPropagation();
              hasMoved = false;
            }
          }, true);
        });

        const activeBtn = section.querySelector('.js-tab-button.is-active') || buttons[0];
        if (activeBtn) {
          currentActiveBtn = activeBtn;
          scrollTabIntoView(activeBtn);
          updateFloatingTooltip(activeBtn, true);
          playEntrance(section.querySelector('.hero-banner-content_tab-pane.is-active'), true);
        }

        let isAnimating = false;

        const switchTab = (btn) => {
          if (isAnimating) return;

          const targetId = btn.getAttribute('data-target-pane');
          const targetPane = section.querySelector(`.hero-banner-content_tab-pane[data-block-id="${targetId}"]`);
          const currentPane = section.querySelector('.hero-banner-content_tab-pane.is-active');

          if (!targetPane || targetPane === currentPane) return;

          // Update nav active state immediately
          buttons.forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          scrollTabIntoView(btn);
          updateFloatingTooltip(btn, false);

          const bgs = section.querySelectorAll('.js-block-bg');
          bgs.forEach(bg => {
            if (bg.getAttribute('data-block-id') === targetId) {
              bg.classList.add('is-active');
            } else {
              bg.classList.remove('is-active');
            }
          });

          if (window.gsap) {
            isAnimating = true;

            const wrapper = section.querySelector('.hero-banner_tabs-content-wrapper');

            // Setup animating state first so both panes are laid out to accurately measure height
            targetPane.classList.add('animating');
            if (currentPane) currentPane.classList.add('animating');

            const currentHeight = currentPane ? currentPane.offsetHeight : 0;
            const targetHeight = targetPane.offsetHeight;

            if (wrapper && currentHeight > 0) {
              wrapper.style.height = `${currentHeight}px`;
            }

            window.gsap.set(targetPane, { xPercent: 100, opacity: 1, zIndex: 10 });
            if (currentPane) {
              window.gsap.set(currentPane, { xPercent: 0, opacity: 1, zIndex: 1 });
            }

            const tl = window.gsap.timeline({
              onComplete: () => {
                panes.forEach(p => {
                  p.classList.remove('is-active', 'animating');
                });
                targetPane.classList.add('is-active');
                window.gsap.set(panes, { clearProps: "xPercent,opacity,zIndex,transform" });
                if (wrapper) wrapper.style.height = '';
                if (window.ScrollTrigger) window.ScrollTrigger.refresh();
                isAnimating = false;
              }
            });

            const _tabDur = (_M.dur && _M.dur.base) || 0.8;
            const _tabEase = (_M.ease && _M.ease.ui) || "power3.out";

            tl.to(targetPane, {
              xPercent: 0,
              duration: _tabDur,
              ease: _tabEase
            }, 0);

            if (currentPane) {
              tl.to(currentPane, {
                xPercent: -100,
                opacity: 0,
                duration: _tabDur,
                ease: _tabEase
              }, 0);
            }

            if (wrapper && targetHeight > 0 && currentHeight !== targetHeight) {
              tl.to(wrapper, {
                height: targetHeight,
                duration: _tabDur,
                ease: _tabEase
              }, 0);
            }
          } else {
            // Fallback if GSAP is not loaded
            panes.forEach(p => p.classList.remove('is-active'));
            targetPane.classList.add('is-active');
          }
        };

        buttons.forEach(button => {
          button.addEventListener('click', (e) => {
            const btn = e.currentTarget;
            const isAlreadyActive = btn.classList.contains('is-active');
            if (isAlreadyActive) {
              const navWrapper = btn.closest('.hero-banner_tabs-nav-wrapper') || btn.closest('.hero-navlist_tabs-nav')?.parentElement;
              if (navWrapper) {
                const wrapper = navWrapper.querySelector('.hero-tab_floating-tooltip-wrapper');
                if (wrapper) {
                  const activeTooltip = wrapper.querySelector('.hero-tab_tooltip');
                  const arrow = wrapper.querySelector('.hero-tab_tooltip-arrow');
                  const animTargets = arrow ? [activeTooltip, arrow] : activeTooltip;
                  if (activeTooltip) {
                    const isOpen = activeTooltip.classList.contains('is-open');
                    if (isOpen) {
                      closeTooltip(activeTooltip);
                    } else {
                      activeTooltip.classList.add('is-open');
                      syncTooltipPosition();
                      if (window.gsap) {
                        window.gsap.fromTo(animTargets, { opacity: 0 }, { opacity: 1, duration: (_M.dur && _M.dur.fast) || 0.3, ease: (_M.ease && _M.ease.ui) || "power2.out" });
                      }
                    }
                  }
                }
              }
            } else {
              switchTab(btn);
            }
          });
        });

        const initScrollTrigger = () => {
          if (window.gsap && window.ScrollTrigger) {
            window.gsap.registerPlugin(window.ScrollTrigger);

            const sectionEl = section;
            if (!sectionEl) return;
            const sectionId = sectionEl.getAttribute('id') || sectionEl.dataset.id || 'hero-banner-static';

            /* No section pin here: each backdrop text scrubs across the
               viewport as the page scrolls past it naturally, rather than
               freezing the section in place for a fixed scroll distance. */
            window.ScrollTrigger.getAll()
              .filter(st => st.vars.id && st.vars.id.indexOf(`hero-banner-parallax-${sectionId}-`) === 0)
              .forEach(st => st.kill());

            const backdropTexts = sectionEl.querySelectorAll('.hero-banner-content_backdrop-text');
            if (!backdropTexts.length) return;

            /* Each backdrop text is its own trigger, anchored to itself rather
               than the whole section - so the right-to-left sweep starts the
               moment that text enters the viewport and finishes completely by
               the moment it leaves, instead of being stretched across the
               section's much larger scroll span. */
            backdropTexts.forEach((txt, i) => {
              window.gsap.fromTo(txt,
                { xPercent: 140 },
                {
                  xPercent: -140,
                  ease: "none",
                  scrollTrigger: {
                    id: `hero-banner-parallax-${sectionId}-${i}`,
                    trigger: txt,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    /* Document-position-derived priority (window.themeScrollPriority,
                       defined in layout/theme.liquid) so this trigger's start/end are
                       only computed after sibling pinned sections above it (e.g.
                       showcase-hotspot, before-after-content, collection-list,
                       main-collections) finish resolving their own pin-spacer heights
                       on the same refresh pass — otherwise a merchant dragging one of
                       those sections above hero-banner in the customizer can leave
                       this scrub range stale. */
                    refreshPriority: window.themeScrollPriority(txt)
                  }
                }
              );
            });
          }
        };

        initScrollTrigger();

        /* ── Hero entrance sequence (token-driven, replays every re-entry) ──
           Reveals the initially-active tab's media/tagline/heading/CTA
           using window.themeMotion tokens and window.themeSplitHeading.
           Re-run from scratch by initHeroEntranceRepeat()'s ScrollTrigger
           every time the section scrolls into view (not just on first load),
           so leaving the section and scrolling back replays the same reveal.
           window.themeSplitHeading() is idempotent (it reverts any prior
           split on the element before re-splitting), which is what makes
           calling this function repeatedly safe. This is additive: it does
           not touch the tab-switch, tooltip, or backdrop-text animations
           above, which keep their own hardcoded values untouched. */
        const initHeroEntrance = (immediate = false) => {
          if (reduceMotion) return;

          const _M = window.themeMotion || {};
          const activePane = section.querySelector('.hero-banner-content_tab-pane.is-active') || section.querySelector('.hero-banner-content_tab-pane');
          const heroMedia = section.querySelector('.hero-banner-content_bg.is-active') || section.querySelector('.hero-banner-content_bg');
          const heroTag = activePane && activePane.querySelector('.hero-banner-content_season-tag');
          const heroHead = activePane && activePane.querySelector('.hero-banner-content_main-title');
          const heroDesc = activePane && activePane.querySelector('.hero-banner-content_main-desc');
          const heroCTA = activePane && activePane.querySelector('.hero-banner-content_buttons');

          if (window.innerWidth < 768 || (!heroMedia && !heroHead)) return;

          /* immediate (first page-load reveal, no preloader to mask a
             hide-then-reveal anymore): snap straight to the settled state
             instead of clipping/hiding then animating in, so there's no
             blank beat under the header while GSAP works through the
             timeline below. Replays via onEnterBack still get the full
             choreography since those happen well after first paint. */
          if (immediate) {
            if (heroHead && window.themeSplitHeading) {
              const s = window.themeSplitHeading(heroHead);
              if (s && s.cleanup) s.cleanup();
            }
            if (heroDesc && window.themeSplitHeading) {
              const s = window.themeSplitHeading(heroDesc);
              if (s && s.cleanup) s.cleanup();
            }
            const targets = [heroMedia, heroTag, heroHead, heroDesc, heroCTA].filter(Boolean);
            if (targets.length) window.gsap.set(targets, { clearProps: 'opacity,visibility,transform,autoAlpha,y,x,scale,clipPath' });
            return;
          }

          const tl = window.gsap.timeline({
            delay: 0.08,
            defaults: { overwrite: 'auto' },
            onComplete: () => {
              const targets = [heroMedia, heroTag, heroHead, heroDesc, heroCTA].filter(Boolean);
              if (targets.length) window.gsap.set(targets, { clearProps: 'opacity,visibility,transform,autoAlpha,y,x,scale,clipPath' });
            }
          });

          if (heroTag) {
            window.gsap.set(heroTag, { opacity: 0, y: 22 });
            tl.to(heroTag, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.38);
          }

          if (heroHead) {
            const split = window.themeSplitHeading && window.themeSplitHeading(heroHead);
            if (split && split.targets !== heroHead) {
              window.gsap.set(split.targets, split.fromVars);
              tl.to(split.targets, Object.assign({}, split.toVars, { duration: split.duration, ease: split.ease, stagger: split.stagger }), 0.52);
            } else {
              window.gsap.set(heroHead, { opacity: 0, y: 30 });
              tl.to(heroHead, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.52);
            }
          }

          if (heroDesc) {
            const descSplit = window.themeSplitHeading && window.themeSplitHeading(heroDesc);
            if (descSplit && descSplit.targets !== heroDesc) {
              window.gsap.set(descSplit.targets, descSplit.fromVars);
              tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, { duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger }), 0.62);
            } else {
              window.gsap.set(heroDesc, { opacity: 0, y: 24 });
              tl.to(heroDesc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.62);
            }
          }

          if (heroCTA) {
            window.gsap.set(heroCTA, { opacity: 0, scale: 0.85 });
            tl.to(heroCTA, { opacity: 1, scale: 1, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.spring) || 'elastic.out(1,0.5)', clearProps: 'scale' }, 1.05);
          }
        };

        /* initHeroEntrance() only ever touches core GSAP (gsap.set/timeline),
           so its very first run is fired off window.onThemeGsapCoreReady
           below rather than waiting on the full onThemeGsapReady (which also
           gates on ScrollTrigger/Draggable/InertiaPlugin — irrelevant to this
           first reveal, but measured via Lighthouse to add several seconds
           of LCP render delay to this section's heading/description, the
           usual LCP candidate on the homepage). heroEntranceFired makes that
           fast path idempotent against the ScrollTrigger-based onEnter below,
           which still exists for sections that aren't already in view when
           the full plugin set finishes loading. */
        let heroEntranceFired = false;
        const fireHeroEntranceOnce = () => {
          if (heroEntranceFired) return;
          heroEntranceFired = true;
          initHeroEntrance(true);
        };

        /* Gates initHeroEntrance() behind a ScrollTrigger so it replays on
           every scroll re-entry instead of firing only once. onEnter covers
           the section already being in view when the trigger is created
           (true on first load, since the hero fills the initial viewport) —
           routed through fireHeroEntranceOnce since the fast core-GSAP path
           above has usually already fired it by the time ScrollTrigger is
           ready. onEnterBack covers scrolling back up into it after having
           scrolled past, and always calls initHeroEntrance directly since
           every re-entry after the first should replay regardless. No
           onLeave/onLeaveBack reset is needed — each initHeroEntrance() call
           re-applies its own hidden gsap.set state before animating in, so
           it's correct to call repeatedly. */
        const initHeroEntranceRepeat = () => {
          if (reduceMotion || !window.gsap || !window.ScrollTrigger) return;
          window.gsap.registerPlugin(window.ScrollTrigger);

          const sectionId = section.id || 'hero-banner-static';
          const triggerId = `hero-entrance-${sectionId}`;
          window.ScrollTrigger.getAll().forEach((t) => {
            if (t.vars && t.vars.id === triggerId) t.kill();
          });

          const _M = window.themeMotion || {};
          window.ScrollTrigger.create({
            id: triggerId,
            trigger: section,
            start: (_M.trigger && _M.trigger.start) || 'top 75%',
            end: 'bottom top',
            // Without this, this trigger defaults to refreshPriority 0, which
            // outranks pinned sibling sections' negative, position-derived
            // priorities (showcase-hotspot, before-after-content,
            // collection-list, main-collections) when a merchant drags one of
            // them above hero-banner in the customizer — it would then
            // refresh, and lock in its start/end, before that pin finishes
            // resolving its pin-spacer height. Matches
            // before-after-content.liquid's same pattern.
            refreshPriority: window.themeScrollPriority(section),
            onEnter: fireHeroEntranceOnce,
            onEnterBack: initHeroEntrance
          });
        };

        /* Preloader handoff (Awwwards roadmap 4.3): previously gated on
           layout/theme.liquid's #site-preloader resolving
           window.themePreloaderDone as its own wipe-out *started*, so the
           hide-then-reveal above began while that mask was still animating
           away. The preloader has since been removed, so
           window.themePreloaderDone is always undefined and this always
           takes the Promise.resolve() fallback below immediately —
           fireHeroEntranceOnce's immediate=true call is what keeps that
           safe now (nothing is hidden first, so there's nothing left to
           mask). Left as-is (rather than inlined) so a future preloader
           would only need window.themePreloaderDone reinstated to regain
           the richer handoff. */
        window.onThemeGsapCoreReady(() => {
          (window.themePreloaderDone || Promise.resolve()).then(fireHeroEntranceOnce);
        });

        window.onThemeGsapReady(() => {
          /* Only gates the ScrollTrigger's creation (i.e. the replay wiring,
             since fireHeroEntranceOnce above already covers the first
             reveal) — later replays via onEnterBack aren't tied to the
             preloader at all. */
          (window.themePreloaderDone || Promise.resolve()).then(initHeroEntranceRepeat);
        });

        // Shopify customizer select events (scoped to this section)
        section.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail.blockId;
          const btn = section.querySelector(`.js-tab-button[data-target-pane="${blockId}"]`);
          if (btn) switchTab(btn);
        });
      });
    };

    initTabs();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      const section = root && (root.classList.contains('hero-banner') ? root : root.querySelector('.hero-banner'));
      if (section) initTabs(section);
    });

    /* Outright section removal (as opposed to an edit, which fires
       shopify:section:load instead): kill this instance's own ScrollTriggers
       by id — the backdrop-text and background parallax triggers created in
       initScrollTrigger()/initHeroParallax() above (id prefix
       `hero-banner-parallax-<sectionId>`) and the entrance-replay trigger
       from initHeroEntranceRepeat() (`hero-entrance-<sectionId>`) — rather
       than relying only on ScrollTrigger's own detached-element cleanup on
       next refresh. Also removes the document-level keydown listener
       initTabs() bound above, since that listener otherwise outlives the
       section indefinitely. Matches sections/before-after-content.liquid's
       pattern. */
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target;
      const section = root && (root.classList.contains('hero-banner') ? root : root.querySelector('.hero-banner'));
      if (!section) return;

      if (section._heroTabsKeydownHandler) {
        document.removeEventListener('keydown', section._heroTabsKeydownHandler);
        section._heroTabsKeydownHandler = null;
      }
      if (section._heroTabsResizeHandler) {
        window.removeEventListener('resize', section._heroTabsResizeHandler);
        section._heroTabsResizeHandler = null;
      }

      const ST = window.ScrollTrigger;
      if (!ST) return;
      const sectionId = section.id || 'hero-banner-static';
      const parallaxPrefix = `hero-banner-parallax-${sectionId}`;
      const entranceId = `hero-entrance-${sectionId}`;
      ST.getAll().forEach((t) => {
        const id = t.vars && t.vars.id;
        if (!id) return;
        if (id.indexOf(parallaxPrefix) === 0 || id === entranceId) t.kill();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
     from each trigger's live document position instead of a fixed number —
     merchants can reorder sections in the theme customizer, so a hardcoded
     priority goes stale the moment the order changes. See hero-banner/
     collection-list/bundle-products/multicolumn for the same pattern. */
  function imageGalleryScrollPriority(el) {
    return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
  }

  function initImageGalleryHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.image-gallery_heading-head');
    if (!headingHead) return;

    var idPrefix = 'ig-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.image-gallery_tagline-text');
    var heading = headingHead.querySelector('.image-gallery_heading');
    var description = headingHead.querySelector('.image-gallery_description');
    var ctaButton = headingHead.querySelector('.button');

    /* The split is left in place rather than reverted on complete since it
       needs to remain animatable for repeat entries — toggleActions below
       replays this reveal every time the heading scrolls back into view,
       and initImageGalleryCards uses the same treatment so the heading and
       slide captions stay in sync instead of drifting apart on scroll-back. */
    var headingSplit = window.themeSplitHeading(heading);
    var descriptionSplit = window.themeSplitHeading(description);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descriptionSplit.targets || [],
      ctaButton || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix + '-head',
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 75%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: imageGalleryScrollPriority(headingHead)
      }
    }));
  }

  /* Each slide's own caption heading/description, revealed together as the
     whole slider scrolls into view (rather than per-slide triggers, which
     would all fire at roughly the same scroll position anyway since slides
     sit side-by-side horizontally). gsap-slider.js's carousel-slider mounts
     immediately once GSAP is ready (unlike the old Splide.js, it does not
     wait for the slider to scroll into view), inserting loop clones
     synchronously via rebuildClones() — and that mount races this same
     onThemeGsapReady queue. The clones are cloneNode(true) duplicates, so
     they carry the identical .image-gallery_slide class; explicitly
     excluding [data-slide-clone] below keeps this always touching only the
     real slide elements regardless of which side of that race wins. Without
     it, a real slide and its clone twin end up as two independent
     ScrollTrigger.batch() targets for the "same" visual image, and only
     whichever one crosses the trigger threshold gets revealed — the caption
     then appears to land on a different slide each load. */
  function initImageGalleryCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var slider = section.querySelector('.image-gallery_slider');
    if (!slider) return;

    var idPrefix = 'ig-cards-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var cards = Array.prototype.slice.call(section.querySelectorAll('.image-gallery_slide:not([data-slide-clone])'));
    if (!cards.length) return;

    var preset = null;
    var allTargets = [];
    cards.forEach(function (card) {
      var heading = card.querySelector('.image-card_heading');
      var description = card.querySelector('.image-card_description');
      if (heading) {
        var headingSplit = window.themeSplitHeading(heading);
        if (!preset) preset = headingSplit;
        allTargets = allTargets.concat(headingSplit.targets || []);
      }
      if (description) {
        var descSplit = window.themeSplitHeading(description);
        if (!preset) preset = descSplit;
        allTargets = allTargets.concat(descSplit.targets || []);
      }
    });
    if (!allTargets.length || !preset) return;

    var _M = window.themeMotion || {};
    var _useClip = (_M.flags ? _M.flags.clipReveals !== false : true);
    var _batchStart = (_M.trigger && _M.trigger.start) || 'top 75%';
    var _staggerStep = (_M.stagger && _M.stagger.tight) || 0.06;

    /* Sets a batch of items (and their images, under the clip-reveal preset)
       back to their pre-reveal hidden state — used both for the initial
       setup below and by onLeaveBack to re-hide a batch once it scrolls back
       out, so the next onEnter has something to animate from. */
    function hideGalleryItems(items) {
      items.forEach(function (item) {
        var img = item.querySelector('img');
        if (_useClip) {
          gsap.set(item, { clipPath: 'inset(0 0 100% 0)', overflow: 'hidden' });
          if (img) gsap.set(img, { scale: 1.12, transformOrigin: 'center center' });
        } else {
          gsap.set(item, preset.fromVars);
        }
      });
    }

    /* Hand the whole set to ScrollTrigger.batch() instead of creating one
       ScrollTrigger per item. batch() groups items that enter the viewport
       within the same short window into a single callback — for a gallery
       with N captions that's a handful of triggers instead of up to 2N, at
       the cost of the stagger now being relative to each batch's entry
       rather than a single global index (items still reveal in the same
       order, just grouped). onLeaveBack re-hides a batch as it scrolls back
       out upward so scrolling forward into it again replays the reveal. */
    hideGalleryItems(allTargets);

    var cardBatch = ST.batch(allTargets, {
      interval: 0.1,
      start: _batchStart,
      /* initImageGalleryHeading (above) already sets this on its own trigger;
         this batch never did, so its start positions could get computed
         before/after sibling pinned sections (hero-banner, main-collections,
         etc. — see window.themeScrollPriority in theme.liquid) finish
         resolving their own pin-spacer heights on the same refresh pass,
         landing a few pixels off in either direction depending on refresh
         order. For captions sitting right at the 'top 75%' threshold, that's
         the difference between entering on this refresh or the next —
         exactly the "reveals on card 1 sometimes, 2 or 3 other times"
         inconsistency between loads. */
      refreshPriority: imageGalleryScrollPriority(slider),
      onEnter: function (batch) {
        if (_useClip) {
          gsap.to(batch, {
            clipPath: 'inset(0 0 0% 0)',
            duration: (_M.dur && _M.dur.slow) || 1.0,
            ease: (_M.ease && _M.ease.reveal) || 'expo.out',
            stagger: _staggerStep,
            clearProps: 'clipPath',
            overwrite: 'auto'
          });
          batch.forEach(function (item, bi) {
            var img = item.querySelector('img');
            if (!img) return;
            gsap.to(img, {
              scale: 1,
              duration: (_M.dur && _M.dur.xslow) || 1.4,
              ease: 'power2.out',
              delay: bi * _staggerStep,
              overwrite: 'auto'
            });
          });
        } else {
          gsap.to(batch, Object.assign({}, preset.toVars, {
            duration: preset.duration,
            ease: preset.ease,
            stagger: _staggerStep,
            overwrite: 'auto'
          }));
        }
      },
      onLeaveBack: function (batch) {
        hideGalleryItems(batch);
      }
    });
    /* Tag the batch's own triggers with idPrefix so the kill-before-rebuild
       pass above (ST.getAll()... indexOf(idPrefix) === 0) still finds and
       clears them on the next theme-editor reload. */
    cardBatch.forEach(function (t, i) { t.vars.id = idPrefix + '-batch-' + i; });
    /* Custom web fonts swapping in after this batch's start positions were
       first measured (FOUT/FOIT) can reflow the heading/description text —
       different line count, different vertical offset — invalidating those
       positions for whichever captions hadn't crossed 'top 75%' yet. The
       layout-wide equivalent (syncSpacerHeight in theme.liquid) only runs on
       the index template behind ScrollSmoother, so any other template using
       this section had no such correction at all. Re-measuring once fonts
       are actually ready removes that source of "correct on one load, off by
       a card on the next" depending on font-cache timing. */
    if (window.document.fonts && window.document.fonts.status !== 'loaded') {
      window.document.fonts.ready.then(function () {
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      });
    }

    /* gsap-slider.js's loop engine (rebuildClones) cloneNode(true)s real
       slides to fill out the wrap-around region — a plain DOM duplicate,
       inline styles included. If a clone gets made from a real slide whose
       caption GSAP had already set to its pre-reveal hidden state (clipPath:
       inset(0 0 100% 0)), that hidden clip-path is baked into the clone
       permanently; clones are deliberately excluded from `cards`/allTargets
       above (they're not real content, and the ScrollTrigger.batch() above
       only ever targets real slides), so nothing was left to ever un-hide
       them. With the clone buffer now sized to cover a full viewport's worth
       (see gsap-slider.js's rebuildClones), clones sit on screen for
       extended stretches as the "preview" of wrapped-around content next to
       whichever real slide is centered — not just a brief flash during a
       wrap — so a frozen-hidden clone caption reads as "this slide's text
       comes and goes at random" as the carousel advances between showing the
       real instance and a clone instance of the same image. Force clone
       captions straight to their revealed end-state (never animated, no
       reveal needed — the real instance already played it) whenever the
       engine (re)builds the clone region, decoupled from its internals via a
       plain MutationObserver on the list rather than reaching into the
       Slider class. */
    var list = slider.querySelector('.splide__list');
    if (list) {
      var revealCloneCaptions = function () {
        Array.prototype.forEach.call(list.querySelectorAll('[data-slide-clone]'), function (card) {
          [card.querySelector('.image-card_heading'), card.querySelector('.image-card_description')].forEach(function (el) {
            if (!el) return;
            var splitChildren = el.querySelectorAll('.theme-split-line, .theme-split-word, .theme-split-char');
            var targets = splitChildren.length ? Array.prototype.slice.call(splitChildren) : [el];
            if (_useClip) {
              gsap.set(targets, { clipPath: 'inset(0 0 0% 0)' });
            } else {
              gsap.set(targets, preset.toVars);
            }
          });
          var cloneImg = card.querySelector('img');
          if (cloneImg) gsap.set(cloneImg, { scale: 1 });
        });
      };
      revealCloneCaptions();
      new MutationObserver(revealCloneCaptions).observe(list, { childList: true });
    }

    /* Image hover zoom */
    if ((_M.flags ? _M.flags.imageHover !== false : true) && window.matchMedia('(pointer: fine)').matches) {
      Array.from(allTargets).forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;
        item.addEventListener('mouseenter', function () {
          gsap.to(img, { scale: 1.07, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
        item.addEventListener('mouseleave', function () {
          gsap.to(img, { scale: 1, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
      });
    }
  }

  function initAllImageGalleryHeadings() {
    document.querySelectorAll('.image-gallery').forEach(function (section) {
      initImageGalleryHeading(section);
      initImageGalleryCards(section);
    });
  }

  window.onThemeGsapReady(initAllImageGalleryHeadings);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('image-gallery')
      ? root
      : (root && root.querySelector ? root.querySelector('.image-gallery') : null);
    if (!section) return;
    window.onThemeGsapReady(function () {
      initImageGalleryHeading(section);
      initImageGalleryCards(section);
    });
  });

  /* Dragging sections in the customizer moves DOM nodes without firing
     shopify:section:load, so imageGalleryScrollPriority()'s refreshPriority
     — baked into each trigger at creation time above — would keep reflecting
     the section's old document position; theme.liquid's global debounced
     ScrollTrigger.refresh() recomputes start/end pixel positions on reorder
     but not that baked-in priority, since that requires recreating the
     trigger rather than just refreshing it. Reinitializing every instance
     kills each section's existing triggers by id (see the kill-before-
     rebuild passes in initImageGalleryHeading/initImageGalleryCards above)
     before recreating them, so this picks up the current position/priority
     for every instance under the new order. Matches
     sections/collection-list.liquid's pattern. */
  document.addEventListener('shopify:section:reorder', function () {
    window.onThemeGsapReady(initAllImageGalleryHeadings);
  });

  /* Outright section removal (as opposed to an edit, which fires
     shopify:section:load instead): kill this instance's own ScrollTriggers
     by id — both the heading reveal (idPrefix 'ig-<sectionId>' from
     initImageGalleryHeading) and the card-caption triggers (idPrefix
     'ig-cards-<sectionId>' from initImageGalleryCards, which also covers
     that function's ScrollTrigger.batch() sub-triggers since those are
     tagged 'ig-cards-<sectionId>-batch-<i>') — rather than relying only on
     ScrollTrigger's own detached-element cleanup on next refresh. Matches
     sections/before-after-content.liquid's pattern. */
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('image-gallery')
      ? root
      : (root && root.querySelector ? root.querySelector('.image-gallery') : null);
    var ST = window.ScrollTrigger;
    if (!section || !section.id || !ST) return;
    var prefixes = ['ig-' + section.id, 'ig-cards-' + section.id];
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (!id) return;
      for (var i = 0; i < prefixes.length; i++) {
        if (id.indexOf(prefixes[i]) === 0) { t.kill(); break; }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-content"] && !Shopify.designMode) return;
  try {
    
  const initImageContentWidth = () => {
    const updateVisualWidth = () => {
      if (window.innerWidth < 768) {
        document.querySelectorAll('.image-content').forEach((section) => {
          const visualCol = section.querySelector('.image-content_col--visual');
          if (visualCol) {
            visualCol.style.width = '';
            visualCol.style.marginRight = '';
            visualCol.style.marginLeft = '';
          }
        });
        return;
      }
      const clientWidth = document.documentElement.clientWidth;
      const sections = document.querySelectorAll('.image-content');
      sections.forEach((section) => {
        const visualCol = section.querySelector('.image-content_col--visual');
        const colsWrap = section.querySelector('.image-content_cols-wrap');
        if (!visualCol || !colsWrap) return;

        const position = colsWrap.getAttribute('data-media-position') || 'row-reverse';
        const rect = visualCol.getBoundingClientRect();

        if (position === 'row') {
          const calcWidth = rect.right;
          visualCol.style.width = `${calcWidth}px`;
          visualCol.style.marginLeft = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
          visualCol.style.marginRight = '';
        } else {
          const calcWidth = clientWidth - rect.left;
          visualCol.style.width = `${calcWidth}px`;
          visualCol.style.marginRight = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
          visualCol.style.marginLeft = '';
        }
      });
    };

    updateVisualWidth();
    window.addEventListener('load', updateVisualWidth);
    window.addEventListener('resize', updateVisualWidth);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('image-content') || event.target.querySelector('.image-content')) {
        updateVisualWidth();
      }
    });
  };
  initImageContentWidth();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  // <scroll-component> (the marquee custom element) is defined once, globally,
  // in assets/scroll-component.js — see that file for the implementation.

  /* ── Logo list section entrance ──────────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playLogoListReveal(section) {
      var _M = window.themeMotion || {};
      var head  = section.querySelector('[class*="logo-list_heading"], [class*="logo-list_head"]');
      var track = section.querySelector('.logo-list_scroll-component, [class*="logo-list_track"], [class*="logo-list_marquee"], [class*="scrolling"]');
      var targets = [head, track].filter(Boolean);
      if (!targets.length) return;

      gsap.set(targets, { opacity: 0, y: 28 });
      gsap.to(targets, {
        opacity: 1, y: 0,
        duration: (_M.dur && _M.dur.slow) || 1.0,
        ease: (_M.ease && _M.ease.enter) || 'power4.out',
        stagger: (_M.stagger && _M.stagger.loose) || 0.18,
        overwrite: 'auto'
      });
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initLogoListSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'logo-list-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it on the page, so it could lock in a stale start/end before
        // that sibling pinned section finishes resolving its own
        // pin-spacer height on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playLogoListReveal(section); },
        onEnterBack: function () { playLogoListReveal(section); }
      });
    }

    document.querySelectorAll('.logo-list').forEach(initLogoListSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('logo-list') ? root : root.querySelector('.logo-list'));
      if (s) { initLogoListSection(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-activate-account"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  const selectors = {
    customerAddresses: '[data-customer-addresses]',
    addressCountrySelect: '[data-address-country-select]',
    addressContainer: '[data-address]',
    toggleAddressButton: 'button[data-address-button]',
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: 'button[data-confirm-message]',
  };
  const attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message',
  };
  class CustomerAddresses {
    constructor() {
      this.elements = this._getElements();
      if (Object.keys(this.elements).length === 0) return;
      this._setupCountries();
      this._setupEventListeners();
    }

    _getElements() {
      const container = document.querySelector(selectors.customerAddresses);
      return container
        ? {
            container,
            addressContainer: container.querySelector(selectors.addressContainer),
            toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
            cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
            deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
            countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
          }
        : {};
    }

    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        });
        this.elements.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
            hideElement: `AddressProvinceContainer_${formId}`,
          });
        });
      }
    }

    _setupEventListeners() {
      this.elements.toggleButtons.forEach((element) => {
        element.addEventListener('click', this._handleAddEditButtonClick);
      });
      this.elements.cancelButtons.forEach((element) => {
        element.addEventListener('click', this._handleCancelButtonClick);
      });
      this.elements.deleteButtons.forEach((element) => {
        element.addEventListener('click', this._handleDeleteButtonClick);
      });
    }

    _toggleExpanded(target) {
      target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
    }

    _handleAddEditButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);
    };

    _handleCancelButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
    };

    _handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: 'delete' },
        });
      }
    };
  }
  window.addEventListener('load', () => {
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  });
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalAddressToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-address-toggler')) customElements.define('modal-address-toggler', ModalAddressToggler);
  class ModalAddressComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-address-component')) customElements.define('modal-address-component', ModalAddressComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  /* ── Main blog entrance ─────────────────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playMainBlogReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('.main-blog_heading-head');
      var tagline  = headWrap && headWrap.querySelector('.main-blog_tagline');
      var heading  = headWrap && headWrap.querySelector('.main-blog_heading');
      var desc     = headWrap && headWrap.querySelector('.main-blog_description');
      var cards    = section.querySelectorAll('.main-blog_grid-col');
      var pagination = section.querySelector('.main-blog_pagination, [class*="pagination"]');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      var headOffset = 0;
      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 20 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        headOffset = 0.15;
      }
      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, {
            duration: split.duration, ease: split.ease, stagger: split.stagger
          }), headOffset);
        } else {
          gsap.set(heading, { opacity: 0, y: 28 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset);
        }
      }
      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
            duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
          }), headOffset + 0.2);
        } else {
          gsap.set(desc, { opacity: 0, y: 20 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset + 0.2);
        }
      }

      if (cards.length && (_M.flags ? _M.flags.staggerCards !== false : true)) {
        gsap.set(cards, { opacity: 0, y: 52, scale: 0.97 });
        tl.to(cards, {
          opacity: 1, y: 0, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1,
          clearProps: 'scale'
        }, headWrap ? 0.3 : 0);
      }

      if (pagination) {
        gsap.set(pagination, { opacity: 0, y: 20 });
        tl.to(pagination, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, '+=0.1');
      }
    }

    function initMainBlogSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'main-blog-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it, so it could refresh and lock in a stale start/end before
        // sibling pinned sections finish resolving their own pin-spacer
        // heights on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playMainBlogReveal(section); },
        onEnterBack: function () { playMainBlogReveal(section); }
      });
    }

    document.querySelectorAll('.main-blog').forEach(initMainBlogSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('main-blog') ? root : root.querySelector('.main-blog'));
      if (s) { initMainBlogSection(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class CartDrawerDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-drawer-dropdown')) {
    customElements.define('cart-drawer-dropdown', CartDrawerDropdown);
  }
  class CartWidgetDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.closeBtns = this.querySelectorAll('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
      if (this.closeBtns.length) {
        this.closeBtns.forEach((closeBtn) => {
          closeBtn.addEventListener('click', () => {
            this.closeDropdown();
          });
        });
      }
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('cart-widget-dropdown')) {
    customElements.define('cart-widget-dropdown', CartWidgetDropdown);
  }
  class ModalCartToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-cart-toggler'))
    customElements.define('modal-cart-toggler', ModalCartToggler);
  class ModalCartRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);

      this.applyColorScheme = (body) => {
        const { colorScheme } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      this.applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }

    open(toggler = null) {
      this.toggler = toggler;
      if (this.toggler) this.toggler.classList.add('btn-loading');
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }

    close() {
      if (this.toggler) this.toggler.classList.remove('btn-loading');
      const parent = this.querySelector(this.dataset.selector);
      if (parent) parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }

    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }

    renderModal() {
      if (this.toggler) this.toggler.classList.add('btn-loading');
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          if (parent && html) parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          if (this.toggler) this.toggler.classList.remove('btn-loading');
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
        });
    }

    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }

    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      if (flag) {
        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('click', this.onBodyClick);
      } else {
        this.removeEventListener('keyup', this.onKeyUp);
        this.removeEventListener('click', this.onBodyClick);
      }
    }

    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (!boundings || boundings.contains(target) || target === boundings) return;
      this.close();
    }

    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-cart-render-component'))
    customElements.define('modal-cart-render-component', ModalCartRenderComponent);
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const button = event.target.closest('button');
        if (!button) return;
        const previousValue = this.input.value;
        button.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]') || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 300);
      this.inputUpdate.addEventListener('input', (event) => {
        const parentElement = document.querySelector(this.dataset.parentSelector);
        const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
        if (localLoader) localLoader.classList.remove('hidden');
        if (parentElement) parentElement.classList.add('is-loading');
        this.debouncedOnUpdate(event);
      });
    }

    onLineItemUpdate() {
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      const parentElement = document.querySelector(this.dataset.parentSelector);
      const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
      if (localLoader) localLoader.classList.remove('hidden');
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const handleLineError = (parent, response) => {
    const parentElement = typeof parent === 'string' ? document.querySelector(parent) : parent;
    const errorContainer = parentElement ? parentElement.querySelector('[data-render-error]') : null;
    if (errorContainer) {
      errorContainer.classList.remove('hidden');
      errorContainer.innerText = response.errors;
    }
    const qtyInput = parentElement ? parentElement.querySelector('input[name="updates[]"]') : null;
    if (qtyInput) qtyInput.value = parseFloat(parentElement.dataset.initQty);
    return (this.erorr = true);
  };
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  const lineItemUpdate = (line, quantity, sections, parent, id = null, itemKey = null) => {
    const parentElement = typeof parent === 'string' ? document.querySelector(parent) : parent;
    const localLoader = parentElement ? parentElement.querySelector('[data-loader]') : null;
    if (localLoader) localLoader.classList.remove('hidden');
    if (parentElement) parentElement.classList.add('is-loading');
    const drawerContainer = document.querySelector('[data-line-items-drawer-container]') || document.querySelector('[data-line-items-container]');
    if (drawerContainer) drawerContainer.classList.add('cart-loading');
    const secArr = JSON.parse(sections);
    let url = routes.cart_change_url;
    let bodyObj = {
      sections: secArr.map((section) => section.id),
      sections_url: window.location.pathname,
    };

    if (id && itemKey) {
      url = routes.cart_update_url;
      bodyObj.updates = {
        [itemKey]: 0,
        [id]: quantity
      };
    } else {
      bodyObj.line = line;
      bodyObj.quantity = quantity;
    }
    
    var body = JSON.stringify(bodyObj);
    this.erorr = false;
    fetch(`${url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if (response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (localLoader) localLoader.classList.add('hidden');
        if (parentElement) parentElement.classList.remove('is-loading');
        if (drawerContainer) drawerContainer.classList.remove('cart-loading');
        if (!this.erorr) {
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if (modal) {
            if (modal.classList.contains('modal--active')) {
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
      });
  };
  class CartItemEditVariant extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggles = Array.from(this.querySelectorAll('[data-dropdown-toggler]'));
      this.contents = Array.from(this.querySelectorAll('[data-dropdown-content]'));
      this.variantJson = JSON.parse(this.querySelector('[data-variant-json]').textContent);
      this.currentOptions = JSON.parse(this.dataset.currentOptions || '[]');

      this.toggles.forEach((toggle, index) => {
        toggle.addEventListener('click', () => {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            this.closeDropdown(index);
          } else {
            this.openDropdown(index);
          }
        });
      });

      this.contents.forEach((content, optionIndex) => {
        content.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleOptionChange(optionIndex, btn.dataset.optionValue);
          });
        });
      });
    }

    openDropdown(index) {
      // Close others
      this.toggles.forEach((_, i) => { if(i !== index) this.closeDropdown(i); });

      const toggle = this.toggles[index];
      const content = this.contents[index];
      
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('dropdown--open');
      this.doAnimate(content);
      
      trapFocus(content);
      this._onBodyClick = this._onBodyClick || this.onBodyClick.bind(this);
      this._onKeyUp = this._onKeyUp || this.onKeyUp.bind(this);
      
      document.body.addEventListener('click', this._onBodyClick);
      this.addEventListener('keyup', this._onKeyUp);
    }

    closeDropdown(index) {
      const toggle = this.toggles[index];
      const content = this.contents[index];
      if (!toggle) return;
      
      toggle.setAttribute('aria-expanded', 'false');
      content.classList.remove('dropdown--open');
      
      document.body.removeEventListener('click', this._onBodyClick);
      this.removeEventListener('keyup', this._onKeyUp);
    }

    onBodyClick(event) {
      if (this.contains(event.target)) return;
      this.toggles.forEach((_, i) => this.closeDropdown(i));
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.toggles.forEach((_, i) => this.closeDropdown(i));
      }
    }

    doAnimate(element) {
      try {
        const frames = JSON.parse(element.dataset.frames);
        const options = JSON.parse(element.dataset.options);
        if (frames && options) element.animate(frames, options);
      } catch(e) {}
    }

    handleOptionChange(optionIndex, value) {
      this.toggles.forEach((_, i) => this.closeDropdown(i));
      
      const newOptions = [...this.currentOptions];
      newOptions[optionIndex] = value;
      
      const matchingVariant = this.variantJson.find(v => {
        return v.options.every((opt, i) => opt === newOptions[i]);
      });

      if (matchingVariant && matchingVariant.id !== parseInt(this.dataset.variantId)) {
        this.updateVariant(matchingVariant.id);
      } else if (!matchingVariant) {
        console.warn('No matching variant found for options:', newOptions);
      }
    }

    updateVariant(variantId) {
      lineItemUpdate(
        this.dataset.lineId, 
        this.dataset.quantity, 
        this.dataset.sections, 
        this.dataset.parentSelector,
        variantId,
        this.dataset.itemKey
      );
    }
  }
  if (!customElements.get('cart-item-edit-variant')) {
    customElements.define('cart-item-edit-variant', CartItemEditVariant);
  }
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-cart-totals'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'data-cart-totals' && oldValue !== newValue) {
            this.update();
          }
        }

        connectedCallback() {
          // Disable transitions before first update so milestone points
          // jump instantly to their correct positions (no jerk on open)
          this.classList.add('no-transition');
          this.update();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.classList.remove('no-transition');
            });
          });
        }

        update() {
          const rateFactor = Shopify.currency.rate || 1;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
          const epsilon = 0.001;

          // Milestones configuration
          const milestones = [
            {
              id: 'shipping',
              threshold: parseFloat(this.dataset.amount) * rateFactor,
              successText: this.dataset.freeShippingUnlockedText || 'Free shipping unlocked!',
              label: this.dataset.freeShippingLabel || window.cartStrings.freeShipping
            }
          ];

          if (this.hasAttribute('data-discount-amount')) {
            milestones.push({
              id: 'discount',
              threshold: parseFloat(this.dataset.discountAmount) * rateFactor,
              successText: this.dataset.discountUnlockedText || 'Discount activated!',
              label: this.dataset.discountText || 'Discount'
            });
          }

          // Sort milestones by threshold to handle any user order
          milestones.sort((a, b) => a.threshold - b.threshold);

          const achieved = milestones.filter(m => cartTotals >= m.threshold - epsilon);
          const next = milestones.find(m => cartTotals < m.threshold - epsilon);

          const textContainer = this.querySelector('.shipping-bar_text');
          if (textContainer) {
            if (!this.baseTextTemplate) {
              this.baseTextTemplate = this.dataset.textTemplate || textContainer.innerHTML;
            }

            let message = '';
            if (achieved.length > 0) {
              message = achieved.map(m => m.successText).join(' & ');
            }

            if (next) {
              const remaining = next.threshold - cartTotals;
              const nextMessage = next.id === 'shipping' 
                ? this.baseTextTemplate.replace(/\|\|amount\|\|/g, `<span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span>`)
                : `Add <span>${Shopify.formatMoney(remaining * 100, window.money_format)}</span> more for <span>${next.label}</span>`;
              
              message = message ? `${message} ${nextMessage}` : nextMessage;
            }

            textContainer.innerHTML = message || window.cartStrings.shippingAmount;
          }

          // Update Progress Bar Appearance
          const maxThreshold = milestones.length > 0 ? Math.max(...milestones.map(m => m.threshold)) : 100;
          const value = Math.min((cartTotals / maxThreshold) * 100, 100);
          
          const fill = this.querySelector('.milestone-fill');
          if (fill) {
            fill.style.width = value.toFixed(2) + '%';
            if (value >= 100 - epsilon) {
              fill.classList.add('is-full');
            } else {
              fill.classList.remove('is-full');
            }
          }

          milestones.forEach(m => {
            const milestoneEl = this.querySelector(`.milestone-point--${m.id}`);
            if (milestoneEl) {
              const percent = Math.min((m.threshold / maxThreshold) * 100, 100);
              milestoneEl.style.left = percent + '%';
              if (cartTotals >= m.threshold - epsilon) {
                milestoneEl.classList.add('is-active');
              } else {
                milestoneEl.classList.remove('is-active');
              }
            }
          });
        }
      }
    );
  }
  class cartDiscountCode extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('button');
      const input = this.querySelector('input[name="discount_code"]');
      if (!button || !input) return;
      const onClick = (event) => {
        event.preventDefault();
        button.classList.add('btn-loading');
        const secArr = JSON.parse(this.dataset.sections);
        const discountCode = input.value.trim();
        var body = JSON.stringify({
          discount: discountCode,
          sections: secArr.map((section) => section.id),
          sections_url: window.location.pathname,
        });
        this.erorr = false;
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const response = JSON.parse(responseText);
            if (response.errors) return handleLineError(parent, response);
            sectionArrRender(secArr, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('btn-loading');
            if (!this.erorr) {
              const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
              if (modal) {
                if (modal.classList.contains('modal--active')) {
                  trapFocus(modal.content);
                  modal.setListeners(true);
                }
              }
            }
          });
      };
      this.onClick = onClick;
      button.addEventListener('click', onClick);
    }
  }
  if (!customElements.get('cart-discount-code')) customElements.define('cart-discount-code', cartDiscountCode);
  if (!customElements.get('line-item-remove')) {
    customElements.define(
      'line-item-remove',
      class LineItemRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const onRemoval = (event) => {
            event.preventDefault();
            this.button.classList.add('btn-loading');
            lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
          };
          this.removal = onRemoval.bind(this);
          this.button.addEventListener('click', this.removal);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collections"]) return;
  try {
    
  /* ── Motion Design System: heading, card entrance, stack-pin and hover ─────
     Rebuilt on the theme's shared window.onThemeGsapReady queue (instead of
     DOMContentLoaded) so it works whether GSAP loads before or after this
     section's markup, reading timing/easing from window.themeMotion instead
     of hardcoding it. Structurally identical to sections/collection-list.liquid's
     stack implementation (same card partial, same stack-pin mechanics) so the
     two sections' shared "stack of collection cards" effect behaves and tunes
     identically instead of drifting apart. */
  /* Both delegate to layout/theme.liquid's window.themeSplitWords/
     window.themeScrollPriority — shared with sections/collection-list.liquid,
     which had byte-identical copies of this logic under a 'cl' prefix. The
     'mc' prefix here keeps this section's own class names/dataset flag
     (.mc-word-wrap/.mc-word-inner, data-mc-split) exactly as they were;
     only the duplicated logic moved, not this section's markup contract. */
  function mainCollectionsSplitWords(el) {
    return window.themeSplitWords(el, 'mc');
  }

  function mainCollectionsScrollPriority(el) {
    return window.themeScrollPriority(el);
  }

  function initMainCollectionsHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.main-collections_heading-head');
    if (!headingHead) return;

    var idPrefix = 'mc-head-' + section.id;
    var oldHeadTrigger = ST.getById(idPrefix);
    if (oldHeadTrigger) oldHeadTrigger.kill();

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.main-collections_tagline-text');
    var heading = headingHead.querySelector('.main-collections_heading');
    var desc = headingHead.querySelector('.main-collections_description');

    if (heading) {
      heading.style.visibility = '';
      if (heading.dataset.mcSplit || heading.querySelector('.mc-word-wrap')) {
        heading.textContent = heading.textContent;
        delete heading.dataset.mcSplit;
      }
    }

    var headingSplit = window.themeSplitHeading(heading);
    var descSplit = window.themeSplitHeading(desc);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descSplit.targets || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix,
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: mainCollectionsScrollPriority(headingHead)
      }
    }));
  }

  /* Per-card entrance reveal for non-stack instances. Always clears its own
     inline styles on the card's sub-elements first — covers the stack /
     no-stack mode switch on resize, where the pin-stack timeline above owns
     these cards instead and this must get completely out of its way. */
  function initMainCollectionsCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    var idPrefix = 'mc-card-' + section.id + '-';
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });
    if (window.innerWidth < 768) return;

    var cards = section.querySelectorAll('.collection-list-card');

    cards.forEach(function (card) {
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      var textCol = card.querySelector('.collection-list-card_content-col--one');
      [topBar, imgWrap, img, textCol].filter(Boolean).forEach(function (el) { gsap.set(el, { clearProps: 'all' }); });
    });

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var _M = window.themeMotion || {};
    if (reduceMotion) return;
    /* If stack-pin mode or collapsible mode is active on this device, skip entrance batch */
    var isDesktop = window.innerWidth >= 768;
    var currentAnim = isDesktop
      ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
      : (section.dataset.animationMobile || 'none');
    if (currentAnim === 'stacked' || currentAnim === 'collapsible') return;

    /* Resets a card's animated sub-elements to their pre-reveal hidden
       state — used both for the initial setup below and by onLeaveBack to
       re-hide a card once it scrolls back out, so scrolling forward into it
       again replays the same entrance. Every card goes through this (not
       just ones below the fold): a card already in view when its
       ScrollTrigger is created just has onEnter fire immediately, which
       matches how every other entrance reveal in this theme treats
       above-the-fold content. */
    function hideCard(card) {
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      var textCol = card.querySelector('.collection-list-card_content-col--one');

      if (topBar) gsap.set(topBar, { opacity: 0, y: -10 });
      if (imgWrap) gsap.set(imgWrap, { clipPath: 'inset(0 0 100% 0)' });
      if (img) gsap.set(img, { scale: 1.14, transformOrigin: 'center center' });
      if (textCol) gsap.set(textCol, { opacity: 0, x: -24 });
    }

    cards.forEach(function (card) { hideCard(card); });

    /* ScrollTrigger.batch() instead of one ST.create() per card — same
       technique image-gallery.liquid already established for this codebase,
       now also applied to sections/collection-list.liquid's identical card
       reveal. Cards entering the viewport within the same short window
       animate together via a single grouped callback instead of each card
       firing its own independent onEnter, which matters on a collections
       page with 20+ cards in the grid. */
    var _staggerStep = (_M.stagger && _M.stagger.tight) || 0.08;
    var cardBatch = ST.batch(Array.prototype.slice.call(cards), {
      interval: 0.1,
      start: (_M.trigger && _M.trigger.start) || 'top 82%',
      end: 'bottom top',
      /* initMainCollectionsHeading/initMainCollectionsStack (above) already set
         this on their own triggers; this batch never did, so its start position
         could get computed before/after sibling pinned sections (hero-banner,
         image-gallery, etc. — see window.themeScrollPriority in theme.liquid)
         finish resolving their own pin-spacer heights on the same refresh pass,
         landing a few pixels off in either direction depending on refresh order.
         For cards sitting right at the 'top 82%' threshold, that's the
         difference between entering on this refresh or the next. */
      refreshPriority: mainCollectionsScrollPriority(section),
      onEnter: function (batch) {
        batch.forEach(function (card, i) {
          var topBar = card.querySelector('.collection-list-card_top-bar');
          var imgWrap = card.querySelector('.collection-list-card_content-image');
          var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
          var textCol = card.querySelector('.collection-list-card_content-col--one');

          var tl = gsap.timeline({ defaults: { overwrite: 'auto' }, delay: i * _staggerStep });
          if (topBar) tl.to(topBar, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.fast) || 0.55, ease: (_M.ease && _M.ease.enter) || 'power3.out' }, 0);
          if (imgWrap) tl.to(imgWrap, { clipPath: 'inset(0 0 0% 0)', duration: (_M.dur && _M.dur.slow) || 1.1, ease: 'expo.out' }, 0.06);
          if (img) tl.to(img, { scale: 1, duration: (_M.dur && _M.dur.xslow) || 1.7, ease: 'power2.out' }, 0.06);
          /* Matches sections/collection-list.liquid's fallback exactly — these
             two card reveals are documented as identically tuned, and this
             0.65 vs collection-list's 0.85 was the one value that had drifted. */
          if (textCol) tl.to(textCol, { opacity: 1, x: 0, duration: (_M.dur && _M.dur.base) || 0.85, ease: (_M.ease && _M.ease.enter) || 'power3.out' }, 0.3);
        });
      },
      onLeaveBack: function (batch) {
        batch.forEach(hideCard);
      }
    });
    /* Tag the batch's own triggers with idPrefix so the kill-before-rebuild
       pass above still finds and clears them on the next theme-editor reload. */
    cardBatch.forEach(function (t, i) { t.vars.id = idPrefix + 'batch-' + i; });
  }

  /* Stack animation: pins the cards-wrap only (never the heading/description
     above it, which stays in normal scroll flow) and scrubs each card up over
     the one before it, dimming/parallaxing the outgoing card's content as the next
     card arrives. Tuned identically to sections/collection-list.liquid's stack
     (scrub 0.8, 0.5x viewport height per card, outgoing content scale/opacity
     0.94/0.22) so the two sections' shared effect matches exactly.
     headH is measured from the wrapper's top to the first card's natural top
     using getBoundingClientRect() — normally ~0 since the wrapper now starts
     right at the first card, but kept to absorb any padding/margin so there's
     no card-jump on pin. */
  function initMainCollectionsStack(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    var cards = section.querySelectorAll('.collection-list-card');
    var wrapper = section.querySelector('.main-collections_cards-wrap');
    if (!cards.length || !wrapper) return;

    var idPrefix = 'mc-stack-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id === idPrefix) t.kill();
    });

    /* Measure geometry BEFORE any DOM changes so layout is still natural.
       getBoundingClientRect includes margins/padding — offsetHeight does not. */
    var wrapperRect = wrapper.getBoundingClientRect();
    var firstCardRect = cards[0].getBoundingClientRect();

    var headH = Math.round(firstCardRect.top - wrapperRect.top);
    if (headH < 0) headH = 0;

    /* Read every top-bar height first, in its own pass, before any style is
       written. Interleaving reads (offsetHeight) with writes (setProperty) in
       a single loop forces a synchronous layout recalc on every iteration;
       batching reads-then-writes collapses that to at most one reflow. */
    var topBarHeights = [];
    cards.forEach(function (card) {
      var tb = card.querySelector('.collection-list-card_top-bar');
      topBarHeights.push(tb ? tb.offsetHeight : 0);
    });

    /* Also read background color here, before layout-affecting writes below —
       getComputedStyle would otherwise force the browser to flush those
       pending style changes first. */
    var schemeBg = getComputedStyle(cards[0]).backgroundColor;

    var accumH = headH;
    var positions = [];

    cards.forEach(function (card, i) {
      positions.push(accumH);
      card.style.setProperty('--card-height', 'calc(100vh - ' + (accumH + topBarHeights[i]) + 'px)');
      accumH += topBarHeights[i];
    });

    wrapper.style.position = 'relative';
    wrapper.style.height = window.innerHeight + 'px';

    /* This section's pin can immediately follow another pinned section (e.g.
       hero-banner) further up the page, so the combined forced scroll before
       real content is reached adds up fast. 0.5 keeps the stacking effect
       clearly visible while limiting how much extra scroll it demands. */
    var scrollDist = (cards.length - 1) * window.innerHeight * 1.0;

    cards.forEach(function (card, i) {
      card.style.position = 'absolute';
      card.style.left = '0';
      card.style.width = '100%';
      card.style.top = '0';
      card.style.zIndex = i + 1;
      card.style.pointerEvents = i === 0 ? 'auto' : 'none';
      gsap.set(card, { y: i === 0 ? headH : window.innerHeight });
    });

    /* Keep wrapper opaque so nothing behind bleeds through the heading gap
       above the first card. */
    wrapper.style.backgroundColor = (schemeBg && schemeBg !== 'rgba(0, 0, 0, 0)' && schemeBg !== 'transparent')
      ? schemeBg
      : (getComputedStyle(document.body).backgroundColor || '#fff');

    var tl = gsap.timeline({
      scrollTrigger: {
        id: idPrefix,
        trigger: wrapper,
        pin: true,
        /* Exclude the sticky header's height so its fixed overlay doesn't
           cover the top of this section once pinned. */
        start: function () { return 'top top+=' + (window.getStickyHeaderOffset ? window.getStickyHeaderOffset() : 0); },
        end: function () { return '+=' + scrollDist; },
        scrub: 0.4,
        refreshPriority: mainCollectionsScrollPriority(wrapper),
        invalidateOnRefresh: true
      }
    });

    cards.forEach(function (card, i) {
      if (i === 0) return;

      tl.to(card, {
        y: positions[i],
        ease: 'none',
        onStart: function () { card.style.pointerEvents = 'auto'; },
        onReverseComplete: function () { card.style.pointerEvents = 'none'; }
      }, '>');

      var img = card.querySelector('.collection-list-card_content-image img') ||
        card.querySelector('.collection-list-card_content-image svg');
      if (img) {
        tl.fromTo(img, { yPercent: 10 }, { yPercent: 0, ease: 'none' }, '<');
      }

      var prevContent = cards[i - 1].querySelector('.collection-list-card_content');
      var prevBackdrop = cards[i - 1].querySelector('.collection-list-card_backdrop-text');
      if (prevContent) tl.to(prevContent, { scale: 0.94, opacity: 0.22, ease: 'none' }, '<');
      if (prevBackdrop) tl.to(prevBackdrop, { yPercent: -40, opacity: 0, ease: 'none' }, '<');
    });

    var totalCards = cards.length;
    cards.forEach(function (card, i) {
      var focusableElements = card.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach(function (el) {
        if (el.dataset.mcFocusBound) return;
        el.dataset.mcFocusBound = '1';
        var isPointer = false;
        var setPointerFlag = function () {
          isPointer = true;
          setTimeout(function () { isPointer = false; }, 500);
        };
        el.addEventListener('pointerdown', setPointerFlag);
        el.addEventListener('mousedown', setPointerFlag);
        el.addEventListener('focus', function () {
          if (isPointer) return;
          try {
            if (!el.matches(':focus-visible')) return;
          } catch (err) {}
          var st = tl.scrollTrigger;
          var targetProgress = totalCards > 1 ? i / (totalCards - 1) : 0;
          gsap.to(tl, {
            progress: targetProgress,
            duration: 0.4,
            ease: 'power2.out',
            onUpdate: function () {
              if (st) window.scrollTo(0, st.start + (st.end - st.start) * tl.progress());
            }
          });
        });
      });
    });

    /* Custom fonts swapping in after this measurement can change
       .collection-list-card_top-bar's rendered text height, which is baked
       into topBarHeights/positions/scrollDist above — stale once that
       happens. Matches layout/theme.liquid's document.fonts.ready pattern:
       re-run the same measurement once fonts are actually ready. Guarded per
       section so repeated init passes (resize, section:load, reorder) don't
       stack up multiple pending re-measurements. initMainCollectionsStack
       already kills its own ScrollTrigger by id on every call, so calling it
       again here is safe. */
    if (document.fonts && !section.dataset.mcFontsReadyBound) {
      section.dataset.mcFontsReadyBound = '1';
      document.fonts.ready.then(function () { initMainCollectionsStack(section); });
    }
  }

  /* Hover: image scale. Guarded by a dataset flag so repeated init passes
     (resize, unrelated theme-editor reloads) don't stack duplicate listeners
     on cards that are already bound. */
  function initMainCollectionsHover(section) {
    var gsap = window.gsap;
    if (!gsap) return;
    section.querySelectorAll('.collection-list-card').forEach(function (card) {
      if (card.dataset.mcHoverBound) return;
      card.dataset.mcHoverBound = '1';
      var imgWrap = card.querySelector('.collection-list-card_content-image');
      var img = imgWrap ? (imgWrap.querySelector('img') || imgWrap.querySelector('svg')) : null;
      if (!img) return;
      card.addEventListener('mouseenter', function () {
        gsap.to(img, { scale: 1.07, duration: 0.65, ease: 'power2.out', overwrite: 'auto' });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(img, { scale: 1, duration: 0.9, ease: 'power2.inOut', overwrite: 'auto' });
      });
    });
  }

  /* Full reset before every (re)init pass: clears both GSAP-managed props and
     directly-set inline styles left by the stack/collapsible layout — covers a resize
     that flips a section between modes, or the theme editor reloading a section mid-scroll. */
  function resetMainCollectionsSection(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var wrapper = section.querySelector('.main-collections_cards-wrap');
    if (wrapper) { wrapper.style.position = ''; wrapper.style.height = ''; wrapper.style.backgroundColor = ''; }

    if (ST) {
      var stackId = 'mc-stack-' + section.id;
      ST.getAll().forEach(function (t) {
        var id = t.vars && t.vars.id;
        if (id === stackId) t.kill();
      });
    }

    section.querySelectorAll('.collection-list-card').forEach(function (card) {
      card.style.removeProperty('--card-height');
      card.style.removeProperty('position');
      card.style.removeProperty('left');
      card.style.removeProperty('width');
      card.style.removeProperty('top');
      card.style.removeProperty('z-index');
      var content = card.querySelector('.collection-list-card_content');
      if (content) {
        content.style.removeProperty('height');
        content.style.removeProperty('opacity');
        content.style.removeProperty('display');
        content.style.removeProperty('overflow');
      }
      if (!gsap) return;
      [
        card,
        content,
        card.querySelector('.collection-list-card_content-image'),
        card.querySelector('.collection-list-card_content-image img') ||
          card.querySelector('.collection-list-card_content-image svg'),
        card.querySelector('.collection-list-card_top-bar'),
        card.querySelector('.collection-list-card_content-col--one'),
        card.querySelector('.collection-list-card_backdrop-text')
      ].filter(Boolean).forEach(function (el) { gsap.set(el, { clearProps: 'all' }); });
    });
  }

  /* Collapsible / Accordion mode with GSAP: allows cards to expand and collapse smoothly */
  function initMainCollectionsCollapsible(section) {
    var gsap = window.gsap;
    if (!gsap) return;

    var cards = section.querySelectorAll('.collection-list-card');
    cards.forEach(function (card) {
      var content = card.querySelector('.collection-list-card_content');
      var topBar = card.querySelector('.collection-list-card_top-bar');
      var toggler = card.querySelector('.collection-list-card_toggler');
      if (!content || !topBar) return;

      var shouldBeOpen = card.dataset.openByDefault === 'true' || card.classList.contains('is-open');
      if (shouldBeOpen) {
        card.classList.add('is-open');
        gsap.set(content, { height: 'auto', opacity: 1, display: 'flex', clearProps: 'transform' });
        if (toggler) toggler.setAttribute('aria-expanded', 'true');
      } else {
        card.classList.remove('is-open');
        gsap.set(content, { height: 0, opacity: 0, display: 'none' });
        if (toggler) toggler.setAttribute('aria-expanded', 'false');
      }

      if (!card.dataset.mcCollapsibleBound) {
        card.dataset.mcCollapsibleBound = '1';
        topBar.addEventListener('click', function (e) {
          var isDesk = window.innerWidth >= 768;
          var curAnim = isDesk
            ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
            : (section.dataset.animationMobile || 'none');
          if (curAnim !== 'collapsible') return;
          var link = e.target.closest('a');
          if (link && !e.target.closest('.collection-list-card_toggler')) return;

          e.preventDefault();
          var isOpen = card.classList.contains('is-open');
          if (isOpen) {
            card.classList.remove('is-open');
            if (toggler) toggler.setAttribute('aria-expanded', 'false');
            gsap.to(content, {
              height: 0,
              opacity: 0,
              duration: 0.4,
              ease: 'power2.inOut',
              onComplete: function () {
                content.style.display = 'none';
              }
            });
          } else {
            cards.forEach(function (otherCard) {
              if (otherCard !== card && otherCard.classList.contains('is-open')) {
                otherCard.classList.remove('is-open');
                var otherToggler = otherCard.querySelector('.collection-list-card_toggler');
                var otherContent = otherCard.querySelector('.collection-list-card_content');
                if (otherToggler) otherToggler.setAttribute('aria-expanded', 'false');
                if (otherContent) {
                  gsap.to(otherContent, {
                    height: 0,
                    opacity: 0,
                    duration: 0.35,
                    ease: 'power2.inOut',
                    onComplete: function () {
                      otherContent.style.display = 'none';
                    }
                  });
                }
              }
            });

            card.classList.add('is-open');
            if (toggler) toggler.setAttribute('aria-expanded', 'true');
            content.style.display = 'flex';
            gsap.fromTo(content,
              { height: 0, opacity: 0 },
              { height: 'auto', opacity: 1, duration: 0.45, ease: 'power2.out' }
            );
          }
        });
      }
    });
  }

  /* Init a single section instance. isResize skips re-creating the heading
     reveal (already set up, and reduceMotion/dataset guards make it a no-op
     otherwise) — a resize only needs to re-decide animation modes and re-measure. */
  function initMainCollectionsReveal(section, isResize) {
    resetMainCollectionsSection(section);
    if (!isResize) initMainCollectionsHeading(section);

    var cards = section.querySelectorAll('.collection-list-card');
    if (!cards.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.innerWidth >= 768;
    var currentAnim = isDesktop
      ? (section.dataset.animationDesktop || section.dataset.animationType || 'stacked')
      : (section.dataset.animationMobile || 'none');

    if (reduceMotion) currentAnim = 'none';

    if (currentAnim === 'stacked') {
      section.classList.add('main-collections--stack-enabled');
      section.classList.remove('main-collections--collapsible-enabled');
      initMainCollectionsStack(section);
    } else if (currentAnim === 'collapsible') {
      section.classList.remove('main-collections--stack-enabled');
      section.classList.add('main-collections--collapsible-enabled');
      initMainCollectionsCollapsible(section);
    } else {
      section.classList.remove('main-collections--stack-enabled');
      section.classList.remove('main-collections--collapsible-enabled');
      initMainCollectionsCards(section);
    }
    initMainCollectionsHover(section);
  }

  /* Every main-collections section on the page. Only used for the initial
     load and for resize, where every instance genuinely needs re-measuring —
     never for a single unrelated section-editor reload. */
  function initAllMainCollectionsReveals(isResize) {
    document.querySelectorAll('.main-collections').forEach(function (section) {
      initMainCollectionsReveal(section, isResize);
    });
  }

  window.onThemeGsapReady(function () { initAllMainCollectionsReveals(false); });

  /* shopify:section:load fires for ANY section reloading in the theme editor,
     not just this one. Reinitializing every main-collections instance on the
     page in response to an unrelated section edit would kill and rebuild
     ScrollTriggers/pins that had nothing to do with the edit, fighting with
     whatever animation that other section owns. Scope the reinit to the
     section that actually reloaded. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('main-collections')
      ? root
      : (root && root.querySelector ? root.querySelector('.main-collections') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initMainCollectionsReveal(section, false); });
  });

  /* Dragging sections in the customizer moves DOM nodes without firing
     shopify:section:load, so pins created above would keep the refreshPriority
     computed from their old position. Reinitializing every instance kills
     each section's existing triggers by id before recreating them, so this
     picks up the current position/priority for every instance under the new
     order. */
  document.addEventListener('shopify:section:reorder', function () {
    window.onThemeGsapReady(function () { initAllMainCollectionsReveals(false); });
  });

  /* Outright section removal (as opposed to an edit, which fires
     shopify:section:load instead): kill this instance's own ScrollTriggers
     by id rather than relying only on ScrollTrigger's own detached-element
     cleanup on next refresh. Matches sections/showcase-hotspot.liquid's
     pattern. */
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('main-collections')
      ? root
      : (root && root.querySelector ? root.querySelector('.main-collections') : null);
    var ST = window.ScrollTrigger;
    if (!section || !section.id || !ST) return;
    var prefixes = ['mc-head-' + section.id, 'mc-card-' + section.id + '-', 'mc-stack-' + section.id];
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (!id) return;
      for (var i = 0; i < prefixes.length; i++) {
        if (id.indexOf(prefixes[i]) === 0) { t.kill(); break; }
      }
    });
  });

  (function () {
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        /* Mobile browsers fire resize when the address bar hides/shows on
           scroll — that only changes innerHeight, not innerWidth. Rebuilding
           every pinned stack ScrollTrigger mid-scroll for a non-resize caused
           visible jumps; only react to an actual width change. */
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        window.onThemeGsapReady(function () { initAllMainCollectionsReveals(true); });
      }, 220);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const btnToForgot = document.getElementById('toForgot');
  const btnToLogin = document.getElementById('toLogin');
  if (!btnToForgot || !btnToLogin) return;
  const loginWrapper = document.getElementById('login-wrapper');
  const forgetWrapper = document.getElementById('forget-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper) {
    const input = wrapper.querySelector('input[type="email"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToForgot.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToLogin.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const successElement = document.getElementById('RecoverForm-EmailSuccess');
    if (window.location.hash === '#recover' || successElement) {
      switchToRecover();
    }
  });
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const btnToAccess = document.getElementById('toAccess');
  const btnToDefault = document.getElementById('toDefault');
  if (!btnToAccess || !btnToDefault) return;
  const loginWrapper = document.getElementById('direct-wrapper');
  const forgetWrapper = document.getElementById('access-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper, pass) {
    const input = wrapper.querySelector('input[type="email"]') || wrapper.querySelector('input[type="password"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToAccess.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToDefault.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const errorElement = document.getElementById('EnterForm-password-error');
    if (errorElement) switchToRecover();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
    
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-bundle-row, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          if (window.innerWidth >= 768 && typeof gal.jhSelectDesktopMedia === 'function' && gal.jhSelectDesktopMedia(imageId)) return;
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, .product-bundle-row, .product-complementary-row, article, .main-product_wrapper, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
          const qtyInput = parentElement.querySelector('quantity-input');
          if (qtyInput) {
            const sourceQtyInput = html.querySelector('quantity-input');
            if (sourceQtyInput && sourceQtyInput.dataset.variantPrice) {
              qtyInput.dataset.variantPrice = sourceQtyInput.dataset.variantPrice;
            } else {
              const jsonSelector = parentElement.querySelector('variant-pill')?.dataset.jsonSelector;
              const jsonElem = jsonSelector ? document.querySelector(jsonSelector) : null;
              if (jsonElem) {
                const data = JSON.parse(jsonElem.textContent);
                const variant = data.variants.find(v => v.id == id);
                if (variant) {
                  qtyInput.dataset.variantPrice = variant.price;
                }
              }
            }
            const inputField = qtyInput.querySelector('input[type="number"]');
            if (inputField) {
              inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyFields = form.querySelectorAll('input[name="quantity"]');
    if (!qtyFields || qtyFields.length === 0) return;
    qtyFields.forEach(qtyField => {
      const minVal = parseFloat(qtyField.min) || 1;
      qtyField.value = minVal;
      qtyField.dispatchEvent(new Event('input', { bubbles: true }));
    });
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content ? this.content.querySelectorAll('[data-btn-variant]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onVariantSelectBound = this.onVariantSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }

      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      this.doAnimate(this.content);
      this.content.focus();
      trapFocus(this.content);
      if (this.items) {
        this.items.forEach(item => {
          item.addEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.button, false);
      if (this.items) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }

    doAnimate(element) {
      try {
        const animationFrames = JSON.parse(this.content.dataset.frames);
        const timing = JSON.parse(this.content.dataset.options);
        if (animationFrames && timing) {
          element.animate(animationFrames, timing);
        }
      } catch (e) {
        console.warn("Animation failed", e);
      }
    }

    onVariantSelect(event) {
      const target = event.currentTarget;
      this.items.forEach(item => item.classList.remove('product-card_select-option--active'));
      target.classList.add('product-card_select-option--active');
      
      const displayElem = this.button.querySelector('[data-current-value]');
      if (displayElem) displayElem.textContent = target.dataset.text;

      const currentDot = this.button.querySelector('[data-current-dot]');
      if (currentDot) {
        const swatchValue = target.style.getPropertyValue('--variant-swatch');
        if (swatchValue) {
          currentDot.style.setProperty('--variant-swatch', swatchValue);
          const focalPoint = target.style.getPropertyValue('--swatch-focal-point');
          if (focalPoint) {
            currentDot.style.setProperty('--swatch-focal-point', focalPoint);
          } else {
            currentDot.style.removeProperty('--swatch-focal-point');
          }
          currentDot.classList.remove('hidden');
        } else {
          currentDot.classList.add('hidden');
        }
      }

      this.setVariantOptions(target.dataset.value);
      this.closeDropdown();
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      onVariantChange(
        this.dataset.jsonSelector,
        currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const button = event.target.closest('button');
        if (!button) return;
        const previousValue = this.input.value;
        button.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const minVal = parseInt(this.input.min);
        const maxVal = parseInt(this.input.max);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        if (!btn) return;
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= minVal);
            btn.toggleAttribute('disabled', value <= minVal);
            break;
          case 'max':
            if (!isNaN(maxVal)) {
              btn.classList.toggle('disabled', value >= maxVal);
              btn.toggleAttribute('disabled', value >= maxVal);
            }
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        if (isNaN(total)) return;
        const formattedTotal = Shopify.formatMoney(total, window.money_format);
        const totalLabel = elem.querySelector('.product-complementary-row_total-label');
        if (totalLabel) {
          elem.innerHTML = totalLabel.outerHTML + formattedTotal;
        } else {
          elem.innerHTML = formattedTotal;
        }
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const parentRow = this.closest('.product-complementary-row, article');
        const errElem = parentRow?.querySelector('[data-product-complementary-card-render-error], [data-render-main-error]');
        if (errElem) {
          errElem.classList.add('hidden');
          const errSpan = errElem.querySelector('[data-error]');
          if (errSpan) errSpan.innerText = '';
        }
        const qtySubtotal = parentRow?.querySelector('[data-qty-subtotal]') 
          || this.querySelector('[data-qty-subtotal]') 
          || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  class QuantityInputCustom extends QuantityInput {
    constructor() {
      super();
      const initialVal = parseInt(this.input?.value) || 1;
      this.updateSubtotal(initialVal);
    }

    updateSubtotal(qty) {
      const subtotalElem = this.closest('.product-complementary-row, article')?.querySelector('[data-qty-subtotal]');
      if (!subtotalElem) return;
      const price = parseInt(this.dataset.variantPrice);
      if (isNaN(price)) return;
      const total = qty * price;
      const formattedTotal = Shopify.formatMoney(total, window.money_format);
      const totalLabel = subtotalElem.querySelector('.product-complementary-row_total-label');
      if (totalLabel) {
        subtotalElem.innerHTML = totalLabel.outerHTML + formattedTotal;
      } else {
        subtotalElem.innerHTML = formattedTotal;
      }
    }

    resetQuantity() {
      if (!this.input) return;
      const minVal = parseInt(this.input.min) || 1;
      this.input.value = minVal;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input-custom')) {
    customElements.define('quantity-input-custom', QuantityInputCustom);
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.empty = true;
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.empty = false;
                  this.innerHTML = recommendations.innerHTML;
                  if (!recommendations.innerHTML.includes('data-recommend-check')) {
                    let recommendationAncestor = this.parentElement;
                    while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                      recommendationAncestor = recommendationAncestor.parentElement;
                    }
                    if (recommendationAncestor) recommendationAncestor.classList.add('hidden');
                  }
                  if (window.ScrollTrigger) {
                    window.ScrollTrigger.refresh();
                    setTimeout(() => window.ScrollTrigger.refresh(), 200);
                  }
                  const imgs = this.querySelectorAll('img');
                  imgs.forEach((img) => {
                    if (!img.complete) {
                      img.addEventListener('load', () => window.ScrollTrigger && window.ScrollTrigger.refresh(), { once: true });
                    }
                  });
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.empty) {
                  const recWrap = this.closest('.product-recommendations-wrapper') || this.closest('.recommendation');
                  if (recWrap && recWrap !== this && !recWrap.classList.contains('section-wrapper')) {
                    recWrap.classList.add('hidden');
                  } else {
                    this.classList.add('hidden');
                  }
                }
              });
          };
          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
        }
      }
    );
  }
  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      const loadMedia = () => {
        if (this.dataset.onHover !== 'true' && typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(document.body, this);
        }
        if (this.getAttribute('loaded') === 'true') return;
        this.setAttribute('loaded', 'true');
        if (this.template) {
          const content = this.template.content.cloneNode(true);
          this.appendChild(content);
        }
        const mediaElement = this.querySelector('video, iframe');
        if (mediaElement) {
          if (mediaElement.tagName === 'VIDEO') {
            mediaElement.playsInline = true;
            mediaElement.setAttribute('playsinline', '');
            mediaElement.setAttribute('webkit-playsinline', '');
            if (!mediaElement.getAttribute('src')) {
              const source = mediaElement.querySelector('source');
              if (source && (source.src || source.getAttribute('src'))) {
                mediaElement.src = source.src || source.getAttribute('src');
              }
            }
            mediaElement.load();
            const playPromise = mediaElement.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                mediaElement.muted = true;
                mediaElement.setAttribute('muted', '');
                mediaElement.play().catch(() => {});
              });
            }
          } else if (mediaElement.tagName === 'IFRAME') {
            const src = mediaElement.getAttribute('src');
            if (src && !src.includes('autoplay')) {
              mediaElement.setAttribute('src', src.includes('?') ? `${src}&autoplay=1` : `${src}?autoplay=1`);
            }
          }
        }
      };
      this.loadMediaHandler = loadMedia;
      if (this.button) this.button.addEventListener('click', this.loadMediaHandler);
    }
    disconnectedCallback() {
      if (this.button && this.loadMediaHandler) this.button.removeEventListener('click', this.loadMediaHandler);
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  class ProductModel extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-deferred-media-toggler]');
      this.template = this.querySelector('template');
      if (this.button) this.button.addEventListener('click', this.loadModel.bind(this));
    }
    loadModel() {
      if (this.getAttribute('loaded') === 'true') return;
      this.setAttribute('loaded', 'true');
      const content = this.template.content.cloneNode(true);
      this.appendChild(content);
      if (typeof window.Shopify !== 'undefined' && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }
      if (window.ProductModel?.loadShopifyXR) {
        window.ProductModel.loadShopifyXR();
      }
    }
    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  }
  if (!customElements.get('product-model')) customElements.define('product-model', ProductModel);
  class RecipientForm extends HTMLElement {
    connectedCallback() {
      this.checkboxInput = this.querySelector(`[id*="Recipient-Checkbox"]`);
      this.checkboxInput.disabled = false;
      this.hiddenControlField = this.querySelector(`[id*="Recipient-Control"]`);
      this.hiddenControlField.disabled = true;
      this.emailInput = this.querySelector(`[id*="Recipient-email"]`);
      this.nameInput = this.querySelector(`[id*="Recipient-name"]`);
      this.messageInput = this.querySelector(`[id*="Recipient-message"]`);
      this.sendonInput = this.querySelector(`[id*="Recipient-send-on"]`);
      this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
      this.errorMessageList = this.errorMessageWrapper.querySelector('ul');
      this.errorMessage = this.errorMessageWrapper.querySelector('.error-message');
      this.defaultErrorHeader = this.errorMessage?.innerText;
      this.currentProductVariantId = this.dataset.productVariantId;
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields(flag = false) {
      if (this.emailInput) this.emailInput.value = '';
      if (this.nameInput) this.nameInput.value = '';
      if (this.messageInput) this.messageInput.value = '';
      if (this.sendonInput) this.sendonInput.value = '';
      if (flag) this.checkboxInput.checked = false;
    }

    displayErrorMessage(title, body) {
      this.clearErrorMessage();
      this.errorMessageWrapper.hidden = false;
      if (typeof body === 'object') {
        this.errorMessage.innerText = this.defaultErrorHeader;
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}-${this.dataset.productId}`;
          const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}-${this.dataset.productId}`;
          const label = key.includes('send_on') ? '' : key;
          const message = `${label} ${value}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message');
          if (!errorTextElement) return;
          if (this.errorMessageList)
            this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove('hidden');
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
          inputElement.setAttribute('aria-invalid', true);
          inputElement.setAttribute('aria-describedby', errorMessageId);
        });
      }
      this.errorMessage.innerText = body;
    }

    createErrorListItem(target, message) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.setAttribute('href', target);
      a.innerText = message;
      a.classList.add('errors-list_link');
      li.appendChild(a);
      li.className = 'error-message errors-list_item';
      return li;
    }

    clearErrorMessage() {
      this.errorMessageWrapper.hidden = true;
      if (this.errorMessageList) this.errorMessageList.innerHTML = '';
      this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
        field.classList.add('hidden');
        const textField = field.querySelector('.error-message');
        if (textField) textField.innerText = '';
      });
      [this.emailInput, this.messageInput, this.nameInput].forEach((inputElement) => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
      });
    }

    resetRecipientForm() {
      if (this.checkboxInput.checked) {
        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  if (!customElements.get('recipient-form')) customElements.define('recipient-form', RecipientForm);
  window.Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  class ModalSizeToggler extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        const modal = this.closest('modal-size-component') || document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (!modal) return;
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-size-toggler')) customElements.define('modal-size-toggler', ModalSizeToggler);
  class ModalSizeComponent extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
    }
    connectedCallback() {
      const self = this;
      const doAnimate = () => {
        if (!self.animatorWrap) return;
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.animatorWrap.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.animatorWrap);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        self.animatorWrap.animate(animationFrames, timing);
      };
      const setClasses = (flag) => {
        self.classList.toggle('modal--active', flag);
        document.body.classList.toggle(`${self.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        const boundings = self.querySelector('.modal-component_wrapper');
        if (!boundings || boundings.contains(target) || target === boundings) return;
        self.close();
      };
      const onKeyUp = (event) => {
        if (event.key === 'Escape') self.close();
      };
      const setListeners = (flag) => {
        if (self.dataset.hideOutside === 'false') return;
        if (flag) {
          self.addEventListener('keyup', onKeyUp);
          self.addEventListener('click', onBodyClick);
        } else {
          self.removeEventListener('keyup', onKeyUp);
          self.removeEventListener('click', onBodyClick);
        }
      };
      const applyColorScheme = () => {
        const wrapper = this.querySelector('.modal-component_wrapper');
        if (!wrapper || !this.dataset.colorScheme) return;
        const classes = this.dataset.colorScheme.trim().split(/\s+/);
        wrapper.classList.add(...classes);
      }
      const open = (toggler = null) => {
        self.toggler = toggler;
        self.parent = self.parentElement;
        if (self.dataset.trigger !== 'self') document.body.append(self);
        applyColorScheme();
        setClasses(true);
        requestAnimationFrame(() => {
          doAnimate();
        });
        trapFocus(self.content);
        setListeners(true);
      };
      const close = () => {
        if (self.dataset.trigger !== 'self') {
          if (self.parentElement === document.body) document.body.removeChild(self);
          if (self.parent) self.parent.append(self);
        }
        setClasses(false);
        if (self.toggler) {
          self.toggler.setAttribute('data-expanded', 'false');
          trapFocus(null, self.toggler, false);
        }
        self.toggler = null;
        self.parent = null;
        setListeners(false);
      };
      this.open = open;
      this.close = close;
    }
  }
  if (!customElements.get('modal-size-component')) customElements.define('modal-size-component', ModalSizeComponent);
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) return this.hideTimer();
      const els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const last = { days: null, hours: null, minutes: null, seconds: null };
      const frames = this.dataset.frames ? JSON.parse(this.dataset.frames) : null;
      const options = this.dataset.options ? JSON.parse(this.dataset.options) : null;
      const doAnimate = (el) => {
        if (!el || !frames || !options) return;
        el.animate(frames, options);
      };
      const hideTimer = () => {
        this.classList.add('hidden');
        if (this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
        const message = this.nextElementSibling;
        if (message?.hasAttribute('data-message')) message.classList.remove('hidden');
      };
      const update = () => {
        const remaining = endDate.getTime() - Date.now();
        if (remaining <= 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          Object.values(els).forEach(el => el && (el.textContent = '0'));
          hideTimer();
          this.dispatchEvent(new Event('timeup'));
          return;
        }
        const current = {
          days: Math.floor(remaining / 864e5),
          hours: Math.floor((remaining % 864e5) / 36e5),
          minutes: Math.floor((remaining % 36e5) / 6e4),
          seconds: Math.floor((remaining % 6e4) / 1e3)
        };
        for (const unit in current) {
          if (els[unit] && last[unit] !== current[unit]) {
            els[unit].textContent = current[unit];
            if (last[unit] !== null) doAnimate(els[unit]);
            last[unit] = current[unit];
          }
        }
      };
      update();
      this.intervalId = setInterval(update, 1000);
    }
    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-products-grid"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
    
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, article, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      if (this.toggler) this.toggler.classList.add('btn-loading');
      this.parent = this.parentElement;
      if (this.dataset.container === 'body') {
        document.body.append(this);
      }
      this.renderModal();
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal() {
      if (this.toggler) this.toggler.classList.add('btn-loading');
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          if (this.toggler) this.toggler.classList.remove('btn-loading');
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
        });
    }
    initFilters() {
      if (window.innerWidth >= 768) {
        this.querySelectorAll('details').forEach((d) => d.setAttribute('open', ''));
      }
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;

      const priceFacet = target.closest('.price-facet');
      if (priceFacet && priceFacet.getAttribute('data-invalid') === 'true') {
        return;
      }

      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
        case 'range':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      if (this.toggler) this.toggler.classList.remove('btn-loading');
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if (this.dataset.trigger !== 'self') {
        if (this.parentElement === document.body) {
          document.body.removeChild(this);
          if (this.parent) this.parent.append(this);
        }
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      if (this.dataset.container === 'body') {
        document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      }
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          document.addEventListener('keyup', this.onKeyUp);
          document.addEventListener('click', this.onBodyClick);
          break;
        default:
          document.removeEventListener('keyup', this.onKeyUp);
          document.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (
        this.contains(target) ||
        (boundings && (boundings.contains(target) || target === boundings)) ||
        (this.toggler && this.toggler.contains(target))
      )
        return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-filter-component'))
    customElements.define('modal-filter-component', ModalFilterComponent);
  /**
   * Section HTML often contains a single [data-render-facets] (sidebar), while the live DOM
   * also has a copy inside the filter modal — querySelector would only update one branch.
   */
  function replaceSectionSelectorFromHtml(htmlRoot, selector) {
    if (!htmlRoot) return;
    const sources = htmlRoot.querySelectorAll(selector);
    if (!sources.length) return;
    const targets = document.querySelectorAll(selector);
    if (!targets.length) return;
    if (selector === '[data-render-facets]' && sources.length === 1 && targets.length > 1) {
      const markup = sources[0].outerHTML;
      targets.forEach((el) => {
        el.outerHTML = markup;
      });
      return;
    }
    const len = Math.min(sources.length, targets.length);
    for (let i = 0; i < len; i++) {
      targets[i].outerHTML = sources[i].outerHTML;
    }
  }
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      const openFacetKeys = this.getOpenFacetKeys();
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target, openFacetKeys);
        return;
      }
      this.renderFetch(url, true, searchParams, target, openFacetKeys);
    }

    getOpenFacetKeys() {
      const openFacetKeys = [];
      const details = document.querySelectorAll(
        'modal-filter-component.modal--active [data-render-facets] details[open][data-facet-key]'
      );
      details.forEach((item) => {
        if (item.dataset.facetKey) openFacetKeys.push(item.dataset.facetKey);
      });
      return openFacetKeys;
    }

    restoreOpenFacetKeys(openFacetKeys = []) {
      if (window.innerWidth >= 768) {
        document.querySelectorAll('modal-filter-component.modal--active [data-render-facets] details').forEach((d) => d.setAttribute('open', ''));
        return;
      }
      if (!openFacetKeys.length) return;
      openFacetKeys.forEach((key) => {
        const facet = document.querySelector(
          `modal-filter-component.modal--active [data-render-facets] details[data-facet-key="${CSS.escape(key)}"]`
        );
        if (facet) facet.setAttribute('open', '');
      });
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null, openFacetKeys = []) {
      const gridContainer = document.querySelector('[data-render-columns]')?.parentElement || document.querySelector('[data-products-grid]') || document.querySelector('#product-grid');
      if (gridContainer) gridContainer.classList.add('grid--loading');
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              replaceSectionSelectorFromHtml(html, selector);
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if (gridContainer) gridContainer.classList.remove('grid--loading');
          if (updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if (modal) modal.initFilters();
          this.restoreOpenFacetKeys(openFacetKeys);
          if (target) {
            const org = document.getElementById(target);
            if (org) org.focus();
          }
        });
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null, openFacetKeys = []) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          replaceSectionSelectorFromHtml(html, selector);
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if (modal) modal.initFilters();
      this.restoreOpenFacetKeys(openFacetKeys);
      if (target) {
        const org = document.getElementById(target);
        if (org) org.focus();
      }
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content?.querySelectorAll('[data-btn-sort]');

      if (!this.button || !this.content) return;

      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;

      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };

      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };

      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.closeDropdown();
      };

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      };

      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };

      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };

      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.addEventListener('click', onSortSelect);
          });
        }
      };

      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.removeEventListener('click', onSortSelect);
          });
        }
      };

      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content ? this.content.querySelectorAll('[data-btn-variant]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onVariantSelectBound = this.onVariantSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }

      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      this.doAnimate(this.content);
      this.content.focus();
      trapFocus(this.content);
      if (this.items) {
        this.items.forEach(item => {
          item.addEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.button, false);
      if (this.items) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }

    doAnimate(element) {
      try {
        const animationFrames = JSON.parse(this.content.dataset.frames);
        const timing = JSON.parse(this.content.dataset.options);
        if (animationFrames && timing) {
          element.animate(animationFrames, timing);
        }
      } catch (e) {
        console.warn("Animation failed", e);
      }
    }

    onVariantSelect(event) {
      const target = event.currentTarget;
      this.items.forEach(item => item.classList.remove('product-card_select-option--active'));
      target.classList.add('product-card_select-option--active');
      
      const displayElem = this.button.querySelector('[data-current-value]');
      if (displayElem) displayElem.textContent = target.dataset.text;

      const currentDot = this.button.querySelector('[data-current-dot]');
      if (currentDot) {
        const swatchValue = target.style.getPropertyValue('--variant-swatch');
        if (swatchValue) {
          currentDot.style.setProperty('--variant-swatch', swatchValue);
          const focalPoint = target.style.getPropertyValue('--swatch-focal-point');
          if (focalPoint) {
            currentDot.style.setProperty('--swatch-focal-point', focalPoint);
          } else {
            currentDot.style.removeProperty('--swatch-focal-point');
          }
          currentDot.classList.remove('hidden');
        } else {
          currentDot.classList.add('hidden');
        }
      }

      this.setVariantOptions(target.dataset.value);
      this.closeDropdown();
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      onVariantChange(
        this.dataset.jsonSelector,
        currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }

  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled', 'btn-loading');
            if (this.loader) this.loader.classList.remove('hidden');
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled', 'btn-loading');
                  if (this.loader) this.loader.classList.add('hidden');
                }
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all');
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      };
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);
  class PriceRange extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.inputs = this.querySelectorAll('input[type="range"]');
      if(!this.inputs) return;

      this.parent = this.closest('.price-facet');
      this.numInputs = this.parent ? this.parent.querySelectorAll('input[type="number"]') : [];

      const onSlideWatch = (source = 'range') => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const errorElement = this.parent.querySelector('.price-range_error');
        
        if (source === 'range') {
          if (minInput && minVal > maxVal) {
            minInput.value = maxVal;
          }
          if (maxInput && maxVal < minVal) {
            maxInput.value = minVal;
          }
        }

        const currentMin = parseFloat(minInput.value);
        const currentMax = parseFloat(maxInput.value);

        if (currentMin > currentMax) {
          if (errorElement) errorElement.classList.remove('hidden');
          this.parent.setAttribute('data-invalid', 'true');
        } else {
          if (errorElement) errorElement.classList.add('hidden');
          this.parent.removeAttribute('data-invalid');
        }

        // Sync with number inputs
        if (this.numInputs.length > 0) {
          const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
          const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
          if (minNum) minNum.value = minInput.value;
          if (maxNum) maxNum.value = maxInput.value;
        }
      }

      const onNumWatch = (event) => {
        const target = event.target;
        const rangeInput = Array.from(this.inputs).find(i => i.name === target.name);
        if (rangeInput && target.value !== '' && !isNaN(parseFloat(target.value))) {
          rangeInput.value = target.value;
          onSlideWatch('number');
        }
      }

      const onNumChange = (event) => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        if (minVal > maxVal) {
          // Swap values
          const temp = minInput.value;
          minInput.value = maxInput.value;
          maxInput.value = temp;
          
          // Update number inputs
          if (this.numInputs.length > 0) {
            const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
            const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
            if (minNum) minNum.value = minInput.value;
            if (maxNum) maxNum.value = maxInput.value;
          }
          
          onSlideWatch('range'); // Trigger sync and clear error
          
          // Trigger form submission after swap
          const facetsFilter = document.querySelector('facets-filter');
          if (facetsFilter) facetsFilter.onSubmitHandler();
        }
      }

      this.watch = onSlideWatch.bind(this);
      this.numWatch = onNumWatch.bind(this);
      this.numChange = onNumChange.bind(this);

      this.inputs.forEach(input => {
        input.addEventListener('input', this.watch);
      });

      if (this.numInputs.length > 0) {
        this.numInputs.forEach(input => {
          input.addEventListener('input', this.numWatch);
          input.addEventListener('change', this.numChange);
        });
      }
    }
  }
  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
    
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, article, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      if (this.toggler) this.toggler.classList.add('btn-loading');
      this.parent = this.parentElement;
      if (this.dataset.container === 'body') {
        document.body.append(this);
      }
      this.renderModal();
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal() {
      if (this.toggler) this.toggler.classList.add('btn-loading');
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          if (this.toggler) this.toggler.classList.remove('btn-loading');
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
        });
    }
    initFilters() {
      if (window.innerWidth >= 768) {
        this.querySelectorAll('details').forEach((d) => d.setAttribute('open', ''));
      }
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;

      const priceFacet = target.closest('.price-facet');
      if (priceFacet && priceFacet.getAttribute('data-invalid') === 'true') {
        return;
      }

      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
        case 'range':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      if (this.toggler) this.toggler.classList.remove('btn-loading');
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if (this.dataset.trigger !== 'self') {
        if (this.parentElement === document.body) {
          document.body.removeChild(this);
          if (this.parent) this.parent.append(this);
        }
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      if (this.dataset.container === 'body') {
        document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
        document.body.classList.toggle('overflow-hidden', flag);
      }
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          document.addEventListener('keyup', this.onKeyUp);
          document.addEventListener('click', this.onBodyClick);
          break;
        default:
          document.removeEventListener('keyup', this.onKeyUp);
          document.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (
        this.contains(target) ||
        (boundings && (boundings.contains(target) || target === boundings)) ||
        (this.toggler && this.toggler.contains(target))
      )
        return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-filter-component'))
    customElements.define('modal-filter-component', ModalFilterComponent);
  /**
   * Section HTML often contains a single [data-render-facets] (sidebar), while the live DOM
   * also has a copy inside the filter modal — querySelector would only update one branch.
   */
  function replaceSectionSelectorFromHtml(htmlRoot, selector) {
    if (!htmlRoot) return;
    const sources = htmlRoot.querySelectorAll(selector);
    if (!sources.length) return;
    const targets = document.querySelectorAll(selector);
    if (!targets.length) return;
    if (selector === '[data-render-facets]' && sources.length === 1 && targets.length > 1) {
      const markup = sources[0].outerHTML;
      targets.forEach((el) => {
        el.outerHTML = markup;
      });
      return;
    }
    const len = Math.min(sources.length, targets.length);
    for (let i = 0; i < len; i++) {
      targets[i].outerHTML = sources[i].outerHTML;
    }
  }
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      const openFacetKeys = this.getOpenFacetKeys();
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target, openFacetKeys);
        return;
      }
      this.renderFetch(url, true, searchParams, target, openFacetKeys);
    }

    getOpenFacetKeys() {
      const openFacetKeys = [];
      const details = document.querySelectorAll(
        'modal-filter-component.modal--active [data-render-facets] details[open][data-facet-key]'
      );
      details.forEach((item) => {
        if (item.dataset.facetKey) openFacetKeys.push(item.dataset.facetKey);
      });
      return openFacetKeys;
    }

    restoreOpenFacetKeys(openFacetKeys = []) {
      if (window.innerWidth >= 768) {
        document.querySelectorAll('modal-filter-component.modal--active [data-render-facets] details').forEach((d) => d.setAttribute('open', ''));
        return;
      }
      if (!openFacetKeys.length) return;
      openFacetKeys.forEach((key) => {
        const facet = document.querySelector(
          `modal-filter-component.modal--active [data-render-facets] details[data-facet-key="${CSS.escape(key)}"]`
        );
        if (facet) facet.setAttribute('open', '');
      });
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null, openFacetKeys = []) {
      const gridContainer = document.querySelector('[data-render-columns]')?.parentElement || document.querySelector('[data-products-grid]') || document.querySelector('#product-grid');
      if (gridContainer) gridContainer.classList.add('grid--loading');
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              replaceSectionSelectorFromHtml(html, selector);
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if (gridContainer) gridContainer.classList.remove('grid--loading');
          if (updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if (modal) modal.initFilters();
          this.restoreOpenFacetKeys(openFacetKeys);
          if (target) {
            const org = document.getElementById(target);
            if (org) org.focus();
          }
        });
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null, openFacetKeys = []) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          replaceSectionSelectorFromHtml(html, selector);
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if (modal) modal.initFilters();
      this.restoreOpenFacetKeys(openFacetKeys);
      if (target) {
        const org = document.getElementById(target);
        if (org) org.focus();
      }
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content?.querySelectorAll('[data-btn-sort]');

      if (!this.button || !this.content) return;

      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;

      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };

      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };

      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.closeDropdown();
      };

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      };

      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };

      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };

      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.addEventListener('click', onSortSelect);
          });
        }
      };

      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);

        if (this.items) {
          this.items.forEach((item) => {
            item.removeEventListener('click', onSortSelect);
          });
        }
      };

      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content ? this.content.querySelectorAll('[data-btn-variant]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onVariantSelectBound = this.onVariantSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }

      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      this.doAnimate(this.content);
      this.content.focus();
      trapFocus(this.content);
      if (this.items) {
        this.items.forEach(item => {
          item.addEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.button, false);
      if (this.items) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }

    doAnimate(element) {
      try {
        const animationFrames = JSON.parse(this.content.dataset.frames);
        const timing = JSON.parse(this.content.dataset.options);
        if (animationFrames && timing) {
          element.animate(animationFrames, timing);
        }
      } catch (e) {
        console.warn("Animation failed", e);
      }
    }

    onVariantSelect(event) {
      const target = event.currentTarget;
      this.items.forEach(item => item.classList.remove('product-card_select-option--active'));
      target.classList.add('product-card_select-option--active');
      
      const displayElem = this.button.querySelector('[data-current-value]');
      if (displayElem) displayElem.textContent = target.dataset.text;

      const currentDot = this.button.querySelector('[data-current-dot]');
      if (currentDot) {
        const swatchValue = target.style.getPropertyValue('--variant-swatch');
        if (swatchValue) {
          currentDot.style.setProperty('--variant-swatch', swatchValue);
          const focalPoint = target.style.getPropertyValue('--swatch-focal-point');
          if (focalPoint) {
            currentDot.style.setProperty('--swatch-focal-point', focalPoint);
          } else {
            currentDot.style.removeProperty('--swatch-focal-point');
          }
          currentDot.classList.remove('hidden');
        } else {
          currentDot.classList.add('hidden');
        }
      }

      this.setVariantOptions(target.dataset.value);
      this.closeDropdown();
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      onVariantChange(
        this.dataset.jsonSelector,
        currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }

  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled', 'btn-loading');
            if (this.loader) this.loader.classList.remove('hidden');
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled', 'btn-loading');
                  if (this.loader) this.loader.classList.add('hidden');
                }
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all');
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      };
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);
  class PriceRange extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.inputs = this.querySelectorAll('input[type="range"]');
      if(!this.inputs) return;

      this.parent = this.closest('.price-facet');
      this.numInputs = this.parent ? this.parent.querySelectorAll('input[type="number"]') : [];

      const onSlideWatch = (source = 'range') => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const errorElement = this.parent.querySelector('.price-range_error');
        
        if (source === 'range') {
          if (minInput && minVal > maxVal) {
            minInput.value = maxVal;
          }
          if (maxInput && maxVal < minVal) {
            maxInput.value = minVal;
          }
        }

        const currentMin = parseFloat(minInput.value);
        const currentMax = parseFloat(maxInput.value);

        if (currentMin > currentMax) {
          if (errorElement) errorElement.classList.remove('hidden');
          this.parent.setAttribute('data-invalid', 'true');
        } else {
          if (errorElement) errorElement.classList.add('hidden');
          this.parent.removeAttribute('data-invalid');
        }

        // Sync with number inputs
        if (this.numInputs.length > 0) {
          const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
          const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
          if (minNum) minNum.value = minInput.value;
          if (maxNum) maxNum.value = maxInput.value;
        }
      }

      const onNumWatch = (event) => {
        const target = event.target;
        const rangeInput = Array.from(this.inputs).find(i => i.name === target.name);
        if (rangeInput && target.value !== '' && !isNaN(parseFloat(target.value))) {
          rangeInput.value = target.value;
          onSlideWatch('number');
        }
      }

      const onNumChange = (event) => {
        const minInput = this.querySelector('.min');
        const maxInput = this.querySelector('.max');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);

        if (minVal > maxVal) {
          // Swap values
          const temp = minInput.value;
          minInput.value = maxInput.value;
          maxInput.value = temp;
          
          // Update number inputs
          if (this.numInputs.length > 0) {
            const minNum = Array.from(this.numInputs).find(i => i.name === minInput.name);
            const maxNum = Array.from(this.numInputs).find(i => i.name === maxInput.name);
            if (minNum) minNum.value = minInput.value;
            if (maxNum) maxNum.value = maxInput.value;
          }
          
          onSlideWatch('range'); // Trigger sync and clear error
          
          // Trigger form submission after swap
          const facetsFilter = document.querySelector('facets-filter');
          if (facetsFilter) facetsFilter.onSubmitHandler();
        }
      }

      this.watch = onSlideWatch.bind(this);
      this.numWatch = onNumWatch.bind(this);
      this.numChange = onNumChange.bind(this);

      this.inputs.forEach(input => {
        input.addEventListener('input', this.watch);
      });

      if (this.numInputs.length > 0) {
        this.numInputs.forEach(input => {
          input.addEventListener('input', this.numWatch);
          input.addEventListener('change', this.numChange);
        });
      }
    }
  }
  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-service"] && !Shopify.designMode) return;
  try {
    
  class ServiceSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-select-toggler]');
      this.content = this.querySelector('[data-select-content]');
      this.input = this.querySelector('input[type="hidden"]');
      this.valueLabel = this.querySelector('[data-current-value]');
      this.items = this.content ? this.content.querySelectorAll('[data-select-option]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onOptionSelectBound = this.onOptionSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }
      if (this.items) {
        this.items.forEach((item) => {
          item.addEventListener('click', this.onOptionSelectBound);
        });
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      document.querySelectorAll('service-select [data-select-content].dropdown--open').forEach((el) => {
        if (el !== this.content) {
          el.classList.remove('dropdown--open');
          const parentBtn = el.closest('service-select')?.querySelector('[data-select-toggler]');
          if (parentBtn) parentBtn.setAttribute('aria-expanded', 'false');
        }
      });

      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      const target = event.target;
      if (this.contains(target) || target === this || target === this.button) return;
      this.closeDropdown();
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.closeDropdown();
      }
    }

    onOptionSelect(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const value = target.dataset.value;
      const text = target.dataset.text || target.textContent.trim();

      this.items.forEach((item) => item.classList.remove('active'));
      target.classList.add('active');

      if (this.valueLabel) {
        this.valueLabel.textContent = text;
        this.valueLabel.classList.remove('is-placeholder');
      }
      if (this.input) {
        this.input.value = value;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.closeDropdown();
    }
  }
  if (!customElements.get('service-select')) customElements.define('service-select', ServiceSelect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
     from each trigger's live document position instead of a fixed number —
     merchants can reorder sections in the theme customizer, so a hardcoded
     priority goes stale the moment the order changes. See hero-banner/
     collection-list/bundle-products for the same pattern. */
  function multicolumnScrollPriority(el) {
    return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
  }

  function initMulticolumnHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.multicolumn_heading-head');
    if (!headingHead) return;

    var idPrefix = 'mc-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.multicolumn_tagline-text');
    var heading = headingHead.querySelector('.multicolumn_heading');
    var description = headingHead.querySelector('.multicolumn_description');

    /* The split is left in place rather than reverted on complete since it
       needs to remain animatable for repeat entries — toggleActions below
       replays this reveal every time the heading scrolls back into view,
       and initMulticolumnCards uses the same treatment so the heading and
       card grid stay in sync instead of drifting apart on scroll-back. */
    var headingSplit = window.themeSplitHeading(heading);
    var descriptionSplit = window.themeSplitHeading(description);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descriptionSplit.targets || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix + '-head',
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: multicolumnScrollPriority(headingHead)
      }
    }));
  }

  function initMulticolumnCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    var _M = window.themeMotion || {};
    if (_M.flags && _M.flags.staggerCards === false) return;

    var cards = section.querySelectorAll('.column-card, [class*="multicolumn_card"], [class*="column_card"]');
    if (!cards.length) return;

    var idPrefix = 'mc-cards-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var cardsTrigger = cards[0].closest('[class*="_wrapper"], [class*="_grid"]') || cards[0].parentElement;

    gsap.set(cards, { opacity: 0, y: 60, scale: 0.97 });
    gsap.to(cards, {
      opacity: 1, y: 0, scale: 1,
      duration: (_M.dur && _M.dur.slow) || 1.0,
      ease: (_M.ease && _M.ease.enter) || 'power4.out',
      stagger: (_M.stagger && _M.stagger.base) || 0.1,
      clearProps: 'scale',
      scrollTrigger: {
        id: idPrefix,
        trigger: cardsTrigger,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: multicolumnScrollPriority(cardsTrigger)
      }
    });

    /* Image hover zoom (desktop pointer: fine only) */
    if ((_M.flags ? _M.flags.imageHover !== false : true) && window.matchMedia('(pointer: fine)').matches) {
      Array.from(cards).forEach(function (card) {
        var img = card.querySelector('img');
        if (!img) return;
        card.addEventListener('mouseenter', function () {
          gsap.to(img, { scale: 1.07, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
        card.addEventListener('mouseleave', function () {
          gsap.to(img, { scale: 1, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
      });
    }
  }

  function initAllMulticolumn() {
    document.querySelectorAll('.multicolumn').forEach(function (section) {
      initMulticolumnHeading(section);
      initMulticolumnCards(section);
    });
  }
  /* keep old name as alias for backwards compat */
  var initAllMulticolumnHeadings = initAllMulticolumn;

  window.onThemeGsapReady(initAllMulticolumn);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('multicolumn')
      ? root
      : (root && root.querySelector ? root.querySelector('.multicolumn') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initMulticolumnHeading(section); initMulticolumnCards(section); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feed"] && !Shopify.designMode) return;
  try {
    
  class FeedReel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const feedElements = Array.from(this.querySelectorAll('[data-feed-element]'));
      if (feedElements.length === 0) return;

      /* Shopify injects this section's compiled script via content_for_header,
         which sits earlier in <head> than the GSAP CDN <script defer> tags in
         theme.liquid — so on first page load window.gsap may not exist yet
         when this runs. A reconnect from the theme editor happens long after
         that (readyState is "complete"), so it can init immediately. */
      const boot = () => {
        this._pendingBoot = null;
        if (!this.isConnected) return;
        this.initFeedReel(feedElements);
      };
      if (window.gsap || document.readyState === 'complete') {
        boot();
      } else {
        this._pendingBoot = boot;
        window.onThemeGsapReady(boot);
      }
    }
    initFeedReel(feedElements) {
      this._pendingBoot = null;
      const rowWraps = Array.from(this.querySelectorAll('.product-feed_row-wrap'));

      const gsap = window.gsap;
      const ST = window.ScrollTrigger;
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const useGsap = !!gsap && !reduceMotion;
      if (gsap && ST) gsap.registerPlugin(ST);
      if (useGsap) this.classList.add('feed-reel--motion');

      const intervalDelay = parseInt(this.getAttribute('data-feed-interval') || '5000', 10);
      const entranceId = 'pf-entrance-' + this.id;

      let currentIndex = 0;
      let advanceTween = null;
      let rafId = null;
      let lastTime = 0;
      let accumulatedTime = 0;
      let manuallyPaused = false;

      const getActiveClass = (element) => {
        const baseClass = element.getAttribute('class').trim().split(/\s+/)[0];
        return `${baseClass}--active`;
      };

      /* Hover fill + content shift per row, only built when GSAP is available. */
      const hoverFills = feedElements.map((el) => {
        if (!useGsap) return null;
        const row = el.querySelector('.feed-row');
        if (!row) return null;
        const fill = document.createElement('span');
        fill.className = 'feed-row_hover-fill';
        fill.setAttribute('aria-hidden', 'true');
        row.prepend(fill);
        return fill;
      });

      const animateRowHover = (el, isHovering) => {
        if (!useGsap) return;
        const index = feedElements.indexOf(el);
        const fill = hoverFills[index];
        const content = el.querySelector('.feed-row_col--content');
        if (fill) {
          gsap.killTweensOf(fill);
          gsap.to(fill, {
            scaleX: isHovering ? 1 : 0,
            duration: isHovering ? 0.4 : 0.3,
            ease: isHovering ? 'power2.out' : 'power2.in',
            overwrite: 'auto'
          });
        }
        if (content) {
          gsap.killTweensOf(content);
          gsap.to(content, { x: isHovering ? 10 : 0, duration: 0.35, ease: 'power2.out', overwrite: 'auto' });
        }
      };

      const animateRowVisual = (el, isActive) => {
        if (!useGsap) return;
        if (!window.matchMedia('(min-width: 768px)').matches) return;
        const image = el.querySelector('.feed-row_image-wrapper');
        const actionWrap = el.querySelector('.feed-row_col--action-wrap');
        gsap.killTweensOf([image, actionWrap].filter(Boolean));
        if (image) {
          const isTilted = image.classList.contains('feed-row_image-wrapper--tilted');
          gsap.to(image, {
            rotation: isTilted ? (isActive ? -3 : 9.03) : 0,
            scale: isActive ? 1.14 : 1,
            duration: 0.7,
            ease: isActive ? 'back.out(1.6)' : 'power3.out',
            overwrite: 'auto'
          });
        }
        if (actionWrap) {
          gsap.to(actionWrap, {
            opacity: isActive ? 1 : 0,
            y: isActive ? 0 : 14,
            duration: 0.5,
            ease: 'power2.out',
            overwrite: 'auto'
          });
        }
      };

      const applyActiveState = (index) => {
        currentIndex = index;
        feedElements.forEach((el, i) => {
          const isActive = i === index;
          el.classList.toggle(getActiveClass(el), isActive);
          animateRowVisual(el, isActive);
        });
      };

      const fallbackLoop = (timestamp) => {
        if (!lastTime) lastTime = timestamp;
        const delta = timestamp - lastTime;
        lastTime = timestamp;
        accumulatedTime += delta;
        if (accumulatedTime >= intervalDelay) {
          accumulatedTime = 0;
          advance();
          return;
        }
        rafId = requestAnimationFrame(fallbackLoop);
      };

      const stopFallbackLoop = () => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      };

      const startTimer = () => {
        if (manuallyPaused) return;
        if (useGsap) {
          if (advanceTween) advanceTween.kill();
          advanceTween = gsap.delayedCall(intervalDelay / 1000, advance);
        } else {
          stopFallbackLoop();
          lastTime = 0;
          accumulatedTime = 0;
          rafId = requestAnimationFrame(fallbackLoop);
        }
      };

      const stopTimer = () => {
        if (useGsap) {
          if (advanceTween) advanceTween.pause();
        } else {
          stopFallbackLoop();
        }
      };

      function advance() {
        applyActiveState((currentIndex + 1) % feedElements.length);
        startTimer();
      }

      const handleMouseEnter = (event) => {
        stopTimer();
        const el = event.currentTarget;
        const targetIndex = feedElements.indexOf(el);
        if (targetIndex !== -1 && targetIndex !== currentIndex) {
          applyActiveState(targetIndex);
        }
        animateRowHover(el, true);
      };
      const handleMouseLeave = (event) => {
        startTimer();
        animateRowHover(event.currentTarget, false);
      };
      /* Keyboard equivalents of the hover handlers above, kept from the prior
         implementation so tabbing through the reel gets the same active-state
         and timer behavior as hovering it with a mouse. */
      const handleFocusIn = (event) => {
        handleMouseEnter(event);
      };
      const handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) {
          handleMouseLeave(event);
        }
      };
      const addEventListeners = () => {
        feedElements.forEach((el) => {
          el.addEventListener('mouseenter', handleMouseEnter);
          el.addEventListener('mouseleave', handleMouseLeave);
          el.addEventListener('focusin', handleFocusIn);
          el.addEventListener('focusout', handleFocusOut);
        });
      };
      const removeEventListeners = () => {
        feedElements.forEach((el) => {
          el.removeEventListener('mouseenter', handleMouseEnter);
          el.removeEventListener('mouseleave', handleMouseLeave);
          el.removeEventListener('focusin', handleFocusIn);
          el.removeEventListener('focusout', handleFocusOut);
        });
      };

      /* Rows fade/slide into place together, staggered, the first time the feed
         scrolls into view, driven by ScrollTrigger. onReveal (activating row 0
         and starting the autoplay timer) is passed in so that showcase also
         waits for the section to actually be scrolled to, instead of firing at
         boot regardless of scroll position. */
      const animateEntrance = (onReveal) => {
        if (!useGsap || !rowWraps.length || window.innerWidth < 768) {
          if (onReveal) onReveal();
          return;
        }
        if (ST) {
          ST.getAll().forEach(function (t) {
            var id = t.vars && t.vars.id;
            if (id && id.indexOf(entranceId) === 0) t.kill();
          });
          var _M = window.themeMotion || {};
          var _useClip = (_M.flags ? _M.flags.clipReveals !== false : true);
          var _staggerStep = (_M.stagger && _M.stagger.loose) || 0.16;
          var _batchStart = (_M.trigger && _M.trigger.start) || 'top 82%';

          /* Map each row's scroll trigger element (its parent row-wrap,
             matching the previous per-row trigger position exactly — each
             [data-feed-element] has exactly one .product-feed_row-wrap
             parent, so this is a 1:1, collision-free mapping) back to the
             element GSAP actually animates, so ScrollTrigger.batch() can
             consolidate what used to be one ScrollTrigger per row into a
             handful of grouped triggers instead. */
          var triggerEls = feedElements.map(function (el) { return el.parentElement || el; });
          var elByTrigger = new Map();
          feedElements.forEach(function (el, i) { elByTrigger.set(triggerEls[i], el); });
          var revealed = false;

          /* Sets a row (and its image, under the clip-reveal preset) back to
             its pre-reveal hidden state — used both for the initial setup
             below and by onLeaveBack to re-hide a batch once it scrolls back
             out, so scrolling forward into it again replays the reveal.
             Deliberately unrelated to `revealed`/onReveal below: the
             showcase's active row and autoplay timer only ever start once,
             on the very first reveal, and keep running regardless of later
             scroll-replays — only the visual entrance repeats. */
          function hideFeedRow(el) {
            var img = el.querySelector('img, [class*="product-feed_image"], [class*="feed-row_image"]');
            if (_useClip) {
              gsap.set(el, { clipPath: 'inset(0 100% 0 0)' });
              if (img) gsap.set(img, { scale: 1.1, transformOrigin: 'center center' });
            } else {
              gsap.set(el, { opacity: 0, y: 60 });
            }
          }

          feedElements.forEach(hideFeedRow);

          var entranceBatch = ST.batch(triggerEls, {
            interval: 0.1,
            start: _batchStart,
            /* Without this, this batch's start positions could get computed
               before/after sibling pinned sections (hero-banner, collection-list,
               image-gallery, etc. — see window.themeScrollPriority in theme.liquid)
               finish resolving their own pin-spacer heights on the same refresh
               pass, landing a few pixels off in either direction depending on
               refresh order. */
            refreshPriority: window.themeScrollPriority ? window.themeScrollPriority(this) : 0,
            onEnter: function (batch) {
              batch.forEach(function (triggerEl, bi) {
                var el = elByTrigger.get(triggerEl);
                if (!el) return;
                var img = el.querySelector('img, [class*="product-feed_image"], [class*="feed-row_image"]');
                var delay = bi * _staggerStep;
                if (_useClip) {
                  gsap.to(el, {
                    clipPath: 'inset(0 0% 0 0)',
                    duration: (_M.dur && _M.dur.slow) || 1.0,
                    ease: (_M.ease && _M.ease.reveal) || 'expo.out',
                    delay: delay,
                    clearProps: 'clipPath',
                    overwrite: 'auto'
                  });
                  if (img) {
                    gsap.to(img, {
                      scale: 1,
                      duration: (_M.dur && _M.dur.xslow) || 1.4,
                      ease: 'power2.out',
                      delay: delay,
                      overwrite: 'auto'
                    });
                  }
                } else {
                  gsap.to(el, {
                    opacity: 1,
                    y: 0,
                    duration: (_M.dur && _M.dur.slow) || 1.0,
                    ease: (_M.ease && _M.ease.enter) || 'power4.out',
                    delay: delay,
                    overwrite: 'auto'
                  });
                }
                if (!revealed && el === feedElements[0]) {
                  revealed = true;
                  if (onReveal) onReveal();
                }
              });
            },
            onLeaveBack: function (batch) {
              batch.forEach(function (triggerEl) {
                var el = elByTrigger.get(triggerEl);
                if (el) hideFeedRow(el);
              });
            }
          });
          /* Tag the batch's own triggers with entranceId so the
             kill-before-rebuild (ST.getById(entranceId)) and cleanupGsap
             above actually find and clear them — previously entranceId was
             never assigned to any trigger, so that cleanup silently never
             matched anything. */
          entranceBatch.forEach(function (t, i) { t.vars.id = entranceId + '-' + i; });
          /* Rows render with configurable custom fonts
             (section_card_heading_family/section_card_text_family) — if those
             fonts swap in after this batch's start positions were first
             measured (FOUT/FOIT), the reflow invalidates those positions for
             whichever rows hadn't crossed the trigger yet. Re-measure once
             fonts are actually ready to remove that drift. */
          if (document.fonts) {
            document.fonts.ready.then(function () {
              if (window.ScrollTrigger) window.ScrollTrigger.refresh();
            });
          }
        } else {
          gsap.set(rowWraps, { opacity: 0, y: 60 });
          gsap.to(rowWraps, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', stagger: 0.12 });
          if (onReveal) onReveal();
        }
      };

      /* Real, touch-reachable pause control (WCAG 2.2.2): the autoplay swap
         only otherwise pauses on mouseenter/focusin, which touch input can
         never trigger. */
      const autoplayToggle = this.querySelector('[data-feed-autoplay-toggle]');
      const handleAutoplayToggleClick = () => {
        manuallyPaused = !manuallyPaused;
        if (manuallyPaused) {
          stopTimer();
        } else {
          startTimer();
        }
        autoplayToggle.classList.toggle('is-paused', manuallyPaused);
        autoplayToggle.setAttribute('aria-pressed', String(manuallyPaused));
        autoplayToggle.setAttribute(
          'aria-label',
          manuallyPaused ? autoplayToggle.dataset.labelPlay : autoplayToggle.dataset.labelPause
        );
      };
      if (autoplayToggle) autoplayToggle.addEventListener('click', handleAutoplayToggleClick);

      this.stopTimer = stopTimer;
      this.removeEventListeners = removeEventListeners;
      this.removeAutoplayToggle = () => {
        if (autoplayToggle) autoplayToggle.removeEventListener('click', handleAutoplayToggleClick);
      };
      this.cleanupGsap = () => {
        if (advanceTween) advanceTween.kill();
        if (useGsap) {
          gsap.killTweensOf([
            ...this.querySelectorAll('.feed-row_image-wrapper'),
            ...this.querySelectorAll('.feed-row_col--action-wrap'),
            ...this.querySelectorAll('.feed-row_col--content'),
            ...rowWraps,
            ...hoverFills.filter(Boolean)
          ]);
          if (ST) {
            ST.getAll().forEach(function (t) {
              var id = t.vars && t.vars.id;
              if (id && id.indexOf(entranceId) === 0) t.kill();
            });
          }
        }
      };

      addEventListeners();
      animateEntrance(() => {
        applyActiveState(0);
        startTimer();
      });
    }
    disconnectedCallback() {
      this._pendingBoot = null;
      if (typeof this.stopTimer === 'function') this.stopTimer();
      if (typeof this.removeEventListeners === 'function') this.removeEventListeners();
      if (typeof this.removeAutoplayToggle === 'function') this.removeAutoplayToggle();
      if (typeof this.cleanupGsap === 'function') this.cleanupGsap();
    }
  }
  if (!customElements.get('feed-reel')) customElements.define('feed-reel', FeedReel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"]) return;
  try {
    
  if (!customElements.get('related-recommendations')) {
    customElements.define(
      'related-recommendations',
      class RelatedRecommendations extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.empty = true;
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.related-recommendations');
                const hasProducts = recommendations && recommendations.querySelector('.product-card-new, .product-card, [data-recommend-check], .splide__slide, .recommendations_grid-col');
                const sectionContainer = this.closest('.recommendations') || this.closest('.section-wrapper');
                if (hasProducts) {
                  this.empty = false;
                  this.innerHTML = recommendations.innerHTML;
                  if (sectionContainer) {
                    sectionContainer.classList.remove('hidden');
                  }
                  if (window.ScrollTrigger) {
                    window.ScrollTrigger.refresh();
                    setTimeout(() => window.ScrollTrigger.refresh(), 200);
                  }
                  const imgs = this.querySelectorAll('img');
                  imgs.forEach((img) => {
                    if (!img.complete) {
                      img.addEventListener('load', () => window.ScrollTrigger && window.ScrollTrigger.refresh(), { once: true });
                    }
                  });
                  const innerSplideElem = this.querySelector('.splide');
                  
                  const initArrowsAndSlider = () => {
                    const parentCarouselSlider = this.closest('carousel-slider');
                    if (parentCarouselSlider && typeof parentCarouselSlider.initialize === 'function') {
                      parentCarouselSlider.initialize();
                    }
                    this.querySelectorAll('carousel-slider').forEach((slider) => {
                      if (typeof slider.initialize === 'function') {
                        slider.initialize();
                      }
                    });

                    const carouselEl = parentCarouselSlider || this.querySelector('carousel-slider');
                    const splideInst = (carouselEl && carouselEl.slider) ? carouselEl.slider : (innerSplideElem ? innerSplideElem.splide : null);
                    if (splideInst) {
                      const allPrev = (sectionContainer || document).querySelectorAll('.splide__arrow--prev');
                      const allNext = (sectionContainer || document).querySelectorAll('.splide__arrow--next');
                      const controlsWrappers = (sectionContainer || document).querySelectorAll('.splide-controls, .splide__arrows');

                      const perPage = splideInst.options.perPage || 1;
                      if (controlsWrappers.length) {
                        controlsWrappers.forEach(ctrl => {
                          if (splideInst.length <= 1 || splideInst.length <= perPage) {
                            ctrl.style.display = 'none';
                          } else {
                            ctrl.style.display = '';
                          }
                        });
                      }

                      const updateArrowsState = () => {
                        const isLoop = splideInst.options.type === 'loop';
                        const isFirst = splideInst.index === 0;
                        const isLast = splideInst.index >= splideInst.length - perPage;

                        allPrev.forEach(btn => {
                          if (!isLoop && isFirst) {
                            btn.setAttribute('disabled', 'disabled');
                          } else {
                            btn.removeAttribute('disabled');
                          }
                        });
                        allNext.forEach(btn => {
                          if (!isLoop && isLast) {
                            btn.setAttribute('disabled', 'disabled');
                          } else {
                            btn.removeAttribute('disabled');
                          }
                        });
                      };

                      allPrev.forEach(btn => {
                        btn.onclick = (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          splideInst.go('<');
                        };
                      });
                      allNext.forEach(btn => {
                        btn.onclick = (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          splideInst.go('>');
                        };
                      });

                      if (typeof splideInst.off === 'function') {
                        splideInst.off('moved updated refresh');
                      }
                      if (typeof splideInst.on === 'function') {
                        splideInst.on('moved updated refresh', updateArrowsState);
                      }
                      updateArrowsState();
                    }
                  };

                  initArrowsAndSlider();
                  setTimeout(initArrowsAndSlider, 50);
                  setTimeout(initArrowsAndSlider, 200);
                } else {
                  this.empty = true;
                  if (sectionContainer) {
                    sectionContainer.classList.add('hidden');
                  } else {
                    this.classList.add('hidden');
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.empty) {
                  const sectionContainer = this.closest('.recommendations') || this.closest('.section-wrapper');
                  if (sectionContainer) {
                    sectionContainer.classList.add('hidden');
                  } else {
                    this.classList.add('hidden');
                  }
                }
              });
          };
          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
        }
      }
    );
  }
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (
    jsonSelector,
    optSet,
    formsSelector,
    renders,
    parentSelector,
    gallerySelectors,
    sectionId,
    productUrl,
    updateUrl,
    focusSelector,
    renderMedia,
    templateSelector
  ) => {
    const json = document.querySelector(jsonSelector);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === optSet[index])
    );

    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }

    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if (!currentVariant) return;

    if (currentVariant.featured_image)
      setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach((form) => {
      if (!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if (!atcBtn) return;
      if (variant.available) {
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, article, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach((selector) => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach((element) => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
        if (focusSelector) {
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach((selector) => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach((element) => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if (!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      if (typeof VariantDropdown !== 'undefined' && VariantDropdown.prototype.updateOptionsAvailability) {
        VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
        return;
      }
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = document.querySelector(this.dataset.form);
      if (!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append(
          'sections',
          secArr.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reels"] && !Shopify.designMode) return;
  try {
    
  /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
     from each trigger's live document position instead of a fixed number —
     merchants can reorder sections in the theme customizer, so a hardcoded
     priority goes stale the moment the order changes. See hero-banner/
     collection-list/bundle-products/multicolumn/image-gallery for the same
     pattern. */
  function productReelsScrollPriority(el) {
    return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
  }

  function initProductReelsHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.product-reels_heading-head');
    if (!headingHead) return;

    var idPrefix = 'pr-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.product-reels_tagline-text');
    var heading = headingHead.querySelector('.product-reels_heading');
    var description = headingHead.querySelector('.product-reels_description');

    /* The split is left in place rather than reverted on complete since it
       needs to remain animatable for repeat entries — toggleActions below
       replays this reveal every time the heading scrolls back into view,
       and initProductReelsCards uses the same treatment so the heading and
       reel cards stay in sync instead of drifting apart on scroll-back. */
    var headingSplit = window.themeSplitHeading(heading);
    var descriptionSplit = window.themeSplitHeading(description);
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descriptionSplit.targets || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix + '-head',
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: productReelsScrollPriority(headingHead)
      }
    }));
  }

  /* Reel cards drop in together as the slider scrolls into view, gated on
     flags.staggerCards like multicolumn/image-gallery's card reveals. */
  function initProductReelsCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);
    var _M = window.themeMotion || {};
    if (_M.flags && _M.flags.staggerCards === false) return;

    var slider = section.querySelector('.product-reels_reel-slider');
    if (!slider) return;
    var cards = slider.querySelectorAll('.product-reels_slide');
    if (!cards.length) return;

    var idPrefix = 'pr-cards-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    gsap.set(cards, { opacity: 0, y: 60, scale: 0.97 });
    gsap.to(cards, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: (_M.dur && _M.dur.slow) || 1.0,
      ease: (_M.ease && _M.ease.enter) || 'power4.out',
      stagger: (_M.stagger && _M.stagger.base) || 0.1,
      clearProps: 'scale',
      scrollTrigger: {
        id: idPrefix,
        trigger: slider,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: productReelsScrollPriority(slider)
      }
    });
  }

  function initAllProductReels() {
    document.querySelectorAll('.product-reels').forEach(function (section) {
      initProductReelsHeading(section);
      initProductReelsCards(section);
    });
  }

  window.onThemeGsapReady(initAllProductReels);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('product-reels')
      ? root
      : (root && root.querySelector ? root.querySelector('.product-reels') : null);
    if (!section) return;
    window.onThemeGsapReady(function () {
      initProductReelsHeading(section);
      initProductReelsCards(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rows"] && !Shopify.designMode) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => {
      if (selector && selector !== '#' && selector !== '.') {
        const el = document.querySelector(selector);
        if (el) arr.push(el);
      }
    });
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    const currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    
    let parentElement = document.querySelector(parentSelector);
    if (!parentElement && parentSelector) {
      const idClean = parentSelector.startsWith('#') ? parentSelector.slice(1) : parentSelector;
      parentElement = document.getElementById(idClean);
    }
    if (parentElement && currentVariant) {
      parentElement.dataset.variantId = currentVariant.id;
      parentElement.dataset.variantPrice = currentVariant.price;
      const selectedVariantLabel = parentElement.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel) {
        const variantName = currentVariant.title || (currentVariant.options && currentVariant.options.join(' / ')) || '';
        if (variantName) selectedVariantLabel.textContent = variantName;
      }
      const customQtyInput = parentElement.querySelector('quantity-input-custom, quantity-input');
      if (customQtyInput) {
        if (currentVariant.price !== undefined) {
          customQtyInput.dataset.variantPrice = currentVariant.price;
        }
        if (typeof customQtyInput.resetQuantity === 'function') {
          customQtyInput.resetQuantity();
        } else {
          const inputField = customQtyInput.querySelector('input[type="number"]');
          if (inputField) {
            const minVal = inputField.min || 1;
            inputField.value = minVal;
            inputField.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      }
    }
    
    setStatuses(currentVariant, formsSelector, renders, parentSelector);
    if(!currentVariant) return;
    
    if(currentVariant.featured_image) setGallery(currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(currentVariant.id, parentSelector);
    renderVariant(renders, currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    const textSpan = typeof element.querySelector === 'function' ? element.querySelector('[data-atc-btn-text]') : null;
    const target = textSpan || element;
    target.textContent = text;
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      const atcText = form.querySelector('[data-atc-btn-text]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcText ? atcText : atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem ? templateElem.content.querySelector(`[data-media-id="${imageId}"]`) : null;
      const imageContainer = document.querySelector(arr[0]);
      if (!imageContainer || !templateElement) return;
      const card = imageContainer.closest('.product-card, .product-card-new, .product-bundle-row, .product-complementary-row, article, .main-product_wrapper');
      if (card) card.classList.add('variant-loading');
      imageContainer.style.transition = 'opacity 0.2s ease';
      imageContainer.style.opacity = 0.3;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        imageContainer.style.opacity = 1;
        if (card) card.classList.remove('variant-loading');
      }, 300);
      return;
    }
    arr.forEach(gallerySelector => {
      const galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(gal => {
        if (gal.slider) {
          const slider = gal.slider;
          const slide = slider.slides.find((s) => s.el.dataset.mediaId == imageId || s.el.dataset.mediaPoint == imageId);
          if (slide) {
            slider.go(slide.index, { userInitiated: true });
            return;
          }
        }
        
        const targetMedia = gal.querySelector(`[data-media-id="${imageId}"], [data-media-point="${imageId}"]`);
        if (targetMedia) {
          const mainThumbs = gal.querySelector('[data-main-thumbs]');
          if (mainThumbs && mainThumbs.scrollHeight > mainThumbs.clientHeight) {
            const targetTop = targetMedia.getBoundingClientRect().top - mainThumbs.getBoundingClientRect().top + mainThumbs.scrollTop;
            mainThumbs.scrollTo({ top: targetTop, behavior: 'smooth' });
          } else {
            const headerArea = document.querySelector('.page-header_fixed-area') || document.querySelector('.page-header');
            const headerOffset = headerArea ? headerArea.getBoundingClientRect().height : 0;
            const targetY = targetMedia.getBoundingClientRect().top + window.pageYOffset - headerOffset - 20;
            if (window.gsap && window.ScrollToPlugin) {
              gsap.to(window, {
                duration: 0.8,
                scrollTo: { y: targetMedia, offsetY: headerOffset + 20 },
                ease: 'power2.out'
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
          const mainSlides = Array.from(gal.querySelectorAll('[data-main-thumbs] .splide__slide'));
          const thumbSlides = Array.from(gal.querySelectorAll('[data-switcher-thumbs] .splide__slide'));
          if (mainSlides.length > 0 && thumbSlides.length > 0) {
            const activeSlide = targetMedia.closest('.splide__slide');
            if (activeSlide) {
              const idx = mainSlides.indexOf(activeSlide);
              if (idx !== -1 && thumbSlides[idx]) {
                thumbSlides.forEach(t => t.classList.remove('is-active'));
                thumbSlides[idx].classList.add('is-active');
                const container = gal.querySelector('[data-switcher-thumbs]');
                if (container) {
                  const thumbTop = thumbSlides[idx].getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                  container.scrollTo({ top: thumbTop - 20, behavior: 'smooth' });
                }
              }
            }
          }
        } else {
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          if (items.length > 0) {
            const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
            if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
            items.unshift(items.splice(activeIndex, 1)[0]);
            gal.innerHTML = '';
            gal.classList.add('--swapped');
            gal.append(...items);
            gal.setAttribute('data-media-id', imageId);
          }
        }
      });
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    const parentElement = document.querySelector(parent);
    const card = parentElement ? (parentElement.closest('.product-card, .product-card-new, .product-bundle-row, .product-complementary-row, article, .section-wrapper') || parentElement) : null;
    if (parentElement) parentElement.classList.add('variant-loading');
    if (card) card.classList.add('variant-loading');
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (parentElement) {
          const arr = JSON.parse(elems);
          arr.forEach(selector => {
            const elements = parentElement.querySelectorAll(selector);
            const sourceElement = html.querySelector(selector);
            if (sourceElement) {
              elements.forEach(element => {
                element.innerHTML = sourceElement.innerHTML;
              });
            }
          });
          const qtyInput = parentElement.querySelector('quantity-input');
          if (qtyInput) {
            const sourceQtyInput = html.querySelector('quantity-input');
            if (sourceQtyInput && sourceQtyInput.dataset.variantPrice) {
              qtyInput.dataset.variantPrice = sourceQtyInput.dataset.variantPrice;
            } else {
              const jsonSelector = parentElement.querySelector('variant-pill')?.dataset.jsonSelector;
              const jsonElem = jsonSelector ? document.querySelector(jsonSelector) : null;
              if (jsonElem) {
                const data = JSON.parse(jsonElem.textContent);
                const variant = data.variants.find(v => v.id == id);
                if (variant) {
                  qtyInput.dataset.variantPrice = variant.price;
                }
              }
            }
            const inputField = qtyInput.querySelector('input[type="number"]');
            if (inputField) {
              inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (parentElement) parentElement.classList.remove('variant-loading');
        if (card) card.classList.remove('variant-loading');
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const elements = parentElem.querySelectorAll(selector);
      elements.forEach(element => {
        flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
      });
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const sectionHtml = response.sections && response.sections[section.id];
      if (!sectionHtml) return;
      const parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const html = parsedDoc.getElementById(section.id) || parsedDoc;
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyFields = form.querySelectorAll('input[name="quantity"]');
    if (!qtyFields || qtyFields.length === 0) return;
    qtyFields.forEach(qtyField => {
      const minVal = parseFloat(qtyField.min) || 1;
      qtyField.value = minVal;
      qtyField.dispatchEvent(new Event('input', { bubbles: true }));
    });
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    const atcButton = element ? (element.querySelector('button[type="submit"]') || element.querySelector('button') || element) : null;
    if (atcButton) atcButton.classList.add('btn-loading');
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        if (atcButton) atcButton.classList.remove('btn-loading');
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content ? this.content.querySelectorAll('[data-btn-variant]') : [];

      this.toggleDropdownBound = this.toggleDropdown.bind(this);
      this.onBodyClickBound = this.onBodyClick.bind(this);
      this.onKeyUpBound = this.onKeyUp.bind(this);
      this.onVariantSelectBound = this.onVariantSelect.bind(this);

      if (this.button) {
        this.button.addEventListener('click', this.toggleDropdownBound);
      }

      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    disconnectedCallback() {
      if (this.button && this.toggleDropdownBound) {
        this.button.removeEventListener('click', this.toggleDropdownBound);
      }
      this.closeDropdown();
    }

    toggleDropdown(event) {
      if (!this.button) return;
      if (this.button.getAttribute('aria-expanded') === 'true') {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'true');
      this.content.classList.add('dropdown--open');
      this.doAnimate(this.content);
      this.content.focus();
      trapFocus(this.content);
      if (this.items) {
        this.items.forEach(item => {
          item.addEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.addEventListener('click', this.onBodyClickBound);
      this.addEventListener('keyup', this.onKeyUpBound);
    }

    closeDropdown() {
      if (!this.button || !this.content) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.button, false);
      if (this.items) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.onVariantSelectBound);
        });
      }
      document.body.removeEventListener('click', this.onBodyClickBound);
      this.removeEventListener('keyup', this.onKeyUpBound);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }

    onKeyUp(event) {
      if (event.key === 'Escape') {
        this.closeDropdown();
      }
    }

    doAnimate(element) {
      try {
        const animationFrames = JSON.parse(this.content.dataset.frames);
        const timing = JSON.parse(this.content.dataset.options);
        if (animationFrames && timing) {
          element.animate(animationFrames, timing);
        }
      } catch (e) {
        console.warn("Animation failed", e);
      }
    }

    onVariantSelect(event) {
      const target = event.currentTarget;
      this.items.forEach(item => item.classList.remove('product-card_select-option--active'));
      target.classList.add('product-card_select-option--active');
      
      const displayElem = this.button.querySelector('[data-current-value]');
      if (displayElem) displayElem.textContent = target.dataset.text;

      const currentDot = this.button.querySelector('[data-current-dot]');
      if (currentDot) {
        const swatchValue = target.style.getPropertyValue('--variant-swatch');
        if (swatchValue) {
          currentDot.style.setProperty('--variant-swatch', swatchValue);
          const focalPoint = target.style.getPropertyValue('--swatch-focal-point');
          if (focalPoint) {
            currentDot.style.setProperty('--swatch-focal-point', focalPoint);
          } else {
            currentDot.style.removeProperty('--swatch-focal-point');
          }
          currentDot.classList.remove('hidden');
        } else {
          currentDot.classList.add('hidden');
        }
      }

      this.setVariantOptions(target.dataset.value);
      this.closeDropdown();
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      onVariantChange(
        this.dataset.jsonSelector,
        currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      const json = document.querySelector(this.dataset.jsonSelector);
      if (!json) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const variants = data && data.variants;
      if (!variants || !Array.isArray(variants)) return;

      const elems = parentOrElems instanceof HTMLElement
        ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
        : parentOrElems;

      elems.forEach((select) => {
        select.setAttribute('data-current-set', JSON.stringify(set));
        const optionIndex = parseInt(select.dataset.optionIndex);
        if (isNaN(optionIndex)) return;

        const isCheckSets = select.dataset.checkSets === 'true';
        const dropdownItems = select.querySelectorAll('.product-card_select-option, [data-btn-variant]');
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((item) => {
            const val = item.dataset.value;
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const statusText = item.querySelector('[data-variant-status-text]');
            if (isAvailable) {
              item.style.opacity = '1';
              if (statusText) statusText.classList.add('hidden');
            } else {
              item.style.opacity = '0.5';
              if (statusText) statusText.classList.remove('hidden');
            }

            const isActive = item.classList.contains('product-card_select-option--active') || item.classList.contains('active') || val === set[optionIndex];
            if (isActive) {
              const displayElem = select.querySelector('[data-current-value]');
              if (displayElem) {
                if (!isAvailable && statusText) {
                  displayElem.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  displayElem.textContent = item.dataset.text || val;
                }
              }
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                if (!isAvailable && statusText) {
                  selectedValueSpan.textContent = (item.dataset.text || val) + ' ' + statusText.textContent.trim();
                } else {
                  selectedValueSpan.textContent = item.dataset.text || val;
                }
              }
            }
          });
        }

        const radioInputs = select.querySelectorAll('input[type="radio"]');
        if (radioInputs.length > 0) {
          radioInputs.forEach((input) => {
            const val = input.value || input.getAttribute('value');
            if (val === undefined) return;

            const isAvailable = variants.some((v) => {
              if (!v.available) return false;
              const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
              if (vVal !== val) return false;
              if (isCheckSets) return true;
              for (let k = 0; k < optionIndex; k++) {
                const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
                if (prevVal !== set[k]) return false;
              }
              return true;
            });

            const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
            const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

            if (isAvailable) {
              input.classList.remove('disabled');
              if (labelText) {
                labelText.classList.add('hidden');
                labelText.classList.remove('visually-hidden');
              }
            } else {
              input.classList.add('disabled');
              if (labelText) {
                labelText.classList.remove('hidden');
                labelText.classList.add('visually-hidden');
              }
            }

            if (input.checked || val === set[optionIndex]) {
              const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
              if (selectedValueSpan) {
                selectedValueSpan.textContent = val;
              }
            }
          });
        }
      });
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class VariantPill extends HTMLElement {
    constructor() {
      super();

      this.variantChange = this.onInputChange.bind(this);
      this.addEventListener('change', this.variantChange);
      this.addEventListener('click', this.onClick.bind(this));
    }

    connectedCallback() {
      const parent = document.querySelector(this.dataset.parent);
      if (parent) {
        const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
        if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
      }
    }

    onClick(event) {
      const label = event.target.closest('label');
      if (label && label.htmlFor) {
        const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
        if (input) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = input.value;
            }
            this.setVariantOptions(input.value);
          }
          return;
        }
      }
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = radio.value;
        }
        this.setVariantOptions(radio.value);
        return;
      }
      const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
      if (btn && btn.dataset.value) {
        const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = btn.dataset.value;
        }
        this.setVariantOptions(btn.dataset.value);
      }
    }

    onInputChange(event) {
      const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
        ? event.target
        : this.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = input.value;
      }
      this.setVariantOptions(input.value);
    }

    setVariantOptions(value) {
      const parent = document.querySelector(this.dataset.parent);
      if (!parent) return;
      const errElem = document.querySelector(this.dataset.errorSelector);
      if (errElem) errElem.classList.add('hidden');

      const targetCard = (this.dataset.mainParent ? (document.querySelector(this.dataset.mainParent) || document.getElementById(this.dataset.mainParent.replace(/^#/, ''))) : null) || this.closest('.product-complementary-row, .product-bundle-row, article');
      const selectedVariantLabel = targetCard?.querySelector('.product-bundle-row_swatches-selected-label, .product-complementary-row_swatches-selected-label, [class*="_swatches-selected-label"]');
      if (selectedVariantLabel && value) {
        selectedVariantLabel.textContent = value;
      }

      const currentSet = JSON.parse(this.dataset.currentSet);
      const index = parseInt(this.dataset.optionIndex);
      currentSet[index] = value;

      this.updateOptionsAvailability(parent, currentSet);

      let availableSet = null;
      if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
        const sets = JSON.parse(this.dataset.availableSets);
        const checkSet = (val) => {
          if (!val || !Array.isArray(sets)) return null;
          return sets.find((set) => set.includes(val));
        };
        availableSet = checkSet(value);
      }
      onVariantChange(
        this.dataset.jsonSelector,
        availableSet ? availableSet : currentSet,
        this.dataset.forms,
        this.dataset.renders,
        this.dataset.mainParent,
        this.dataset.galleries,
        this.dataset.sectionId,
        this.dataset.productUrl,
        this.dataset.updateUrl,
        null,
        this.dataset.mediaTemplate === 'true',
        this.dataset.template
      );
    }

    updateOptionsAvailability(parentOrElems, set) {
      VariantDropdown.prototype.updateOptionsAvailability.call(this, parentOrElems, set);
    }
  }
  if (!customElements.get('variant-pill')) { customElements.define('variant-pill', VariantPill); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  window.Shopify = window.Shopify || {};
  window.Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const button = event.target.closest('button');
        if (!button) return;
        const previousValue = this.input.value;
        button.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const minVal = parseInt(this.input.min);
        const maxVal = parseInt(this.input.max);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        if (!btn) return;
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= minVal);
            btn.toggleAttribute('disabled', value <= minVal);
            break;
          case 'max':
            if (!isNaN(maxVal)) {
              btn.classList.toggle('disabled', value >= maxVal);
              btn.toggleAttribute('disabled', value >= maxVal);
            }
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        if (isNaN(total)) return;
        const formattedTotal = Shopify.formatMoney(total, window.money_format);
        const totalLabel = elem.querySelector('.product-complementary-row_total-label');
        if (totalLabel) {
          elem.innerHTML = totalLabel.outerHTML + formattedTotal;
        } else {
          elem.innerHTML = formattedTotal;
        }
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const parentRow = this.closest('.product-complementary-row, article');
        const errElem = parentRow?.querySelector('[data-product-complementary-card-render-error], [data-render-main-error]');
        if (errElem) {
          errElem.classList.add('hidden');
          const errSpan = errElem.querySelector('[data-error]');
          if (errSpan) errSpan.innerText = '';
        }
        const qtySubtotal = parentRow?.querySelector('[data-qty-subtotal]') 
          || this.querySelector('[data-qty-subtotal]') 
          || document.querySelector('[data-qty-single-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  class QuantityInputCustom extends QuantityInput {
    constructor() {
      super();
      const initialVal = parseInt(this.input?.value) || 1;
      this.updateSubtotal(initialVal);
    }

    updateSubtotal(qty) {
      const subtotalElem = this.closest('.product-complementary-row, article')?.querySelector('[data-qty-subtotal]');
      if (!subtotalElem) return;
      const price = parseInt(this.dataset.variantPrice);
      if (isNaN(price)) return;
      const total = qty * price;
      const formattedTotal = Shopify.formatMoney(total, window.money_format);
      const totalLabel = subtotalElem.querySelector('.product-complementary-row_total-label');
      if (totalLabel) {
        subtotalElem.innerHTML = totalLabel.outerHTML + formattedTotal;
      } else {
        subtotalElem.innerHTML = formattedTotal;
      }
    }

    resetQuantity() {
      if (!this.input) return;
      const minVal = parseInt(this.input.min) || 1;
      this.input.value = minVal;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input-custom')) {
    customElements.define('quantity-input-custom', QuantityInputCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-banner"] && !Shopify.designMode) return;
  try {
    
  /* ── Promotion banner entrance & sequential video autoplay ──────── */
  (function () {
    function initPromotionBannerSection() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var gsap = window.gsap;
      var ST = window.ScrollTrigger;
      if (!gsap || !ST) return;
      gsap.registerPlugin(ST);

      function scrollPinPriority(el) {
        return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
      }

      function getAutoplayCols(section) {
        return Array.from(section.querySelectorAll('.promotion-banner_column[data-video-autoplay="true"]')).filter(function (col) {
          return !!col.querySelector('deferred-media');
        });
      }

      function clearControllerTimers(controller) {
        if (!controller) return;
        if (controller.timer) {
          clearTimeout(controller.timer);
          controller.timer = null;
        }
        if (controller.videoListener) {
          controller.videoListener.video.removeEventListener('ended', controller.videoListener.handler);
          controller.videoListener = null;
        }
        if (controller.messageListener) {
          window.removeEventListener('message', controller.messageListener);
          controller.messageListener = null;
        }
      }

      function pauseColumnVideo(col) {
        var deferredMedia = col.querySelector('deferred-media');
        if (!deferredMedia) return;
        var video = deferredMedia.querySelector('video');
        if (video) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
        }
        var youtube = deferredMedia.querySelector('.js-youtube');
        if (youtube && youtube.contentWindow) {
          youtube.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        var vimeo = deferredMedia.querySelector('.js-vimeo');
        if (vimeo && vimeo.contentWindow) {
          vimeo.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }

      function playColAtIndex(section, index) {
        var cols = getAutoplayCols(section);
        if (!cols.length) return;

        var controller = section._promoVideoController;
        if (!controller || !controller.isPlaying) return;

        if (index >= cols.length) index = 0;
        controller.currentIndex = index;

        var targetCol = cols[index];
        var isMulti = cols.length > 1;

        clearControllerTimers(controller);

        cols.forEach(function (col, i) {
          if (i !== index) {
            pauseColumnVideo(col);
          }
        });

        var deferredMedia = targetCol.querySelector('deferred-media');
        if (!deferredMedia) return;

        function onVideoEnded() {
          if (!controller.isPlaying) return;
          clearControllerTimers(controller);
          if (isMulti) {
            pauseColumnVideo(targetCol);
            var nextIndex = (index + 1) % cols.length;
            playColAtIndex(section, nextIndex);
          }
        }

        function startPlayback() {
          var video = deferredMedia.querySelector('video');
          var youtube = deferredMedia.querySelector('.js-youtube');
          var vimeo = deferredMedia.querySelector('.js-vimeo');

          if (video) {
            video.muted = true;
            video.controls = false;
            if (isMulti) {
              video.loop = false;
              video.removeAttribute('loop');
              var endedHandler = function () {
                onVideoEnded();
              };
              video.addEventListener('ended', endedHandler, { once: true });
              controller.videoListener = { video: video, handler: endedHandler };
            } else {
              video.loop = true;
            }

            try {
              video.currentTime = 0;
            } catch (e) {}

            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function () {
                if (isMulti) {
                  controller.timer = setTimeout(onVideoEnded, 6000);
                }
              });
            }

            if (isMulti) {
              var duration = (video.duration && !isNaN(video.duration) && isFinite(video.duration) && video.duration > 0)
                ? (video.duration + 0.5) * 1000
                : 8000;
              controller.timer = setTimeout(onVideoEnded, Math.max(duration, 3000));
            }
          } else if (youtube || vimeo) {
            if (youtube && youtube.contentWindow) {
              youtube.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0, true]}', '*');
              youtube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
            if (vimeo && vimeo.contentWindow) {
              vimeo.contentWindow.postMessage('{"method":"setCurrentTime","value":0}', '*');
              vimeo.contentWindow.postMessage('{"method":"play"}', '*');
            }

            if (isMulti) {
              var msgHandler = function (event) {
                try {
                  var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                  if (data) {
                    if (data.event === 'onStateChange' && data.info === 0) {
                      onVideoEnded();
                    } else if (data.event === 'ended') {
                      onVideoEnded();
                    }
                  }
                } catch (e) {}
              };
              window.addEventListener('message', msgHandler);
              controller.messageListener = msgHandler;
              controller.timer = setTimeout(onVideoEnded, 8000);
            }
          }
        }

        if (deferredMedia.getAttribute('loaded') !== 'true') {
          if (typeof deferredMedia.loadMediaHandler === 'function') {
            deferredMedia.loadMediaHandler();
          } else {
            var btn = deferredMedia.querySelector('[data-deferred-media-toggler]');
            if (btn) btn.click();
          }
          requestAnimationFrame(function () {
            startPlayback();
          });
        } else {
          startPlayback();
        }
      }

      function startSectionAutoplay(section) {
        var cols = getAutoplayCols(section);
        if (!cols.length) return;

        var controller = section._promoVideoController;
        if (!controller) {
          controller = {
            currentIndex: 0,
            isPlaying: false,
            timer: null,
            videoListener: null,
            messageListener: null
          };
          section._promoVideoController = controller;
        }

        controller.isPlaying = true;
        playColAtIndex(section, controller.currentIndex);
      }

      function pauseSectionAutoplay(section) {
        var controller = section._promoVideoController;
        if (controller) {
          controller.isPlaying = false;
          clearControllerTimers(controller);
        }
        var cols = getAutoplayCols(section);
        cols.forEach(pauseColumnVideo);
      }

      function playPromoBannerReveal(section) {
        if (reduce) return;
        var _M = window.themeMotion || {};
        var wrapper  = section.querySelector('.promotion-banner_wrapper');
        var heading  = section.querySelector('.promo-card_heading');
        var desc     = section.querySelector('.promo-card_description');
        var ctaWrap  = section.querySelector('.promo-card_button-wrapper');

        var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

        if (wrapper && (_M.flags ? _M.flags.clipReveals !== false : true)) {
          gsap.set(wrapper, { clipPath: 'inset(0 0 100% 0)', scale: 1.03, transformOrigin: 'center bottom' });
          tl.to(wrapper, {
            clipPath: 'inset(0 0 0% 0)', scale: 1,
            duration: (_M.dur && _M.dur.xslow) || 1.4, ease: (_M.ease && _M.ease.reveal) || 'expo.out',
            clearProps: 'clipPath,scale'
          }, 0);
        } else if (wrapper) {
          gsap.set(wrapper, { opacity: 0 });
          tl.to(wrapper, { opacity: 1, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        }

        if (heading) {
          var split = window.themeSplitHeading && window.themeSplitHeading(heading);
          if (split && split.targets !== heading) {
            gsap.set(split.targets, split.fromVars);
            tl.to(split.targets, Object.assign({}, split.toVars, { duration: split.duration, ease: split.ease, stagger: split.stagger }), 0.4);
          } else {
            gsap.set(heading, { opacity: 0, y: 28 });
            tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.4);
          }
        }

        if (desc) {
          var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
          if (descSplit && descSplit.targets !== desc) {
            gsap.set(descSplit.targets, descSplit.fromVars);
            tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, { duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger }), 0.6);
          } else {
            gsap.set(desc, { opacity: 0, y: 24 });
            tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0.6);
          }
        }

        if (ctaWrap) {
          gsap.set(ctaWrap, { opacity: 0, scale: 0.88 });
          tl.to(ctaWrap, {
            opacity: 1, scale: 1,
            duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.spring) || 'elastic.out(1,0.5)',
            clearProps: 'scale'
          }, 0.75);
        }
      }

      function initPromoBannerSection(section) {
        var _M = window.themeMotion || {};
        var triggerId = 'promo-banner-reveal-' + (section.id || 'static');
        ST.getAll().forEach(function (t) {
          if (t.vars && t.vars.id === triggerId) t.kill();
        });
        if (window.innerWidth < 768) return;
        ST.create({
          id: triggerId,
          trigger: section,
          start: (_M.trigger && _M.trigger.start) || 'top 82%',
          end: 'bottom top',
          refreshPriority: scrollPinPriority(section),
          onEnter: function () {
            playPromoBannerReveal(section);
            startSectionAutoplay(section);
          },
          onEnterBack: function () {
            playPromoBannerReveal(section);
            startSectionAutoplay(section);
          },
          onLeave: function () {
            pauseSectionAutoplay(section);
          },
          onLeaveBack: function () {
            pauseSectionAutoplay(section);
          }
        });
      }

      function initAll() {
        document.querySelectorAll('.promotion-banner').forEach(initPromoBannerSection);
      }

      initAll();

      document.addEventListener('shopify:section:load', function (e) {
        var root = e.target;
        var s = root && (root.classList.contains('promotion-banner') ? root : root.querySelector('.promotion-banner'));
        if (s) {
          initPromoBannerSection(s);
        }
      });

      document.addEventListener('shopify:section:reorder', function () {
        initAll();
      });
    }

    if (window.onThemeGsapReady) {
      window.onThemeGsapReady(initPromotionBannerSection);
    } else {
      document.addEventListener('DOMContentLoaded', initPromotionBannerSection);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-hero-banner"] && !Shopify.designMode) return;
  try {
    
  class PromotionalHeroBanner extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
      if (slides.length === 0) return;
      /* The section's entrance reveal already gates itself behind
         prefers-reduced-motion — this accordion interaction (hover/click/focus
         swapping which slide is expanded) didn't. Keep the swap itself (it's
         input-tied, not continuous) but drop the flex-basis tween driving it.
         Reactive to the MediaQueryList's own "change" event rather than a
         one-shot .matches read, so toggling the OS setting mid-session takes
         effect on the next slide swap instead of only after a reload. */
      const reduceMotionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      let reduceMotion = reduceMotionQuery ? reduceMotionQuery.matches : false;
      if (reduceMotionQuery) {
        reduceMotionQuery.addEventListener('change', (e) => { reduceMotion = e.matches; });
      }
      let activeSlide = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
      /* The heading is excluded here — it stays visible in both states and is
         rotated into a vertical tab label via CSS when collapsed, animated
         between states with GSAP Flip (see activateSlide) instead of the
         opacity/y fade the rest of these text blocks use. */
      const getTextEls = (slide) =>
        ['[data-banner-logo-wrapper]', '[data-banner-tagline-wrapper]', '[data-banner-subheading-wrapper]', '[data-banner-description-wrapper]', '[data-banner-countdown-wrapper]', '[data-banner-button-wrapper]']
          .map((sel) => slide.querySelector(sel))
          .filter(Boolean);
      const getHeadingWrapper = (slide) => slide.querySelector('[data-banner-heading-wrapper]');
      const getInactiveBasis = () => (window.innerWidth < 768 ? '10vw' : 'min(195px, calc(195 / 1920 * 100vw))');
      const getFlexVars = (isActive) =>
        isActive ? { flexGrow: 1, flexShrink: 1, flexBasis: '0%' } : { flexGrow: 0, flexShrink: 0, flexBasis: getInactiveBasis() };
      /* Shared by both the panel's flex tween and the heading's Flip tween
         so they can't drift apart. power2.out's velocity peaks right at
         t=0 — fine for a fade, but for a full 90° rotation that front-loaded
         burst reads as an abrupt snap instead of a smooth turn. sine.inOut
         eases in and out symmetrically, closer to how rotation actually
         reads as smooth to the eye. */
      const ACCORDION_DURATION = 0.6;
      const ACCORDION_EASE = 'sine.inOut';
      const initSlide = (slide) => {
        const isActive = slide === activeSlide;
        const textEls = getTextEls(slide);
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-expanded', String(isActive));
        if (!window.gsap) return;
        /* over-banner.liquid's `.over-banner` has a CSS `transition` on
           flex-grow/flex-basis as a no-JS fallback (so the plain class swap
           still animates when GSAP never loads). Once GSAP is available it
           takes over animating those same two properties every frame — left
           active, the browser's own transition keeps retriggering itself
           toward each new frame's value, chasing a constantly-moving target
           instead of ever tracking GSAP's curve, which is what made the
           accordion resize look laggy/non-smooth. Killing it inline (once,
           here) hands the properties over to GSAP exclusively. */
        window.gsap.set(slide, Object.assign({ transition: 'none' }, getFlexVars(isActive)));
        if (!textEls.length) return;
        window.gsap.set(textEls, isActive ? { autoAlpha: 1, y: 0 } : { autoAlpha: 0, y: 10 });
      };
      const initSlides = () => slides.forEach(initSlide);
      initSlides();
      if (!window.gsap) {
        window.addEventListener('load', initSlides, { once: true });
      }
      const unlockPointerEvents = () => {
        slides.forEach((s) => s.classList.remove('--pointer-avoid'));
      };
      /* Class toggle + fade for everything except the heading and the
         panel's own flex-basis — those two are handled together in
         activateSlide so they can be measured and started from one
         consistent snapshot instead of running as separate tweens that
         can drift out of sync with each other (see the comment there). */
      const updateSlideStatus = (slide, targetSlide) => {
        const willBeActive = slide === targetSlide;
        const textEls = getTextEls(slide);
        slide.classList.toggle('is-active', willBeActive);
        slide.setAttribute('aria-expanded', String(willBeActive));
        if (!textEls.length) return;
        if (!window.gsap) {
          textEls.forEach((el) => {
            el.style.opacity = '';
            el.style.transform = '';
            el.style.visibility = '';
          });
          return;
        }
        if (willBeActive) {
          window.gsap.fromTo(
            textEls,
            { autoAlpha: 0, y: 10 },
            { autoAlpha: 1, y: 0, duration: 0.35, ease: 'power2.out', stagger: 0.04, delay: 0.15, overwrite: 'auto' }
          );
          return;
        }
        window.gsap.to(textEls, {
          autoAlpha: 0,
          y: 10,
          duration: 0.15,
          ease: 'power2.in',
          overwrite: 'auto',
          onComplete: () => {
            if (!window.gsap || slide.classList.contains('is-active')) return;
            window.gsap.set(textEls, { clearProps: 'opacity,visibility,transform,y,autoAlpha' });
          }
        });
      };
      const activateSlide = (targetSlide) => {
        if (!targetSlide || targetSlide === activeSlide) return;
        if (this.clearPointerEventsTimer) clearTimeout(this.clearPointerEventsTimer);
        slides.forEach((slide) => {
          slide.classList.toggle('--pointer-avoid', slide !== targetSlide);
        });

        const changingSlides = slides.filter((slide) => slide.classList.contains('is-active') !== (slide === targetSlide));
        const useGsap = !!window.gsap;
        const useHeadingFlip = useGsap && !reduceMotion && !!window.Flip && changingSlides.length > 0;

        /* FLIP: Measure First — the heading's old (rotated/collapsed or
           horizontal/expanded) box, captured before anything below moves it. */
        const headingFlips = useHeadingFlip
          ? changingSlides
              .map((slide) => getHeadingWrapper(slide))
              .filter(Boolean)
              .map((headingWrapper) => ({
                heading: headingWrapper.querySelector('.over-banner_heading'),
                state: window.Flip.getState(headingWrapper, { props: 'rotation' })
              }))
          : [];
        /* Pin nowrap for the duration of the tween — the "becoming active"
           end state has no forced nowrap of its own (a long merchant
           heading should be free to wrap once it's settled and horizontal),
           but letting it wrap mid-tween, while scale:true below is faking
           the size change with a transform, shows the wrapped lines from
           frame one instead of the intended single vertical/horizontal
           line. Cleared once each Flip tween completes. */
        headingFlips.forEach(({ heading }) => {
          if (heading) heading.style.whiteSpace = 'nowrap';
        });

        slides.forEach((slide) => updateSlideStatus(slide, targetSlide));

        if (useHeadingFlip) {
          /* The heading is positioned relative to its panel, and that panel
             is about to grow/shrink over the same 0.5s via the flex tween
             below. If Flip measured "Last" right now, the panel would
             still be at its OLD width — the flex tween hasn't run yet — so
             the heading would aim at a stale target and visibly fight the
             panel as it kept resizing underneath it; that mismatch was the
             cause of the previous jank. Jump every changing panel straight
             to its final flex values first (synchronous, before the browser
             paints) purely so Flip measures the real destination; the
             fromTo below puts the panel back to its starting width in the
             same synchronous pass and animates it from there, so nothing
             visibly snaps. */
          changingSlides.forEach((slide) => {
            window.gsap.set(slide, getFlexVars(slide === targetSlide));
          });
          /* FLIP: Invert & Play — scale:true keeps the heading's real DOM
             width pinned at its end-state value and fakes the size change
             with a scaleX/scaleY transform instead, so the text can't
             reflow mid-tween the way it would if Flip tweened the actual
             width. */
          headingFlips.forEach(({ heading, state }) => {
            window.Flip.from(state, {
              duration: ACCORDION_DURATION,
              ease: ACCORDION_EASE,
              absolute: true,
              scale: true,
              overwrite: 'auto',
              onComplete: () => {
                if (heading) heading.style.whiteSpace = '';
              }
            });
            /* The rotation alone reads as a hard mechanical spin since the
               text stays fully opaque the whole way through. Layering a
               opacity dip on the same element/duration - fading out as it
               turns past the illegible diagonal midpoint, back in as it
               settles - reads as a modern fade+turn instead of a flat rotate.
               A separate tween (not part of the Flip vars) because Flip.from
               only interpolates the transform props it measured. */
            if (heading) {
              window.gsap.fromTo(
                heading,
                { opacity: 1 },
                { keyframes: { opacity: [0.15, 1] }, duration: ACCORDION_DURATION, ease: 'power2.inOut', overwrite: 'auto' }
              );
            }
          });
        }

        if (useGsap) {
          changingSlides.forEach((slide) => {
            const willBeActive = slide === targetSlide;
            if (reduceMotion) {
              window.gsap.set(slide, getFlexVars(willBeActive));
              return;
            }
            window.gsap.fromTo(
              slide,
              getFlexVars(!willBeActive),
              Object.assign({ duration: ACCORDION_DURATION, ease: ACCORDION_EASE, overwrite: 'auto' }, getFlexVars(willBeActive), {
                onComplete: willBeActive ? unlockPointerEvents : undefined
              })
            );
          });
        }

        activeSlide = targetSlide;
        if (!useGsap || reduceMotion) {
          unlockPointerEvents();
        } else {
          this.clearPointerEventsTimer = setTimeout(unlockPointerEvents, ACCORDION_DURATION * 1000 + 50);
        }
      };
      slides.forEach((slide) => {
        slide.addEventListener('mouseenter', () => activateSlide(slide));
        slide.addEventListener('click', () => activateSlide(slide));
        slide.addEventListener('focusin', () => activateSlide(slide));
        slide.addEventListener('keydown', (e) => {
          if (e.target !== slide) return;
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            activateSlide(slide);
          }
        });
      });
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const targetBlock = slides.find((slide) => slide.dataset.blockId === event.detail.blockId);
          if (!targetBlock) return;
          activateSlide(targetBlock);
        });
      }
    }
  }
  if (!customElements.get('promotional-hero-banner')) {
    customElements.define('promotional-hero-banner', PromotionalHeroBanner);
  }
  
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const endDate = new Date(this.getAttribute('end-date'));
      if (isNaN(endDate)) return this.hideTimer();
      const els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]')
      };
      const last = { days: null, hours: null, minutes: null, seconds: null };
      const frames = this.dataset.frames ? JSON.parse(this.dataset.frames) : null;
      const options = this.dataset.options ? JSON.parse(this.dataset.options) : null;
      const doAnimate = (el) => {
        if (!el || !frames || !options) return;
        if (el.getAnimations) {
          el.getAnimations().forEach((anim) => anim.cancel());
        }
        el.animate(frames, options);
      };
      const hideTimer = () => {
        this.classList.add('hidden');
        if (this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
        const message = this.nextElementSibling;
        if (message?.hasAttribute('data-message')) message.classList.remove('hidden');
      };
      const update = () => {
        const remaining = endDate.getTime() - Date.now();
        if (remaining <= 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          Object.values(els).forEach(el => el && (el.textContent = '0'));
          hideTimer();
          this.dispatchEvent(new Event('timeup'));
          return;
        }
        const current = {
          days: Math.floor(remaining / 864e5),
          hours: Math.floor((remaining % 864e5) / 36e5),
          minutes: Math.floor((remaining % 36e5) / 6e4),
          seconds: Math.floor((remaining % 6e4) / 1e3)
        };
        for (const unit in current) {
          if (els[unit] && last[unit] !== current[unit]) {
            els[unit].textContent = current[unit];
            if (last[unit] !== null) doAnimate(els[unit]);
            last[unit] = current[unit];
          }
        }
      };
      update();
      this.intervalId = setInterval(update, 1000);
    }
    disconnectedCallback() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  /* ── Section entrance reveal ─────────────────────────────────────── */
  function playPromotionalHeroBannerReveal(wrapper) {
    var _M = window.themeMotion || {};
    window.gsap.set(wrapper, { clipPath: 'inset(100% 0 0 0)', scale: 1.03, transformOrigin: 'center bottom' });
    window.gsap.to(wrapper, {
      clipPath: 'inset(0% 0 0 0)', scale: 1,
      duration: (_M.dur && _M.dur.xslow) || 1.4, ease: (_M.ease && _M.ease.reveal) || 'expo.out',
      clearProps: 'clipPath,scale',
      overwrite: 'auto'
    });

    /* The clip-wipe above reveals the whole slide as one block — heading
       and description still need their own themeSplitHeading treatment
       layered on top so the merchant's chosen text animation actually
       shows, same combo as the clip-wrap + split used in featured-video/
       promotion-banner. Only the active accordion slide's text is split,
       matching what PromotionalHeroBanner's connectedCallback already
       treats as visible. */
    var activeSlide = wrapper.querySelector('.over-banner.is-active') || wrapper.querySelector('.over-banner');
    var heading = activeSlide && activeSlide.querySelector('.over-banner_heading');
    var desc = activeSlide && activeSlide.querySelector('.over-banner_description');

    if (heading) {
      var headingSplit = window.themeSplitHeading && window.themeSplitHeading(heading);
      if (headingSplit && headingSplit.targets !== heading) {
        window.gsap.set(headingSplit.targets, headingSplit.fromVars);
        window.gsap.to(headingSplit.targets, Object.assign({}, headingSplit.toVars, {
          duration: headingSplit.duration, ease: headingSplit.ease, stagger: headingSplit.stagger,
          delay: 0.5, overwrite: 'auto'
        }));
      }
    }
    if (desc) {
      var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
      if (descSplit && descSplit.targets !== desc) {
        window.gsap.set(descSplit.targets, descSplit.fromVars);
        window.gsap.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
          duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger,
          delay: 0.65, overwrite: 'auto'
        }));
      }
    }
  }

  /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
     replays every time the section scrolls back into view, instead of
     firing once and staying done forever. onEnter also covers the section
     already being in view when the trigger is created. Falls back to
     playing immediately if ScrollTrigger never loads, matching the
     previous behavior when window.ScrollTrigger was unavailable. Extracted
     into its own named function (rather than inline in a forEach) so a
     single section can be killed-and-rebuilt on shopify:section:load
     without touching any other .promotional-hero-banner instance on the
     page. */
  function initPromotionalHeroBannerSection(section) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (reduce || isMobile) return;
    var _M = window.themeMotion || {};
    var _flags = _M.flags || {};
    if (!_flags.clipReveals && _flags.clipReveals !== undefined) return;

    var wrapper = section.querySelector('.promotional-hero-banner_wrapper, .promotional-hero-banner_area-wrap, [class*="promotional-hero-banner_area"]');
    if (!wrapper || !window.gsap) return;
    if (!window.ScrollTrigger) { playPromotionalHeroBannerReveal(wrapper); return; }
    window.gsap.registerPlugin(window.ScrollTrigger);
    var triggerId = 'promotional-hero-banner-reveal-' + (section.id || 'static');
    window.ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars && t.vars.id === triggerId) t.kill();
    });
    window.ScrollTrigger.create({
      id: triggerId,
      trigger: section,
      start: (_M.trigger && _M.trigger.start) || 'top 82%',
      end: 'bottom top',
      // Without this, this trigger defaults to refreshPriority 0, which
      // outranks any pinned section's negative priority above it, so it
      // could refresh and lock in a stale start/end before sibling pinned
      // sections finish resolving their own pin-spacer heights on the same
      // refresh pass, silently breaking the reveal.
      refreshPriority: window.themeScrollPriority(section),
      onEnter: function () { playPromotionalHeroBannerReveal(wrapper); },
      onEnterBack: function () { playPromotionalHeroBannerReveal(wrapper); }
    });
  }

  window.onThemeGsapReady(function () {
    document.querySelectorAll('.promotional-hero-banner').forEach(initPromotionalHeroBannerSection);
  });

  /* shopify:section:load fires for ANY section reloading in the theme
     editor, not just this one. Reinitializing every promotional-hero-banner
     instance on the page in response to an unrelated section edit would
     kill and rebuild ScrollTriggers that had nothing to do with the edit.
     Scope the reinit to the section that actually reloaded, and re-guard
     with onThemeGsapReady since this listener lives outside the initial
     ready callback above and GSAP may not have finished loading yet. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('promotional-hero-banner')
      ? root
      : (root && root.querySelector ? root.querySelector('.promotional-hero-banner') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initPromotionalHeroBannerSection(section); });
  });

  /* Outright section removal (as opposed to an edit, which fires
     shopify:section:load instead): kill this instance's own reveal
     ScrollTrigger by id rather than relying only on ScrollTrigger's own
     detached-element cleanup on next refresh. Matches
     sections/before-after-content.liquid's pattern. */
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('promotional-hero-banner')
      ? root
      : (root && root.querySelector ? root.querySelector('.promotional-hero-banner') : null);
    if (!section || !section.id || !window.ScrollTrigger) return;
    var triggerId = 'promotional-hero-banner-reveal-' + section.id;
    window.ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars && t.vars.id === triggerId) t.kill();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richtext"] && !Shopify.designMode) return;
  try {
    
  function initRichtextBlocks(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var idPrefix = 'rt-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var triggerStart = (_M.trigger && _M.trigger.start) || 'top 82%';

    /* Tagline entrance */
    var tagline = section.querySelector('.richtext_block--tagline');
    if (tagline) {
      gsap.set(tagline, { opacity: 0, y: 20 });
      gsap.to(tagline, {
        opacity: 1, y: 0,
        duration: (_M.dur && _M.dur.base) || 0.65,
        ease: (_M.ease && _M.ease.enter) || 'power4.out',
        scrollTrigger: {
          id: idPrefix + '-tagline',
          trigger: tagline,
          start: triggerStart,
          end: 'bottom top',
          toggleActions: 'play reverse play reverse',
          /* Without this, this trigger defaults to refreshPriority 0, which
             outranks a pinned section's negative (position-derived) priority
             above it (showcase-hotspot, before-after-content, collection-list,
             main-collections) — merchants can drag any of those above this
             richtext section in the customizer. It would then refresh and
             lock in its start/end before that sibling pinned section finishes
             resolving its own pin-spacer height on the same refresh pass. */
          refreshPriority: window.themeScrollPriority(tagline)
        }
      });
    }

    /* Heading + description reveal, split per-line/word/char via themeSplitHeading */
    var blocks = Array.prototype.slice.call(
      section.querySelectorAll('.richtext_block--heading, .richtext_block--description')
    );
    blocks.forEach(function (block, i) {
      var target = block.querySelector('.richtext_heading') || block.querySelector('.richtext_description-text');
      if (!target) return;
      var split = window.themeSplitHeading(target);
      gsap.set(split.targets, split.fromVars);
      gsap.to(split.targets, Object.assign({}, split.toVars, {
        duration: split.duration,
        ease: split.ease,
        stagger: split.stagger,
        scrollTrigger: {
          id: idPrefix + '-' + i,
          trigger: block,
          start: triggerStart,
          end: 'bottom top',
          toggleActions: 'play reverse play reverse',
          /* Without this, this trigger defaults to refreshPriority 0, which
             outranks a pinned section's negative (position-derived) priority
             above it (showcase-hotspot, before-after-content, collection-list,
             main-collections) — merchants can drag any of those above this
             richtext section in the customizer. It would then refresh and
             lock in its start/end before that sibling pinned section finishes
             resolving its own pin-spacer height on the same refresh pass. */
          refreshPriority: window.themeScrollPriority(block)
        }
      }));
    });

    /* CTA button entrance */
    var ctaWrap = section.querySelector('.richtext_block--button');
    if (ctaWrap) {
      gsap.set(ctaWrap, { opacity: 0, y: 24, scale: 0.9 });
      gsap.to(ctaWrap, {
        opacity: 1, y: 0, scale: 1,
        duration: (_M.dur && _M.dur.slow) || 1.0,
        ease: (_M.ease && _M.ease.spring) || 'elastic.out(1,0.5)',
        clearProps: 'scale',
        scrollTrigger: {
          id: idPrefix + '-cta',
          trigger: ctaWrap,
          start: triggerStart,
          end: 'bottom top',
          toggleActions: 'play reverse play reverse',
          /* Without this, this trigger defaults to refreshPriority 0, which
             outranks a pinned section's negative (position-derived) priority
             above it (showcase-hotspot, before-after-content, collection-list,
             main-collections) — merchants can drag any of those above this
             richtext section in the customizer. It would then refresh and
             lock in its start/end before that sibling pinned section finishes
             resolving its own pin-spacer height on the same refresh pass. */
          refreshPriority: window.themeScrollPriority(ctaWrap)
        }
      });
    }
  }

  function initAllRichtextBlocks() {
    document.querySelectorAll('.richtext').forEach(initRichtextBlocks);
  }

  window.onThemeGsapReady(initAllRichtextBlocks);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('richtext')
      ? root
      : (root && root.querySelector ? root.querySelector('.richtext') : null);
    if (!section) return;
    window.onThemeGsapReady(function () { initRichtextBlocks(section); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  // <scroll-component> (the marquee custom element) is defined once, globally,
  // in assets/scroll-component.js — see that file for the implementation.

  /* ── Scrolling-banner section entrance ───────────────────────────────
     Matches logo-list.liquid's section entrance fade — the marquee track
     itself previously had no reveal at all, appearing instantly while every
     other section on the page fades/reveals in. Fades the <scroll-component>
     wrapper rather than the inner .scroll-component track so this never
     fights the track's own CSS marquee animation (which lives on that inner
     element via --marquee-animation-name). */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playScrollingBannerReveal(section) {
      var _M = window.themeMotion || {};
      var track = section.querySelector('scroll-component');
      var buttonWrap = section.querySelector('.scrolling-banner_button-wrapper');
      var targets = [track, buttonWrap].filter(Boolean);
      if (!targets.length) return;

      gsap.set(targets, { opacity: 0, y: 28 });
      gsap.to(targets, {
        opacity: 1, y: 0,
        duration: (_M.dur && _M.dur.slow) || 1.0,
        ease: (_M.ease && _M.ease.enter) || 'power4.out',
        stagger: (_M.stagger && _M.stagger.loose) || 0.18,
        overwrite: 'auto'
      });
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initScrollingBannerReveal(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'scrolling-banner-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 75%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it, so it could refresh and lock in a stale start/end before
        // sibling pinned sections finish resolving their own pin-spacer
        // heights on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playScrollingBannerReveal(section); },
        onEnterBack: function () { playScrollingBannerReveal(section); }
      });
    }

    document.querySelectorAll('.scrolling-banner').forEach(initScrollingBannerReveal);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('scrolling-banner') ? root : root.querySelector('.scrolling-banner'));
      if (s) { initScrollingBannerReveal(s); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-intro"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    connectedCallback() {
      this.anchor = this.querySelector('a');
      const onClickRef = (e) => {
        e.preventDefault();
        const target = document.querySelector(this.anchor.getAttribute('href'));
        if (!target) return;
        const doScroll = () => target.scrollIntoView({ behavior: 'smooth' });
        if (this.dataset.offset) {
          const offsetEl = document.querySelector(this.dataset.offset);
          if (offsetEl) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offsetEl.offsetHeight, behavior: 'smooth' });
          else doScroll();
        } else doScroll();
        if (target.nodeName.toLowerCase() === 'input') target.focus();
      };
      this.onClickRef = onClickRef;
      this.anchor.addEventListener('click', this.onClickRef);
    }
    disconnectedCallback() {
      this.anchor.removeEventListener('click', this.onClickRef);
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  const initServiceIntroWidth = () => {
    const updateVisualWidth = () => {
      if (window.innerWidth < 768) {
        document.querySelectorAll('.service-intro').forEach((section) => {
          const visualCol = section.querySelector('.service-intro_col--visual');
          if (visualCol) {
            visualCol.style.width = '';
            visualCol.style.marginRight = '';
            visualCol.style.marginLeft = '';
          }
        });
        return;
      }
      const clientWidth = document.documentElement.clientWidth;
      const sections = document.querySelectorAll('.service-intro');
      sections.forEach((section) => {
        const visualCol = section.querySelector('.service-intro_col--visual');
        const colsWrap = section.querySelector('.service-intro_cols-wrap');
        if (!visualCol || !colsWrap) return;

        const position = colsWrap.getAttribute('data-media-position') || 'row-reverse';
        const rect = visualCol.getBoundingClientRect();

        if (position === 'row') {
          const calcWidth = rect.right;
          visualCol.style.width = `${calcWidth}px`;
          visualCol.style.marginLeft = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
          visualCol.style.marginRight = '';
        } else {
          const calcWidth = clientWidth - rect.left;
          visualCol.style.width = `${calcWidth}px`;
          visualCol.style.marginRight = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
          visualCol.style.marginLeft = '';
        }
      });
    };

    updateVisualWidth();
    window.addEventListener('load', updateVisualWidth);
    window.addEventListener('resize', updateVisualWidth);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('service-intro') || event.target.querySelector('.service-intro')) {
        updateVisualWidth();
      }
    });
  };
  initServiceIntroWidth();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-grid"] && !Shopify.designMode) return;
  try {
    
  function servicesGridScrollPriority(el) {
    return -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
  }

  function initServicesGridHeading(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var headingHead = section.querySelector('.services-grid_heading-head');
    if (!headingHead) return;

    var idPrefix = 'sg-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var _M = window.themeMotion || {};
    var tagline = headingHead.querySelector('.services-grid_tagline-text');
    var heading = headingHead.querySelector('.services-grid_heading');
    var description = headingHead.querySelector('.services-grid_description');
    var ctaButton = headingHead.querySelector('.button');

    var headingSplit = window.themeSplitHeading ? window.themeSplitHeading(heading) : { targets: heading, fromVars: {}, toVars: {} };
    var descriptionSplit = window.themeSplitHeading ? window.themeSplitHeading(description) : { targets: description, fromVars: {}, toVars: {} };
    var headSplitActive = headingSplit.targets !== heading;

    var headEls = [].concat(
      tagline || [],
      headingSplit.targets || [],
      descriptionSplit.targets || [],
      ctaButton || []
    );
    if (!headEls.length) return;

    gsap.set(headEls, headingSplit.fromVars);
    gsap.to(headEls, Object.assign({}, headingSplit.toVars, {
      duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
      ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
      stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
      scrollTrigger: {
        id: idPrefix + '-head',
        trigger: headingHead,
        start: (_M.trigger && _M.trigger.start) || 'top 75%',
        end: 'bottom top',
        toggleActions: 'play reverse play reverse',
        refreshPriority: servicesGridScrollPriority(headingHead)
      }
    }));
  }

  function initServicesGridCards(section) {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.innerWidth < 768;
    if (!gsap || !ST || reduceMotion || isMobile) return;
    gsap.registerPlugin(ST);

    var grid = section.querySelector('.services-grid_container');
    if (!grid) return;

    var idPrefix = 'sg-cards-' + section.id;
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (id && id.indexOf(idPrefix) === 0) t.kill();
    });

    var cards = Array.prototype.slice.call(section.querySelectorAll('.services-grid_item'));
    if (!cards.length) return;

    var _M = window.themeMotion || {};
    var _batchStart = (_M.trigger && _M.trigger.start) || 'top 80%';

    ST.batch(cards, {
      interval: 0.1,
      start: _batchStart,
      onEnter: function (batch) {
        gsap.fromTo(batch, { opacity: 0, y: 30 }, {
          opacity: 1,
          y: 0,
          duration: (_M.dur && _M.dur.base) || 0.6,
          ease: (_M.ease && _M.ease.enter) || 'power3.out',
          stagger: 0.1,
          overwrite: 'auto'
        });
      },
      onLeaveBack: function (batch) {
        gsap.set(batch, { opacity: 0, y: 30 });
      }
    });

    if ((_M.flags ? _M.flags.imageHover !== false : true) && window.matchMedia('(pointer: fine)').matches) {
      cards.forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;
        item.addEventListener('mouseenter', function () {
          gsap.to(img, { scale: 1.07, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
        item.addEventListener('mouseleave', function () {
          gsap.to(img, { scale: 1, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.ui) || 'power3.out', overwrite: 'auto' });
        });
      });
    }
  }

  function initAllServicesGrids() {
    document.querySelectorAll('.services-grid').forEach(function (section) {
      initServicesGridHeading(section);
      initServicesGridCards(section);
    });
  }

  if (window.onThemeGsapReady) {
    window.onThemeGsapReady(initAllServicesGrids);
  } else {
    document.addEventListener('DOMContentLoaded', initAllServicesGrids);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('services-grid')
      ? root
      : (root && root.querySelector ? root.querySelector('.services-grid') : null);
    if (!section) return;
    initServicesGridHeading(section);
    initServicesGridCards(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    var section = root && root.classList && root.classList.contains('services-grid')
      ? root
      : (root && root.querySelector ? root.querySelector('.services-grid') : null);
    var ST = window.ScrollTrigger;
    if (!section || !section.id || !ST) return;
    var prefixes = ['sg-' + section.id, 'sg-cards-' + section.id];
    ST.getAll().forEach(function (t) {
      var id = t.vars && t.vars.id;
      if (!id) return;
      for (var i = 0; i < prefixes.length; i++) {
        if (id.indexOf(prefixes[i]) === 0) { t.kill(); break; }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showcase-hotspot"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      ).filter((element) => {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
      });
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code?.toUpperCase() !== 'TAB') return;
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first &&
        !container.contains(event.target)
      )
        return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class SpotDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this._disconnectTimer) {
        clearTimeout(this._disconnectTimer);
        this._disconnectTimer = null;
      }
      // GSAP's pin (needed for ScrollSmoother, see the javascript block below)
      // temporarily detaches/reattaches this element while swapping the pin out
      // to remeasure or rebuilding it on refresh. disconnectedCallback defers
      // its teardown to tell that apart from a real removal — on a transient
      // reparent this element is still fully wired, so skip rewiring it twice.
      if (this._initialized) return;
      this._initialized = true;

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      const doAnimate = (element) => {
        const { frames, options } = this.content.dataset;
        if (!frames || !options) return;
        try {
          element.animate(JSON.parse(frames), JSON.parse(options));
        } catch (e) {
          console.warn('SpotDropdown: Animation data missing or invalid', e);
        }
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(this.dataset.formId);
        const input = this.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const onBodyClick = (event) => { if (!this.contains(event.target)) closeDropdown(); };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const openDropdown = () => {
        // Block manual open while GSAP scroll animation controls this section
        if (this.closest('.showcase-hotspot')?.hasAttribute('data-gsap-controlled')) return;
        // Close every other open spot-dropdown in the same section first
        const section = this.closest('.showcase-hotspot') || this.closest('.section-wrapper');
        if (section) {
          section.querySelectorAll('spot-dropdown').forEach((el) => {
            if (el !== this && el.closeDropdown) el.closeDropdown();
          });
        }
        this.button.setAttribute('aria-expanded', 'true');
        this.content.classList.add('dropdown--open');
        doAnimate(this.content);
        this.content.focus();
        trapFocus(this.content);
        document.body.addEventListener('click', onBodyClick);
        this.addEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.content.classList.remove('dropdown--open');
        trapFocus(null, this.button, false);
        document.body.removeEventListener('click', onBodyClick);
        this.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onToggleClick = () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeDropdown() : openDropdown();
      };
      this.button.addEventListener('click', onToggleClick);
      this._onToggleClick = onToggleClick;
      this._select = select;
      this._closeDropdown = closeDropdown;
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
    disconnectedCallback() {
      // Defer teardown: if this disconnect is just GSAP's pin-spacer reparenting
      // (ScrollSmoother swapping the pin out to remeasure, or rebuilding it on
      // refresh), this element is reconnected again before the timeout fires.
      // Running closeDropdown()'s trapFocus()/.focus() mid-reparent would
      // otherwise itself trigger a ScrollSmoother refresh, which reparents
      // again, recursing until the call stack overflows.
      this._disconnectTimer = setTimeout(() => {
        if (this.isConnected) return;
        this._initialized = false;
        if (this.button && this._onToggleClick) this.button.removeEventListener('click', this._onToggleClick);
        if (this.items && this._select) this.items.forEach((item) => item.removeEventListener('click', this._select));
        if (this._closeDropdown) this._closeDropdown();
      }, 0);
    }
  }
  if (!customElements.get('spot-dropdown')) customElements.define('spot-dropdown', SpotDropdown);
  const initShowcaseHotspotGSAP = () => {
    window.onThemeGsapReady(() => {
      gsap.registerPlugin(ScrollTrigger);

      /* Priority for ScrollTrigger.refresh() ordering among pinned sections, derived
         from this element's live document position instead of a fixed number —
         merchants can reorder sections in the customizer, so a hardcoded priority
         goes stale the moment the order changes. Same formula as
         collection-list.liquid / before-after-content.liquid. */
      const getRefreshPriority = (el) => -(el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));

      /* Section header (tagline/heading/info/description/button) scroll-in reveal —
         same toggleActions pattern as every other section's heading
         (multicolumn.liquid / bundle-products.liquid / image-gallery.liquid), kept
         independent of the desktop-only pin/hotspot timeline below so it still
         reveals normally on mobile, where that timeline never runs. */
      const setupHeadingReveal = (section) => {
        // Always kill any existing mobile heading-reveal trigger for this section first,
        // regardless of current viewport width — calling this on desktop (e.g. the
        // shopify:section:load handler does so unconditionally) must still clean up a
        // stale instance created while the viewport was mobile-width, otherwise it keeps
        // animating the same elements the desktop pinned timeline also drives via scrub.
        const idPrefix = `sh-head-${section.id}`;
        ScrollTrigger.getById(idPrefix)?.kill();

        // On desktop, the pinned timeline handles the staggered entrance & exit of heading elements directly
        if (window.innerWidth >= 768) return;

        const headingHead = section.querySelector('.showcase-hotspot_heading-head');
        if (!headingHead) return;

        const _M = window.themeMotion || {};
        const tagline = headingHead.querySelector('.showcase-hotspot_tagline-text');
        const heading = headingHead.querySelector('.showcase-hotspot_heading');
        const infoText = headingHead.querySelector('.showcase-hotspot_info-text');
        const description = headingHead.querySelector('.showcase-hotspot_description');
        const ctaButton = headingHead.querySelector('.button');

        /* The split is left in place rather than reverted on complete since it
           needs to remain animatable for repeat entries — toggleActions below
           replays this reveal every time the heading scrolls back into view. */
        const headingSplit = window.themeSplitHeading(heading);
        const descriptionSplit = window.themeSplitHeading(description);
        const headSplitActive = headingSplit.targets !== heading;

        const headEls = [].concat(
          tagline || [],
          headingSplit.targets || [],
          infoText || [],
          descriptionSplit.targets || [],
          ctaButton || []
        );
        if (!headEls.length) return;

        const fromVars = Object.assign({}, headingSplit.fromVars);
        delete fromVars.y;
        delete fromVars.yPercent;
        delete fromVars.skewX;
        delete fromVars.rotateX;

        const toVars = Object.assign({}, headingSplit.toVars);
        delete toVars.y;
        delete toVars.yPercent;
        delete toVars.skewX;
        delete toVars.rotateX;

        gsap.set(headEls, fromVars);
        gsap.to(headEls, Object.assign({}, toVars, {
          duration: headSplitActive ? headingSplit.duration : ((_M.dur && _M.dur.base) || 0.7),
          ease: headSplitActive ? headingSplit.ease : ((_M.ease && _M.ease.enter) || 'power3.out'),
          stagger: headSplitActive ? headingSplit.stagger : ((_M.stagger && _M.stagger.base) || 0.1),
          scrollTrigger: {
            id: idPrefix,
            trigger: headingHead,
            start: (_M.trigger && _M.trigger.start) || 'top 75%',
            end: 'bottom top',
            toggleActions: 'play none play none',
            refreshPriority: getRefreshPriority(headingHead)
          }
        }));
      };

      const setupSectionScrollTrigger = (section) => {
        const colsWrap = section.querySelector('.showcase-hotspot_cols-wrap');
        const visualCol = section.querySelector('.showcase-hotspot_col--visual');
        const imageGroups = section.querySelectorAll('.hotspot-image-item');
        if (!colsWrap || !visualCol || imageGroups.length === 0) return;

        const triggerId = `showcase-hotspot-${section.id}`;
        // Kill any ScrollTrigger this section already owns before rebuilding it, so a
        // theme-editor reload of just this section doesn't stack duplicate instances
        ScrollTrigger.getById(triggerId)?.kill();
        if (window.innerWidth < 768) return;

        // Mark section so SpotDropdown blocks manual tooltip opens during scroll control
        section.setAttribute('data-gsap-controlled', '');

        // Step 1: Reset all tooltips to closed state
        imageGroups.forEach((group, index) => {
          const tooltips = group.querySelectorAll('[data-dropdown-content]');
          const togglers = group.querySelectorAll('[data-dropdown-toggler]');

          tooltips.forEach((tooltip) => {
            tooltip.classList.remove('dropdown--open');
            // autoAlpha stays on the tooltip itself — it needs to override the CSS
            // visibility:hidden/opacity:0 baseline (hotspot-item.liquid) for the
            // tooltip to ever become visible; opacity compounds down the tree, so
            // setting it on a child instead leaves the tooltip permanently
            // invisible regardless of the child's own value. scale/y move to the
            // inner wrapper instead, since the tooltip's own transform is reserved
            // for CSS centering (translateX/Y on some tooltip_position values),
            // which a GSAP transform here would overwrite.
            gsap.set(tooltip, { autoAlpha: 0 });
            const animTarget = tooltip.querySelector('[data-dropdown-anim]');
            gsap.set(animTarget, { scale: 0.85, y: 15 });
          });

          togglers.forEach((toggler) => {
            toggler.setAttribute('aria-expanded', 'false');
          });

          if (index === 0) {
            gsap.set(group, { autoAlpha: 1, y: '0%', zIndex: 1 });
          } else {
            gsap.set(group, { autoAlpha: 0, y: '100%', zIndex: index + 1 });
          }
        });

        // How long to hold the pin, in vh — set by Liquid (section markup) based on
        // block count. Read directly rather than duplicating that formula here, so
        // there's one source of truth for the hold duration.
        const holdVh = parseFloat(getComputedStyle(colsWrap).getPropertyValue('--scroll-height')) || 200;

        // Step 2: GSAP pins the whole row — both columns freeze together at top
        // (below header) for the scroll duration, then scrubs the tooltip reveal
        // timeline; the pin doesn't move either column, only the tooltips animate.
        // ScrollSmoother is active on this template (layout/theme.liquid), and
        // native CSS position: sticky doesn't track correctly against its
        // transformed #smooth-content — pin: true is the supported way to freeze
        // an element while ScrollSmoother is active, the same approach
        // collection-list.liquid / before-after-content.liquid already use for
        // their own pinned sections.
        //
        // `end` is relative (+=px) rather than tied to the section's own bottom —
        // GSAP's pin-spacer already reserves colsWrap's natural height plus this
        // duration, so anchoring end to the section's bottom on top of that would
        // count the hold distance twice, leaving a dead scroll gap after release.
        const tl = gsap.timeline({
          scrollTrigger: {
            id: triggerId,
            trigger: colsWrap,
            pin: true,
            anticipatePin: 1,
            refreshPriority: getRefreshPriority(colsWrap),
            // Exclude the sticky header's height so its fixed overlay doesn't
            // cover the top of this section once pinned — same shared helper
            // collection-list.liquid / before-after-content.liquid use, kept as
            // a function so it re-resolves on every refresh instead of needing
            // a separate onRefresh callback to patch self.start after the fact.
            start: () => 'top top+=' + (window.getStickyHeaderOffset ? window.getStickyHeaderOffset() : 0),
            end: () => `+=${(holdVh / 100) * window.innerHeight}`,
            scrub: 1,
            invalidateOnRefresh: true
          }
        });

        // Step 2.5: Staggered entrance animation for heading elements (tagline, heading, info, description, button)
        const headingHead = section.querySelector('.showcase-hotspot_heading-head');
        let headEls = [];
        if (headingHead) {
          const tagline = headingHead.querySelector('.showcase-hotspot_tagline-text');
          const heading = headingHead.querySelector('.showcase-hotspot_heading');
          const infoText = headingHead.querySelector('.showcase-hotspot_info-text');
          const description = headingHead.querySelector('.showcase-hotspot_description');
          const ctaButton = headingHead.querySelector('.button');

          const headingSplit = window.themeSplitHeading(heading);
          const descriptionSplit = window.themeSplitHeading(description);

          headEls = [].concat(
            tagline || [],
            headingSplit.targets || [],
            infoText || [],
            descriptionSplit.targets || [],
            ctaButton || []
          );

          if (headEls.length) {
            tl.fromTo(headEls, 
              Object.assign({}, headingSplit.fromVars, { autoAlpha: 0 }),
              Object.assign({}, headingSplit.toVars, {
                autoAlpha: 1,
                duration: 0.8,
                stagger: 0.15,
                ease: 'power2.out'
              })
            );
          }
        }

        // Initial hold: text is now revealed, hotspots start revealing next
        tl.to({}, { duration: 0.2 });

        // Step 3: Reveal each tooltip one by one as user continues scrolling
        imageGroups.forEach((group, groupIndex) => {
          const tooltips = group.querySelectorAll('[data-dropdown-content]');
          const togglers = group.querySelectorAll('[data-dropdown-toggler]');

          if (groupIndex > 0) {
            const prevGroup = imageGroups[groupIndex - 1];
            tl.to(group, { autoAlpha: 1, y: '0%', duration: 1.2, ease: 'power1.inOut', force3D: true, onStart: () => gsap.set(group, { zIndex: groupIndex + 1 }) });
            tl.to(prevGroup, { autoAlpha: 0, duration: 1, ease: 'power1.inOut', force3D: true }, '<');
          }

          tooltips.forEach((tooltip, tooltipIndex) => {
            const toggler = togglers[tooltipIndex];
            const animTarget = tooltip.querySelector('[data-dropdown-anim]');

            // Fades the tooltip itself (overriding its CSS hidden baseline) while
            // the inner wrapper handles the scale/y "pop in" so the tooltip's own
            // CSS centering transform is never touched
            tl.fromTo(tooltip,
              { autoAlpha: 0 },
              {
                autoAlpha: 1,
                duration: 0.6,
                ease: 'power1.out',
                onStart: () => {
                  tooltip.classList.add('dropdown--open');
                  if (toggler) toggler.setAttribute('aria-expanded', 'true');
                },
                onReverseComplete: () => {
                  tooltip.classList.remove('dropdown--open');
                  if (toggler) toggler.setAttribute('aria-expanded', 'false');
                }
              },
              '+=0.2'
            );
            tl.fromTo(animTarget,
              { scale: 0.85, y: 15 },
              { scale: 1, y: 0, duration: 0.6, ease: 'power1.out', force3D: true },
              '<'
            );
          });
        });

        // Trailing hold: brief pause after final hotspot reveals before unpinning cleanly
        tl.to({}, { duration: 0.2 });
      };

      // Kills this section's ScrollTrigger and clears any GSAP-applied inline styles,
      // restoring the tooltips to their default CSS-driven state
      const teardownSectionScrollTrigger = (section) => {
        section.removeAttribute('data-gsap-controlled');
        ScrollTrigger.getById(`showcase-hotspot-${section.id}`)?.kill();
        ScrollTrigger.getById(`sh-head-${section.id}`)?.kill();
        const headingHead = section.querySelector('.showcase-hotspot_heading-head');
        if (headingHead) gsap.set(headingHead, { clearProps: 'all' });
        section.querySelectorAll('.hotspot-image-item').forEach((group) => {
          gsap.set(group, { clearProps: 'all' });
          group.querySelectorAll('[data-dropdown-content]').forEach((tooltip) => {
            tooltip.classList.remove('dropdown--open');
            gsap.set(tooltip, { clearProps: 'all' });
            const animTarget = tooltip.querySelector('[data-dropdown-anim]');
            if (animTarget) gsap.set(animTarget, { clearProps: 'all' });
          });
        });
      };

      const resetSectionMobile = (section) => {
        teardownSectionScrollTrigger(section);
        const visualCol = section.querySelector('.showcase-hotspot_col--visual');
        if (visualCol) {
          visualCol.style.width = '';
          visualCol.style.marginRight = '';
          visualCol.style.marginLeft = '';
        }
      };

      // Runs BEFORE any pin is created: GSAP's pin-spacer snapshots visualCol's box
      // model (including width) at pin-creation time, so the full-bleed width needs
      // to already be in place — otherwise the spacer locks in the narrower
      // pre-full-bleed width and the pinned column visibly doesn't reach the edge
      const updateVisualWidth = () => {
        if (window.innerWidth < 768) return;
        const clientWidth = document.documentElement.clientWidth;
        const sections = document.querySelectorAll('.showcase-hotspot');
        sections.forEach((section) => {
          const visualCol = section.querySelector('.showcase-hotspot_col--visual');
          const colsWrap = section.querySelector('.showcase-hotspot_cols-wrap');
          if (!visualCol || !colsWrap) return;

          const position = colsWrap.getAttribute('data-media-position') || 'row-reverse';
          const rect = visualCol.getBoundingClientRect();

          if (position === 'row') {
            const calcWidth = rect.right;
            visualCol.style.width = `${calcWidth}px`;
            visualCol.style.marginLeft = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
            visualCol.style.marginRight = '';
          } else {
            const calcWidth = clientWidth - rect.left;
            visualCol.style.width = `${calcWidth}px`;
            visualCol.style.marginRight = `-${calcWidth - (colsWrap.offsetWidth / 2)}px`;
            visualCol.style.marginLeft = '';
          }
        });
      };

      updateVisualWidth();
      window.addEventListener('load', () => {
        updateVisualWidth();
        // Images still loading when the pin/pin-spacer snapshotted visualCol's width
        // above can leave that width stale — refresh ScrollTrigger after the late
        // correction so the pinned column/spacer picks up the corrected dimensions.
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      });
      window.addEventListener('resize', updateVisualWidth);

      // Heading reveal runs on every breakpoint (unlike the pin/hotspot timeline
      // below, which is desktop-only), so it's set up here unconditionally rather
      // than inside the matchMedia handler.
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.querySelectorAll('.showcase-hotspot').forEach(setupHeadingReveal);
      }

      const mm = gsap.matchMedia();

      mm.add({
        isDesktop: '(min-width: 768px)',
        reduceMotion: '(prefers-reduced-motion: reduce)'
      }, (context) => {
        const { isDesktop, reduceMotion } = context.conditions;
        const sections = document.querySelectorAll('.showcase-hotspot');

        if (!isDesktop || reduceMotion) {
          // Covers reduced-motion being toggled on mid-session while still desktop —
          // the (max-width: 767px) branch below only catches the mobile crossing
          sections.forEach(teardownSectionScrollTrigger);
          return;
        }

        sections.forEach(setupSectionScrollTrigger);
      });

      mm.add('(max-width: 767px)', () => {
        document.querySelectorAll('.showcase-hotspot').forEach(resetSectionMobile);
      });

      /* shopify:section:load fires for ANY section reloading in the theme editor, not
         just this one. Reinitializing every showcase-hotspot instance on the page in
         response to an unrelated section edit would kill and rebuild ScrollTriggers
         that had nothing to do with the edit. Scope the reinit to the section that
         actually reloaded. */
      document.addEventListener('shopify:section:load', (event) => {
        const root = event.target;
        const section = root?.classList?.contains('showcase-hotspot')
          ? root
          : root?.querySelector?.('.showcase-hotspot');
        if (!section) return;

        window.onThemeGsapReady(() => {
          const isDesktop = window.matchMedia('(min-width: 768px)').matches;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          updateVisualWidth();
          if (!reduceMotion) setupHeadingReveal(section);
          if (isDesktop && !reduceMotion) {
            setupSectionScrollTrigger(section);
          } else {
            resetSectionMobile(section);
          }
        });
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target;
        const section = root?.classList?.contains('showcase-hotspot')
          ? root
          : root?.querySelector?.('.showcase-hotspot');
        if (!section) return;
        ScrollTrigger.getById(`showcase-hotspot-${section.id}`)?.kill();
        ScrollTrigger.getById(`sh-head-${section.id}`)?.kill();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowcaseHotspotGSAP);
  } else {
    initShowcaseHotspotGSAP();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  /* ── Testimonials entrance ──────────────────────────────────────── */
  window.onThemeGsapReady(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST) return;
    gsap.registerPlugin(ST);

    function playTestimonialsReveal(section) {
      var _M = window.themeMotion || {};
      var headWrap = section.querySelector('[class*="testimonials_heading-head"], [class*="testimonials_head"]');
      var heading  = headWrap && headWrap.querySelector('h2, h3, [class*="testimonials_heading"]');
      var tagline  = headWrap && headWrap.querySelector('[class*="testimonials_tagline"], [class*="tagline"]');
      var desc     = headWrap && headWrap.querySelector('[class*="testimonials_description"], [class*="description"]');
      var cards    = section.querySelectorAll('.testimonials_grid-col, .testimonials_slide');

      var tl = gsap.timeline({ defaults: { overwrite: 'auto' } });

      var headOffset = 0;
      if (tagline) {
        gsap.set(tagline, { opacity: 0, y: 20 });
        tl.to(tagline, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, 0);
        headOffset = 0.15;
      }
      if (heading) {
        var split = window.themeSplitHeading && window.themeSplitHeading(heading);
        if (split && split.targets !== heading) {
          gsap.set(split.targets, split.fromVars);
          tl.to(split.targets, Object.assign({}, split.toVars, {
            duration: split.duration, ease: split.ease, stagger: split.stagger
          }), headOffset);
        } else {
          gsap.set(heading, { opacity: 0, y: 28 });
          tl.to(heading, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.slow) || 1.0, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset);
        }
      }
      if (desc) {
        var descSplit = window.themeSplitHeading && window.themeSplitHeading(desc);
        if (descSplit && descSplit.targets !== desc) {
          gsap.set(descSplit.targets, descSplit.fromVars);
          tl.to(descSplit.targets, Object.assign({}, descSplit.toVars, {
            duration: descSplit.duration, ease: descSplit.ease, stagger: descSplit.stagger
          }), headOffset + 0.2);
        } else {
          gsap.set(desc, { opacity: 0, y: 20 });
          tl.to(desc, { opacity: 1, y: 0, duration: (_M.dur && _M.dur.base) || 0.65, ease: (_M.ease && _M.ease.enter) || 'power4.out' }, headOffset + 0.2);
        }
      }

      if (cards.length && (_M.flags ? _M.flags.staggerCards !== false : true)) {
        gsap.set(cards, { opacity: 0, y: 52, scale: 0.97 });
        tl.to(cards, {
          opacity: 1, y: 0, scale: 1,
          duration: (_M.dur && _M.dur.slow) || 1.0,
          ease: (_M.ease && _M.ease.enter) || 'power4.out',
          stagger: (_M.stagger && _M.stagger.base) || 0.1,
          clearProps: 'scale'
        }, headWrap ? 0.3 : 0);
      }
    }

    /* Gates the reveal behind a ScrollTrigger with onEnter/onEnterBack so it
       replays every time the section scrolls back into view, instead of
       firing once and staying done forever. onEnter also covers the section
       already being in view when the trigger is created. */
    function initTestimonialsSection(section) {
      var _M = window.themeMotion || {};
      var triggerId = 'testimonials-reveal-' + (section.id || 'static');
      ST.getAll().forEach(function (t) {
        if (t.vars && t.vars.id === triggerId) t.kill();
      });
      if (window.innerWidth < 768) return;
      ST.create({
        id: triggerId,
        trigger: section,
        start: (_M.trigger && _M.trigger.start) || 'top 82%',
        end: 'bottom top',
        // Without this, this trigger defaults to refreshPriority 0, which
        // outranks any pinned section's negative (position-derived) priority
        // above it on the page — so it would refresh, and lock in its
        // start/end, before that sibling pinned section finishes resolving
        // its own pin-spacer height on the same refresh pass.
        refreshPriority: window.themeScrollPriority(section),
        onEnter: function () { playTestimonialsReveal(section); },
        onEnterBack: function () { playTestimonialsReveal(section); }
      });

      section.querySelectorAll('.splide__list').forEach(function (list) {
        var revealCloneCards = function () {
          Array.prototype.forEach.call(list.querySelectorAll('[data-slide-clone]'), function (card) {
            gsap.set(card, { opacity: 1, y: 0, scale: 1 });
          });
        };
        revealCloneCards();
        new MutationObserver(revealCloneCards).observe(list, { childList: true });
      });
    }

    document.querySelectorAll('.testimonials').forEach(initTestimonialsSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      var s = root && (root.classList.contains('testimonials') ? root : root.querySelector('.testimonials'));
      if (s) { initTestimonialsSection(s); }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
